/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import classes from "./customers.module.css";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import { withTranslation } from "react-i18next";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Tree } from "@minoru/react-dnd-treeview";
import styles from "./styles.module.css";
import RemoveSelection from "./removeSelection";
import { CustomNode } from "./customNode";
import { CustomDragPreview } from "./customDragPreview";
import Grid from "@mui/material/Grid";
import {
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
} from "@mui/material";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import Breadcrumb from "../../../component/breadcrumb";

import OrderTable from "../orders/orderTable.js";
import BillingAccount from "../reports/billing/billingAccount";
import AssetOwnershipTable from "../reports/asset/assetOwnershipTable";
import SubscriptionsTable from "../subscriptions/subscriptionsTable";
import Profile from "../../pm/customer/profile";
import Loader from "../../../component/loader";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Pagination from "@mui/material/Pagination";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  ExpandAll,
  RefreshIcon,
} from "../../../component/icons/icons.js";
import Input from "../../../component/inputpm";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import AddChildItemDialog from "./addChildItemDialog";
import PaymentDetails from "../../pm/customer/paymentDetails";
import DialogContentText from "@mui/material/DialogContentText";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UriEncode from "../../../component/uriEncode/uriEncode.js";
import AddonsTable from "../addonsManagement/addonsTable.js";
import Drawer from "@mui/material/Drawer";
import { ChevronLeft } from "@mui/icons-material";
import QuoteTable from "../quotes/quoteTable.js";
import { FormControlLabel, Switch, TextField } from "@mui/material";
import ManageCustomerTableView from "./manageCustomerTableView.js";
import Split from "react-split";
import Base64ViewerDialog from "../../../component/fileViewer/index.js";
// import { withStyles } from '@mui/styles';
import { withNavigation } from "../../../helper/withNavigation.js";
import { formatNumber } from "../../../helper/numberFormatter";
import moment from "moment";
import SettlementTable from "../reports/settlement/settlementTable.js";
import {formatDate, convertDateParam, convertTillDateParam, isValidDate } from "../../../helper/dateFormatter.js";
class ManageCustomersHierarchy extends Component {
  // Declare property values that belongs to the component
  state = {
    renderView: false,
    customerList: [],
    customerListProxy: [],
    customerTreeData: [],
    selectedCustomerNodes: [],

    selectedNodes: [],

    // main data
    name: "",
    rowsPerPage: 20,
    page: 1,
    startRecord: 1,
    totalRowsCount: 0,
    tableRowsPerPage: 10,
    tablePage: 1,
    bread: [],

    showChildItem: false,
    childItemDetails: {},
    customerDetails: {},
    profileData: {},
    display: false,
    loading: true,
    initialOpen: true,
    showHierarchy: true,
    tenant:
      this.props.parentTenantId ||
      localStorage.getItem("selectedSalesChannel") ||
      "",
    tenantList: [],

    assetData: [],
    assetDataProxy: [],
    renderBillingView: false,
    invoiceHistoryData: [],

    subscriptionData: [],
    totalSubscriptionCount: 0,
    searchingSubscriptions: true,

    billingData: {},
    totalInvoiceCount: 0,
    searchingBillingData: true,

    subsHistoryPage: 1,
    subsHistoryPerPage: 10,
    subsHistoryStartRecord: 1,
    subscriptionRowsPerPage: 10,
    sortOrderSubs: "DESC",
    sortBySubs: "subscriptionId",
    searchIdentifierValues: [],

    invoiceHistoryPage: 1,
    invoiceHistoryPerPage: 10,
    invoiceHistoryStartRecord: 1,
    sortOrderInvoice: "DESC",
    sortByInvoice: "invoiceDate",

    orderId: "",
    billToCustId: "",

    assetDataPage: 1,
    assetDataPerpage: 10,
    assetDataStartRecord: 1,
    totalAssetCount: 0,
    serialNumber: "",

    eftAccountList: [],
    creditCardList: [],
    billingAddressList: [],

    // invoice payment
    initiatePaymentDialog: false,
    invoiceOrderId: null,
    invoiceId: null,
    invoicePayment: true,
    subscriptionAdjustments: [],
    totalOrderCount: 0,

    enableDnd: false,
    hierarchyLevel: "",

    showMoveItemDialog: false,
    moveItemData: {},
    moveItemMessageText: {},
    err: "",
    manageCustomerRequired: false,

    subsFilters: {
      productName: "",
      subscriptionId: "",
      orderId: "",
    },

    addonsData: [],
    totalAddonsCount: 0,
    addonsRowsPerPage: 10,
    addonsPage: 1,
    addonsStartRecord: 1,
    searchingAddons: true,
    sortByAddons: "nonInventoriedAssetId",
    sortOrderAddons: "DESC",
    addonsFilters: {
      productName: "",
      addonId: "",
      orderId: "",
    },

    ordersData: [],
    totalOrdersCount: 0,
    ordersRowsPerPage: 10,
    ordersPage: 1,
    ordersStartRecord: 1,
    searchingOrders: true,
    sortByOrders: "orderDate",
    sortOrderOrders: "DESC",
    ordersFilters: {
      orderId: "",
      orderDate: "",
      orderStatus: "",
    },

    quotesData: [],
    totalQuotesCount: 0,
    quotesRowsPerPage: 10,
    quotesPage: 1,
    quotesStartRecord: 1,
    searchingQuotes: true,
    sortByQuotes: "createdTxStamp",
    sortOrderQuotes: "DESC",
    quotesFilters: {
      quoteId: "",
      quoteDate: "",
      quoteStatus: "All Quotes",
      quoteType: "",
    },
    showMyCustomers: null,
    initialLoad: true,
    isTaskMode: false,
    taskCustomerId: "",
    taskCustomerTenant: "",
    newLeadOrCustomer: false,

    showBanDialog: false,
    custCodeValue: "",
    selectedToPromote: {},
    showCustomerBanError: false,
    custCodeAvailable: false,

    selectedFileToView: {},
    showFileData: false,
    profileSelectCallback: null,

    // settlement filters and other variables
    settlemtnSortBy: "createdStamp",
    settlementSortOrder: "DESC",
    settlementRowsPerPage: 10,
    settlementStartRecord: 1,
    settlementPage: 1,
    settlementList: [],
    totalSettlementCount: 0,
    searchingSettlements: true,
    solutionProviderName: '',
    itemDescription: '',
    settlementOrderId: '',
    fromDate: "",
    toDate: "",
    today: moment(new Date()).format("yyyy-MM-DD"),
    partnerId: '',
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    console.log("screen", this.props.screen);
    let search = new URLSearchParams(window.location.search);
    var taskCustomerId = search.get("id");
    var taskCustomerTenant = search.get("tenantId");
    var newLead = search.get("newLead");
    var newCustomer = search.get("newCustomer");
    if (taskCustomerId) {
      this.setState({
        isTaskMode: true,
        taskCustomerId: taskCustomerId,
        taskCustomerTenant: taskCustomerTenant,
      });
    }
    let isNewLeadOrCustomer =
      newLead?.toLowerCase() === "y" || newCustomer?.toLowerCase() === "y";
    if (isNewLeadOrCustomer) {
      this.setState({
        newLeadOrCustomer: true,
      });
    }
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    let t = this.props.t;
    let bread = [
      {
        title:
          this.props.screen === "checkout"
            ? t("CHECKOUT") + ": " + t("SELECT_CUSTOMER")
            : t("MANAGE_CUSTOMERS"),
        url: this.props.screen === "checkout" ? "checkout" : "manageCustomers",
      },
    ];
    if (this.props.screen === "manageCustomer") {
      this.setState({
        enableDnd: true,
      });
    }
    if (this.props.screen === "settlementView" && this.props.providerType === "SALES_CHNL_PROVIDER") {
      if (this.props.partnerList && this.props.partnerList.length > 0) {
        this.setState({
          partnerId: this.props.partnerList[0].id
        })
      }
    }
    const storedShowMyCustomers = localStorage.getItem("showMyCustomers");
    const isPMUIScreens =
      this.props.screen === "products" &&
      (this.props.subScreen === "product" ||
        this.props.subScreen === "productsFilter");
    if (isPMUIScreens) {
      this.setState({
        showMyCustomers: false,
      });
    } else if (storedShowMyCustomers !== null) {
      this.setState({
        showMyCustomers:
          storedShowMyCustomers === "true"
            ? true
            : storedShowMyCustomers === "false"
              ? false
              : this.props.showMyCustomersEnabled === true,
      });
    } else if (this.props.screen === "settlementView" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
      this.setState({
        showMyCustomers: false
      })
    } else {
      this.setState({
        showMyCustomers: this.props.showMyCustomersEnabled === true,
      });
    }
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_PARTY_CONFIGS/endpoint`,
      {},
    ).then((res) => {
      let isManagedRequired = res.data["party.managed.enabled"]
        ? res.data["party.managed.enabled"]
        : "true";
      this.setState({
        manageCustomerRequired: isManagedRequired,
      });
    });
    // Initial data handlelling
    var selectedTreeItemsInitial = [];
    if (this.props.selectedTreeItems) {
      selectedTreeItemsInitial = this.props.selectedTreeItems;
    } else {
      let storageData = {};
      if (this.props.screen === "manageCustomer") {
        if (this.props.screenType && this.props.screenType === "leads") {
          storageData = JSON.parse(
            localStorage.getItem("manageLeadsHierarchy"),
          );
        } else {
          storageData = JSON.parse(
            localStorage.getItem("manageCustomerHierarchy"),
          );
        }
      } else if (this.props.screen === "assetOwner") {
        storageData = JSON.parse(localStorage.getItem("assetOwnerHierarchy"));
      } else if (this.props.screen === "billing") {
        storageData = JSON.parse(localStorage.getItem("billingHierarchy"));
      } else if (this.props.screen === "subscriptions") {
        storageData = JSON.parse(
          localStorage.getItem("subscriptionsHierarchy"),
        );
      } else if (this.props.screen === "addonsManagement") {
        storageData = JSON.parse(localStorage.getItem("addonsManagement"));
      } else if (this.props.screen === "orders") {
        storageData = JSON.parse(localStorage.getItem("orders"));
      } else if (this.props.screen === "quotes") {
        storageData = JSON.parse(localStorage.getItem("quotes"));
      } else if (this.props.screen === "settlementView") {
        storageData = null;
      } else {
        storageData = null;
      }

      if (storageData) {
        selectedTreeItemsInitial = storageData.selectedTreeItems
          ? storageData.selectedTreeItems
          : [];
        this.setState({
          page: storageData.pageData.page,
          startRecord: storageData.pageData.startRecord,
          rowsPerPage: storageData.pageData.rowsPerPage,

          name: this.props.newAddedAccountName
            ? this.props.newAddedAccountName
            : storageData.searchData.name,
          // showMyCustomers: this.props.newAddedAccountName ? false : null,
        });
      }
    }

    this.setState(
      {
        bread,
        selectedCustomerNodes: selectedTreeItemsInitial,
        orderId: this.props.orderId,
        partyId: this.props.userId,
      },
      () => {
        if (this.props.providerType === "SOLUTION_PROVIDER" || (this.props.tenantRoles.includes("MASTER_PROVIDER") && this.props.screen === 'settlementView')) {
          BusApiCall(
            "POST",
            `${constants.busInternalUrl}/passthru/GET_CHILD_TENANT_LIST/endpoint`,
            {},
          )
            .then((res) => {
              let list = res.data.tenants;
              var selectedSalesChannel = localStorage.getItem(
                "selectedSalesChannel",
              );
              this.setState(
                {
                  tenantList: list,
                  tenant:
                    this.props.parentTenantId ||
                    selectedSalesChannel ||
                    (list && list.length > 0 ? list[0].tenantId : ""),
                },
                () => {
                  localStorage.setItem(
                    "selectedSalesChannel",
                    this.state.tenant,
                  );
                  this.getCustomersHierarchy();
                },
              );
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
            });
        } else {
          this.checkOrderForInvoice();
          this.getCustomersHierarchy();
        }
      },
    );
    // Initial data handelling end
  }
  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  setProfileSelectCallback = (callback) => {
    this.profileSelectCallback = callback;
    if (this.props.setSelectCallback) {
      this.props.setSelectCallback(callback);
    }
  };

  getCustomersHierarchy = () => {
    this.setState({
      renderView: false,
      loading: true,
    });
    let partyId = "";
    if (
      this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
      this.props.loggedInUserType === "ECOMMERCE_ADMIN"
    ) {
      partyId = this.props.ecommerceCustData.partyId;
    } else if (
      this.state.billToCustId !== "" &&
      this.state.billToCustId !== undefined
    ) {
      partyId = this.state.billToCustId;
    } else if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      this.props.solutionList.length > 0
    ) {
      partyId = this.props.solutionList[0].providerId;
    } else if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      (this.props.screen === "billing" ||
        this.props.screen === "assetOwner" ||
        this.props.screen === "subscriptions" ||
        this.props.screen === "addonsManagement")
    ) {
      partyId = this.state.tenant;
    } else {
      partyId = this.props.providerId;
    }
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    this.updateLocalStorage();
    let ban = "";
    // let spBan = localStorage.getItem('selectedPromoBan');
    // if (this.props.screen === 'checkout' && spBan) {
    //     ban = spBan;
    // }
    if (this.props.screen === "billing" && this.props.userId) {
      ban = this.props.userId;
    }
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      (this.props.screen === "billing" ||
        this.props.screen === "assetOwner" ||
        this.props.screen === "subscriptions" ||
        this.props.screen === "checkout" ||
        this.props.screen === "addonsManagement" ||
        this.props.screen === "orders" ||
        window.location.pathname === "/manageCustomers" ||
        window.location.pathname === "/manageLeads" ||
        this.props.screen === "settlementView")
    ) {
      jsonData.tenantId = this.state.tenant;
    }
    var level = "";
    if (
      this.props.screen === "billing" ||
      this.props.screen === "products" ||
      this.props.screen === "createOffering" ||
      this.props.screen === "settlementView"
    ) {
      if (this.props.subScreen === "oldOfferingFilter") {
        this.setState({
          initialOpen: true,
        });
        ban = this.props.offeringBan;
      } else {
        level = 1;
        this.setState({
          hierarchyLevel: 1,
        });
      }
    }
    if (this.state.taskCustomerTenant) {
      jsonData.tenantId = this.state.taskCustomerTenant;
    }
    if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.screen === "settlementView" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
      jsonData.tenantId = this.state.tenant;
    }
    var searchLeadId = null;
    if (this.props.router && this.props.router.location.pathname === "/manageLeads") {
      var searchParams = new URLSearchParams(window.location.search);
      searchLeadId = searchParams.get('leadId');
    }
    var url = ``;
    if (this.state.isTaskMode) {
      url = `${constants.busV4Url}/parties/${this.props.providerType === "SOLUTION_PROVIDER" ? this.state.taskCustomerTenant : partyId}/hierarchy?name=${this.state.name}&ban=${ban}&level=${level}&customerPartyIds=${this.props.router && this.props.router.location.pathname === "/manageLeads" ? searchLeadId ? searchLeadId : '' : this.state.taskCustomerId}&showMyCustomers=${false}&showLeads=${this.props.router && this.props.router.location.pathname === "/manageLeads" ? true : false}`;
    } else {
      url = `${constants.busV4Url}/parties/${this.props.providerType === "SOLUTION_PROVIDER" || (this.props.tenantRoles.includes("MASTER_PROVIDER") && this.props.screen === 'settlementView') ? this.state.tenant : partyId}/hierarchy?name=${this.state.name}&ban=${ban}&level=${level}&customerPartyIds=${this.props.router && this.props.router.location.pathname === "/manageLeads" ? searchLeadId ? searchLeadId : '' : this.props.offeringCustomer && this.props.offeringCustomer.length > 0 ? this.props.offeringCustomer.join() : ""}&showMyCustomers=${this.props.showMyCustomersEnabled ? this.state.showMyCustomers : false}&showLeads=${this.props.router && this.props.router.location.pathname === "/manageLeads" ? true : false}`;
    }
    // Get customers list
    BusApiCall("GET", url, jsonData, pageOptions)
      .then((res) => {
        if (
          res.data.customers.length === 0 &&
          this.state.showMyCustomers &&
          this.state.initialLoad
        ) {
          this.setState(
            {
              showMyCustomers: false,
              initialLoad: false,
            },
            () => {
              this.getCustomersHierarchy();
            },
          );
          return;
        }
        if (res.data.customers.length > 0) {
          var allCustomers = res.data.customers;
          var defualtSelectedCustomer = {};
          var selectedCustomerPartyId = "";
          var defualtSelectedChild = {};
          var showChildItem = false;
          if (searchLeadId) {
            var customerName = res.data.customers[0].accountName;
            this.setState({
              name: customerName
            })
          }

          var selectedCustomerNodes = [...this.state.selectedCustomerNodes];
          if (selectedCustomerNodes.length > 0) {
            var index = res.data.customers.findIndex(
              (x) => x.partyId === selectedCustomerNodes[0].id,
            );
            if (index > -1) {
              if (allCustomers[index].ban) {
                showChildItem = false;
                defualtSelectedCustomer = allCustomers[index];
                selectedCustomerPartyId = allCustomers[index].partyId;
              } else {
                showChildItem = true;
                defualtSelectedChild = allCustomers[index];
                let path = defualtSelectedChild.path.split("/");
                if (this.state.initialOpen === true) {
                } else {
                  this.setState({
                    initialOpen: path,
                  });
                }
                var parentIndex = allCustomers.findIndex(
                  (x) => x.partyId === path[1],
                );
                defualtSelectedCustomer = allCustomers[parentIndex];
              }
            } else {
              defualtSelectedCustomer = allCustomers[0];
              selectedCustomerPartyId = allCustomers[0].partyId;
            }
          } else {
            defualtSelectedCustomer = allCustomers[0];
            selectedCustomerPartyId = allCustomers[0].partyId;
          }
          if (this.props.screen === "checkout") {
            this.setState({
              initialOpen: [res.data.customers[0].partyId],
            });
          }
          this.setState(
            {
              customerList: JSON.parse(JSON.stringify(res.data.customers)),
              customerListProxy: JSON.parse(JSON.stringify(res.data.customers)),
              totalCount: +res.headers["x-total-count"],
              totalRowsCount: +res.headers["x-total-count"],
              customerDetails: defualtSelectedCustomer,
              childItemDetails: defualtSelectedChild,
              showChildItem: showChildItem,
            },
            () => {
              this.createCustomerTreeData();
              // if (this.props.screen === 'billing') {
              //     this.getBillingDetails(defualtSelectedCustomer.partyId);
              //     this.getSubscriptionAdjustments(defualtSelectedCustomer.partyId);
              // }
              if (showChildItem) {
                this.handleSelectCustomer(false, defualtSelectedChild);
                // if (this.props.screen === 'subscriptions') {
                //     this.getCustomerSubscriptions(defualtSelectedChild.partyId);
                // }
                // if (this.props.screen === 'assetOwner') {
                //     this.getAssetDetails(defualtSelectedChild.partyId);
                // }
              } else {
                this.handleSelectCustomer(false, defualtSelectedCustomer);
                // if (this.props.screen === 'subscriptions') {
                //     this.getCustomerSubscriptions(defualtSelectedCustomer.partyId);
                // }
                // if (this.props.screen === 'assetOwner') {
                //     this.getAssetDetails(defualtSelectedCustomer.partyId);
                // }
              }
            },
          );
        } else {
          // If no customer found
          this.setState({
            customerList: [],
            customerListProxy: [],
            customerTreeData: [],
            totalCount: 0,
            totalRowsCount: 0,
            renderView: true,
            loading: false,
          });
          if (
            this.props.screen === "checkout" &&
            this.props.subScreen === "product"
          ) {
            this.props.setErrorMessage(
              this.props.t("NO_CUSTOMERS_FOUND"),
              false,
            );
            // setTimeout(() => {
            //     if (this.props.closeDialog) this.props.closeDialog();
            //   }, 3000);
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          initialLoad: false,
        });
      });
  };

  createCustomerTreeData = () => {
    this.setState({ loading: true });
    const tempTreeData = this.state.customerList.map((item) => {
      if (item.level === 1) {
        return { ...item, parent: 0, droppable: true, id: item.partyId };
      } else {
        return {
          ...item,
          parent: item.parentId,
          droppable: item.isGroup,
          id: item.partyId,
          accountName: item.accountName ? item.accountName : item.name,
        };
      }
    });
    this.setState(
      {
        customerTreeData: tempTreeData,
        renderView: true,
      },
      () => {
        if (
          this.props.screen === "manageCustomer" ||
          this.props.screen === "checkout" ||
          this.props.screen === "products"
        ) {
          this.setState({
            loading: false,
          });
        }
      },
    );
  };

  handleDrop = (
    newTree,
    { dragSourceId, dropTargetId, dragSource, dropTarget },
  ) => {
    this.props.setErrorMessage("");
    const tempTree = this.state.treeData.map((data) => {
      var item = this.state.selectedNodes.find((n) => n.id === data.id);
      if (item) {
        return { ...item, parent: dropTargetId };
      } else {
        return data;
      }
    });

    this.setState({
      treeData: tempTree,
      selectedNodes: [],
    });
  };

  handleDropCustomer = (
    newTree,
    { dragSourceId, dropTargetId, dragSource, dropTarget },
  ) => {
    this.props.setErrorMessage("");
    this.setState({
      moveItemData: { dragSourceId, dropTargetId, dragSource, dropTarget },
      moveItemMessageText: {
        name: dragSource.accountName,
        oldParentName:
          dragSource.canonicalName.split("/")[
          dragSource.canonicalName.split("/").length - 2
          ],
        newParentName: dropTarget.accountName,
      },
      showMoveItemDialog: true,
    });
  };

  moveItem = (val) => {
    if (val) {
      var dragSourceId = this.state.moveItemData.dragSourceId;
      var dropTargetId = this.state.moveItemData.dropTargetId;
      var dragSource = this.state.moveItemData.dragSource;
      var dropTarget = this.state.moveItemData.dropTarget;
      if (dragSource && dragSource.ban) {
        // Move organization/customer is not allowed
        this.props.setErrorMessage(
          this.props.t("MOVE_OUTSIDE_CUSTOMER"),
          false,
        );
        this.setState({
          showMoveItemDialog: false,
          moveItemData: {},
          moveItemMessageText: {},
        });
      } else {
        var dragSourcePath = dragSource.path.split("/");
        var dropTargetPath = dropTarget.path.split("/");
        if (dragSourcePath[1] === dropTargetPath[1]) {
          if (dragSourceId && dropTargetId) {
            this.setState({
              loading: true,
            });
            BusApiCall(
              "GET",
              `${constants.busV4Url}/myProfile?customerId=${dragSourceId}`,
            )
              .then((res) => {
                var data = res.data;
                var payload = {};
                if (data.partyType === "LOCATION") {
                  payload = {
                    partyId: data.partyId ? data.partyId : "",
                    isGroup: data.isGroup ? data.isGroup : "",
                    partyName: data.accountName ? data.accountName : "",
                    userName: data.username ? data.username : "",
                    partyType: data.partyType,
                    parentPartyId: dropTargetId,
                    locationDetails: {
                      description: data.locationDetails.description
                        ? data.locationDetails.description
                        : "",
                      identifier: data.locationDetails.identifier
                        ? data.locationDetails.identifier
                        : "",
                      positioning: data.locationDetails.positioning
                        ? data.locationDetails.positioning
                        : "",
                    },
                  };
                } else {
                  payload = {
                    partyId: data.partyId ? data.partyId : "",
                    isGroup: data.isGroup ? data.isGroup : "",
                    partyName: data.accountName ? data.accountName : "",
                    userName: data.username ? data.username : "",
                    partyType: data.partyType,
                    contact: {
                      firstName: data.firstName ? data.firstName : "",
                      lastName: data.lastName ? data.lastName : "",
                      email: data.email ? data.email : "",
                      phone: data.officePhone ? data.officePhone : "",
                      emailMechId: data.emailMechId ? data.emailMechId : "",
                      phoneMechId: data.officePhoneMechId
                        ? data.officePhoneMechId
                        : "",
                    },
                    parentPartyId: dropTargetId,
                  };
                  if (data.shipping && data.shipping.length > 0) {
                    payload.shipping = {
                      mechId: data.shipping[0].postalMechId,
                      addressLine1: data.shipping[0].street1,
                      addressLine2: data.shipping[0].street2,
                      city: data.shipping[0].city,
                      state: data.shipping[0].state,
                      zipCode: data.shipping[0].zip,
                      country: data.shipping[0].country,
                    };
                  } else {
                    payload.shipping = {
                      mechId: "",
                      addressLine1: "",
                      addressLine2: "",
                      city: "",
                      state: "",
                      zipCode: "",
                      country: this.props.defaultCountry,
                    };
                  }
                }
                var messageData = {
                  name: dragSource.accountName,
                  oldParentName:
                    dragSource.canonicalName.split("/")[
                    dragSource.canonicalName.split("/").length - 2
                    ],
                  newParentName: dropTarget.accountName,
                };
                console.log("check final payload", payload);
                // BusApiCall('PUT', `${constants.busV4Url}/parties`, payload).then(res => {
                //     this.setState({
                //         showMoveItemDialog: false,
                //         moveItemData: {},
                //         moveItemMessageText: {}
                //     })
                //     this.props.setErrorMessage(this.props.t('ITEM_MOVED_SUCCESSFULLY', { messageData }), true)
                //     this.getCustomersHierarchy();
                // }).catch(err => {
                //     this.setState({
                //         showMoveItemDialog: false,
                //         moveItemData: {},
                //         moveItemMessageText: {}
                //     })
                //     if (err.response && err.response.data && err.response.data.message) {
                //         this.props.setErrorMessage(err.response.data.message, false)
                //     } else {
                //         this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
                //     }
                //     this.setState({ loading: false })
                // })
              })
              .catch((err) => {
                this.setState({
                  showMoveItemDialog: false,
                  moveItemData: {},
                  moveItemMessageText: {},
                });
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({ loading: false });
              });
          }
        } else {
          // Move outside the organization/customer
          var data = {
            name: dragSource.accountName,
            parentName: dragSource.canonicalName.split("/")[1],
          };
          this.props.setErrorMessage(
            this.props.t("MOVE_OUTSIDE_CUSTOMER_ERROR", { data }),
            false,
          );
          this.setState({
            showMoveItemDialog: false,
            moveItemData: {},
            moveItemMessageText: {},
          });
        }
      }
    } else {
      this.setState({
        showMoveItemDialog: false,
        moveItemData: {},
        moveItemMessageText: {},
      });
    }

    // const tempTree = this.state.customerTreeData.map((data) => {
    //     var item = this.state.selectedCustomerNodes.find((n) => n.id === data.id);
    //     if (item) {
    //         return { ...item, parent: dropTargetId };
    //     } else {
    //         if (data.id === dropTargetId) {
    //             return { ...data, hasChildren: true };
    //         } else {
    //             return data;
    //         }
    //     }
    // });
    // console.log('check updated data', tempTree);
    // this.setState({
    //     customerTreeData: tempTree,
    //     selectedCustomerNodes: [],
    //     renderView: false
    // }, () => {
    //     this.setState({
    //         renderView: true
    //     })
    // })
  };

  deSelect = () => {
    this.setState({
      selectedNodes: [],
    });
  };

  deSelectCustomer = () => {
    this.setState({
      selectedCustomerNodes: [],
    });
  };

  handleSelectMouseDown = (isShiftKey, node) => {
    const item = this.state.selectedNodes.find((n) => n.id === node.id);

    if (!item && !isShiftKey) {
      this.setState({
        selectedNodes: [node],
      });
    } else if (!item && isShiftKey) {
      this.setState({
        selectedNodes: [...this.state.selectedNodes],
      });
    }
  };

  handleSelectMouseDownCustomer = (isShiftKey, node) => {
    const item = this.state.selectedCustomerNodes.find((n) => n.id === node.id);

    if (!item && !isShiftKey) {
      this.setState({
        selectedCustomerNodes: [node],
      });
    } else if (!item && isShiftKey) {
      this.setState({
        selectedCustomerNodes: [...this.state.selectedCustomerNodes],
      });
    }
  };

  handleSelect = (isShiftKey, node) => {
    const item = this.state.selectedNodes.find((n) => n.id === node.id);

    if (this.state.selectedNodes.length === 0) {
      this.setState({
        selectedNodes: [node],
      });
    } else if (!item && isShiftKey) {
      this.setState({
        selectedNodes: [...this.state.selectedNodes, node],
      });
    } else if (item && isShiftKey) {
      this.setState({
        selectedNodes: this.state.selectedNodes.filter((n) => n.id !== node.id),
      });
    } else if (item && !isShiftKey) {
      this.setState({
        selectedNodes: [node],
      });
    } else {
      this.setState({
        selectedNodes: [node],
      });
    }
  };

  handleSelectCustomer = (isShiftKey, node) => {
    this.setState({
      subsHistoryPage: 1,
      subsHistoryStartRecord: 1,
    });
    if (this.props.screen === "checkout") {
      this.props.resetSelecteddata();
    }
    const item = this.state.selectedCustomerNodes.find((n) => n.id === node.id);

    if (this.state.selectedCustomerNodes.length === 0) {
      this.setState({
        selectedCustomerNodes: [node],
      });
    } else if (!item && isShiftKey) {
      this.setState({
        selectedCustomerNodes: [...this.state.selectedCustomerNodes, node],
      });
    } else if (item && isShiftKey) {
      this.setState({
        selectedCustomerNodes: this.state.selectedCustomerNodes.filter(
          (n) => n.id !== node.id,
        ),
      });
    } else if (item && !isShiftKey) {
      this.setState({
        selectedCustomerNodes: [node],
      });
    } else {
      this.setState({
        selectedCustomerNodes: [node],
      });
    }
    if (this.props.screen === "billing") {
      // this.getBillingDetails(node.partyId);
      this.setState({
        loading: true,
        subscriptionData: [],
        billingData: [],
        renderBillingView: false,
        invoiceHistoryData: [],
      });

      var jsonData = {
        partyId: node.partyId,
      };
      this.getCustomerInvoiceAndAdjustmentsOnChange(node.partyId);
      // this.getCustomerInvoice(jsonData);
      // this.getSubscriptionAdjustments(node.partyId);
    }
    this.updateLocalStorage();
    if (node.ban) {
      this.setState(
        {
          customerDetails: node,
          selectedCustomerPartyId: node.partyId,
          display: false,
          showChildItem: false,
          childItemDetails: {},
        },
        () => {
          if (this.props.screen === "subscriptions") {
            this.getCustomerSubscriptions(node.partyId);
          }
          if (this.props.screen === "addonsManagement") {
            this.getCustomerAddons(node.partyId);
          }
          if (this.props.screen === "assetOwner") {
            this.getAssetDetails(node.partyId);
          }
          if (this.props.screen === "orders") {
            // this.getCustomerOrders(node.ban);
            this.getCustomerOrders(node.partyId);
          }
          if (this.props.screen === "settlementView") {
            this.getCustomerSettlements(node.partyId);
          }
          if (this.props.screen === "quotes") {
            // this.getCustomerQuotes(node.ban);
            this.getCustomerQuotes(node.partyId);
          }
          this.setState({
            display: true,
          });
        },
      );
    } else {
      let parentId = node.path.split("/")[1];
      let parentCustomerData = this.state.customerList.find(
        (x) => x.id === parentId,
      );
      this.setState(
        {
          customerDetails: parentCustomerData,
          childItemDetails: node,
          selectedCustomerPartyId: node.partyId,
          display: false,
          showChildItem: true,
        },
        () => {
          if (this.props.screen === "subscriptions") {
            this.getCustomerSubscriptions(node.partyId);
          }
          if (this.props.screen === "addonsManagement") {
            this.getCustomerAddons(node.partyId);
          }
          if (this.props.screen === "assetOwner") {
            this.getAssetDetails(node.partyId);
          }
          if (this.props.screen === "orders") {
            // this.getCustomerOrders(parentCustomerData.ban);
            this.getCustomerOrders(node.partyId);
          }
          if (this.props.screen === "settlementView") {
            this.getCustomerSettlements(node.partyId);
          }
          if (this.props.screen === "quotes") {
            // this.getCustomerQuotes(parentCustomerData.ban);
            this.getCustomerQuotes(node.partyId);
          }
          this.setState({
            display: true,
          });
        },
      );
    }
  };

  // additional methods
  updateLocalStorage = () => {
    let data = {
      selectedTreeItems: this.state.selectedCustomerNodes,
      searchData: {
        name: this.state.name,
      },
      pageData: {
        page: this.state.page,
        startRecord: this.state.startRecord,
        rowsPerPage: this.state.rowsPerPage,
      },
    };

    if (this.props.screen === "manageCustomer") {
      if (this.props.screenType && this.props.screenType === "leads") {
        localStorage.setItem("manageLeadsHierarchy", JSON.stringify(data));
      } else {
        localStorage.setItem("manageCustomerHierarchy", JSON.stringify(data));
      }
    } else if (this.props.screen === "assetOwner") {
      localStorage.setItem("assetOwnerHierarchy", JSON.stringify(data));
    } else if (this.props.screen === "billing") {
      localStorage.setItem("billingHierarchy", JSON.stringify(data));
    } else if (this.props.screen === "subscriptions") {
      localStorage.setItem("subscriptionsHierarchy", JSON.stringify(data));
    } else if (this.props.screen === "addonsManagement") {
      localStorage.setItem("addonsManagement", JSON.stringify(data));
    }
  };

  getMyProfile = (data) => {
    this.setState({
      loading: true,
    });
    let creditCardList = [];
    let eftAccountList = [];

    BusApiCall(
      "GET",
      `${constants.busV4Url}/myProfile?customerId=${data.partyId}`,
    ).then((res) => {
      this.setState({ billingAddressList: res.data.billing });
      res.data.paymentMethods.map((method, i) => {
        if (method.routingNumber) {
          eftAccountList.push({ ...method });
        } else if (method.cardNumber) {
          creditCardList.push({ ...method });
        }
      });

      this.setState(
        {
          profileData: res.data,
          eftAccountList: eftAccountList,
          creditCardList: creditCardList,
          display: false,
        },
        () => {
          this.setState({ display: true, loading: false });
        },
      );
    });
  };

  getAssetDetails = (partyId) => {
    this.setState({
      assetData: [],
      assetDataProxy: [],
      loading: true,
    });

    let pageOptions = {
      batchSize: this.state.assetDataPerpage,
      startRecord: this.state.assetDataStartRecord,
    };

    var jsonData = {
      partyId: partyId,
      serialNumber: this.state.serialNumber,
    };

    let data = {};
    if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      (this.props.screen === "billing" ||
        this.props.screen === "assetOwner" ||
        this.props.screen === "subscriptions")
    ) {
      data.tenantId = this.state.tenant;
    }

    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/reports?reportType=ASSET_OWNERSHIP&jsonData=${JSON.stringify(jsonData)}`,
      data,
      pageOptions,
    )
      .then((res) => {
        this.setState({
          assetDataProxy: res.data.assetOwnershipReport.assetOwnershipList,
          totalAssetCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  openAssetData = (index) => {
    var list = [...this.state.assetDataProxy];
    var item = list[index];
    var payload = {
      orderId: item.orderId,
      serialNumber: item.serialNumber,
    };
    if (item.childProducts && item.childProducts.length > 0) {
      if (list[index].expand) {
        list[index].expand = false;
      } else {
        list[index].expand = true;
      }
      this.setState({
        assetDataProxy: list,
      });
    } else {
      this.setState({ loading: true });
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/GET_ASSEMBLY_DETAILS/endpoint`,
        payload,
      )
        .then((res) => {
          if (
            res.data.componentList &&
            res.data.componentList.length > 0 &&
            res.data.componentList[0].subProducts
          ) {
            list[index].childProducts = res.data.componentList[0].subProducts;
            list[index].expand = true;
            this.setState({
              loading: false,
              assetDataProxy: list,
            });
          } else {
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  };

  getBillingDetails = (partyId) => {
    this.setState({
      loading: true,
      subscriptionData: [],
      billingData: [],
      renderBillingView: false,
      invoiceHistoryData: [],
    });

    var jsonData = {
      partyId: partyId,
    };
    this.getCustomerInvoice(jsonData);
  };

  toBase64Json(obj) {
    const json = JSON.stringify(obj);
    return btoa(unescape(encodeURIComponent(json)));
  }

  getCustomerSubscriptions = (jsonData) => {
    if (this.state.customerDetails.partyId) {
      let pageOptions = {
        batchSize: this.state.subsHistoryPerPage,
        startRecord: this.state.subsHistoryStartRecord,
      };

      let filter = "&orderId=";
      if (this.state.orderId !== null && this.state.orderId !== "") {
        filter = filter + this.state.orderId;
      }

      let data = {};
      if (
        this.props.providerType === "SOLUTION_PROVIDER" &&
        (this.props.screen === "billing" ||
          this.props.screen === "assetOwner" ||
          this.props.screen === "subscriptions")
      ) {
        data.tenantId = this.state.tenant;
      }

      let encodedSearchIdentifierValues = '';
      if (Array.isArray(this.state.searchIdentifierValues) && this.state.searchIdentifierValues.length > 0) {
        encodedSearchIdentifierValues = this.toBase64Json(this.state.searchIdentifierValues);
      }
      this.setState({
        loading: true,
        subscriptionData: [],
        searchingSubscriptions: true,
      });
      BusApiCall('GET', `${constants.busV4Url}/customers/${UriEncode(this.state.customerDetails.ban)}/client/${jsonData.partyId ? jsonData.partyId : jsonData}/subscriptions?sortBy=${this.state.sortBySubs}&sortOrder=${this.state.sortOrderSubs}&productName=${this.state.subsFilters.productName}&subscriptionId=${this.state.subsFilters.subscriptionId}&orderId=${this.state.subsFilters.orderId}&jsonData=${encodedSearchIdentifierValues}`, data, pageOptions).then(res => {
        this.setState({
          subscriptionData: res.data.subscriptions || [],

          totalSubscriptionCount: +res.headers["x-total-count"],
          loading: false,
          searchingSubscriptions: false,
        });
        // this.setState({
        //     subscriptionData: res.data,
        //     totalSubscriptionCount: +res.headers['x-total-count'],

        // }, () => {
        //     this.setState({
        //         renderBillingView: true,
        //         loading: false,
        //     })
        // });
      })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, searchingSubscriptions: false });
        });
    } else {
      setTimeout(() => {
        this.getCustomerSubscriptions(jsonData);
      }, 2000);
    }
  };

  getCustomerQuotes = (jsonData) => {
    if (this.state.customerDetails.partyId) {
      let pageOptions = {
        batchSize: this.state.quotesRowsPerPage,
        startRecord: this.state.quotesStartRecord,
      };

      let data = {};
      this.setState({ loading: true, quotesData: [], searchingQuotes: true });

      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/quotes?sortBy=${this.state.sortByQuotes}&sortOrder=${this.state.sortOrderQuotes}&id=${this.state.quotesFilters.quoteId}&state=${encodeURIComponent(this.state.quotesFilters.quoteStatus ? (this.state.quotesFilters.quoteStatus === "All Quotes" ? "" : this.state.quotesFilters.quoteStatus) : "")}&partyId=${jsonData && jsonData.partyId ? jsonData.partyId : jsonData}&type=${encodeURIComponent(this.state.quotesFilters.quoteType && this.state.quotesFilters.quoteType === "All Quotes" ? "" : this.state.quotesFilters.quoteType)}`,
        data,
        pageOptions,
      )
        .then((res) => {
          this.setState({
            quotesData: res.data,
            totalQuotesCount: +res.headers["x-total-count"],
            loading: false,
            searchingQuotes: false,
          });
          // console.log('get quotes by customer res.data +++++++++++++++++++', res.data)
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, searchingQuotes: false });
        });
    } else {
      setTimeout(() => {
        this.getCustomerQuotes(jsonData);
      }, 2000);
    }
  };

  getCustomerOrders = (jsonData) => {
    if (this.state.customerDetails.partyId) {
      let pageOptions = {
        batchSize: this.state.ordersRowsPerPage,
        startRecord: this.state.ordersStartRecord,
      };

      let data = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        data.tenantId = this.props.parentTenantId;
      }
      this.setState({ loading: true, ordersData: [], searchingOrders: true });

      BusApiCall(
        "GET",
        `${constants.busV4Url}/orders?sortBy=${this.state.sortByOrders}&sortOrder=${this.state.sortOrderOrders}&orderId=${this.state.ordersFilters.orderId}&orderStatus=${UriEncode(this.state.ordersFilters.orderStatus)}&partyId=${encodeURIComponent(jsonData && jsonData.partyId ? jsonData.partyId : jsonData)}`,
        data,
        pageOptions,
      )
        .then((res) => {
          this.setState({
            ordersData: res.data,
            totalOrdersCount: +res.headers["x-total-count"],
            loading: false,
            searchingOrders: false,
          });
          // console.log('get orders by customer res.data +++++++++++++++++++', res.data)
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, searchingOrders: false });
        });
    } else {
      setTimeout(() => {
        this.getCustomerOrders(jsonData);
      }, 2000);
    }
  };

  getCustomerSettlements = () => {
    if (this.state.customerDetails.partyId) {
      this.setState({
        loading: true,
        searchingSettlements: true
      });
      let pageOptions = {
        batchSize: this.state.settlementRowsPerPage || 10,
        startRecord: this.state.settlementStartRecord || 1,
      };

      let fromDate = this.state.fromDate
        // ? encodeURIComponent(this.convertDateParam(this.state.fromDate))
        ? encodeURIComponent(convertDateParam(this.state.fromDate))
        : "";
      let toDate = this.state.toDate
        // ? encodeURIComponent(this.convertTillDateParam(this.state.toDate))
        ? encodeURIComponent(convertTillDateParam(this.state.toDate))
        : "";
      var jsonData = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        jsonData.tenantId = this.state.tenant;
      }
      if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.screen === "settlementView" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
        jsonData.tenantId = this.state.tenant;
      }

      let searchFilter = '';
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        searchFilter += `&invoiceTypeId=PARTNER_STLMNT_INV`;
      }
      if (this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER")) {
        if (this.props.tabValue === 2) {
          searchFilter += `&invoiceTypeId=GROUP_STLMNT_INV`;
        } else {
          searchFilter += `&invoiceTypeId=PARTNER_STLMNT_INV`;
        }
      } else {
        if (this.props.providerType === "SALES_CHNL_PROVIDER") {
          searchFilter += `&invoiceTypeId=GROUP_STLMNT_INV`;
        }
      }
      searchFilter += `&partnerId=${this.state.partnerId || ''}&customerBan=${this.state.customerDetails.ban}&customerName=${this.state.customerName || ''}&orderId=${this.state.settlementOrderId || ''}&productName=${this.state.itemDescription || ''}&from=${fromDate || ''}&to=${toDate || ''}`;
      BusApiCall(
        "GET",
        // `${constants.busV4Url}/settlement/views/summary?sortBy=${this.state.settlemtnSortBy}&sortOrder=${this.state.settlementSortOrder}&${searchFilter}`,
        `${constants.busV44UrlPublic}/providers/${this.state.tenant ? this.state.tenant : this.props.providerId}/settlement-invoices/report?sortBy=${this.state.sortByInvoice}&sortOrder=${this.state.sortOrderInvoice}${searchFilter}`,
        jsonData,
        pageOptions,
      )
        .then((res) => {
          //let data = JSON.parse(res);
          this.setState({
            settlementList: res.data,
            totalSettlementCount: +res.headers["x-total-count"],
            loading: false,
            searchingSettlements: false
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    } else {
      setTimeout(() => {
        this.getCustomerOrders(jsonData);
      }, 2000);
    }
  };

  // convertDateParam(date) {
  //   return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  // }

  getCustomerAddons = (jsonData) => {
    if (this.state.customerDetails.partyId) {
      let pageOptions = {
        // batchSize: this.state.subsHistoryPerPage,
        batchSize: this.state.addonsRowsPerPage,
        // startRecord: this.state.subsHistoryStartRecord,
        startRecord: this.state.addonsStartRecord,
      };

      let filter = "&orderId=";
      if (this.state.orderId !== null && this.state.orderId !== "") {
        filter = filter + this.state.orderId;
      }

      let data = {};
      if (
        this.props.providerType === "SOLUTION_PROVIDER" &&
        (this.props.screen === "billing" ||
          this.props.screen === "assetOwner" ||
          this.props.screen === "subscriptions" ||
          this.props.screen === "addonsManagement")
      ) {
        data.tenantId = this.state.tenant;
      }
      this.setState({ loading: true, addonsData: [], searchingAddons: true });
      // &subscriptionId=${this.state.addonsFilters.subscriptionId}
      // BusApiCall('GET', `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.customerDetails.ban)}/client/${jsonData.partyId ? jsonData.partyId : jsonData}/assets/addons?sortBy=${this.state.sortByAddons}&sortOrder=${this.state.sortOrderAddons}&productName=${this.state.addonsFilters.productName}&orderId=${this.state.addonsFilters.orderId}`, data, pageOptions)
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.customerDetails.ban)}/client/${jsonData.partyId ? jsonData.partyId : jsonData}/assets/addons?sortBy=${this.state.sortByAddons}&sortOrder=${this.state.sortOrderAddons}&productName=${this.state.addonsFilters.productName}&addonId=${this.state.addonsFilters.addonId}&orderId=${this.state.addonsFilters.orderId}`,
        data,
        pageOptions,
      )
        .then((res) => {
          this.setState({
            addonsData: res.data,
            totalAddonsCount: +res.headers["x-total-count"],
            loading: false,
            searchingAddons: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false, searchingAddons: false });
        });
    } else {
      setTimeout(() => {
        this.getCustomerAddons(jsonData);
      }, 2000);
    }
  };

  getCustomerInvoice = (jsonData) => {
    this.setState({
      loading: true,
      searchingBillingData: true,
      invoiceHistoryData: [],
    });
    let pageOptions = {
      batchSize: this.state.invoiceHistoryPerPage,
      startRecord: this.state.invoiceHistoryStartRecord,
    };
    let filter = "&orderId=";
    if (this.state.orderId !== null && this.state.orderId !== "") {
      filter = filter + this.state.orderId;
    }
    let data = {};
    if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      (this.props.screen === "billing" ||
        this.props.screen === "assetOwner" ||
        this.props.screen === "subscriptions")
    ) {
      data.tenantId = this.state.tenant;
    }

    BusApiCall(
      "GET",
      `${constants.busV4Url}/billing/views/${jsonData.partyId}/invoice?sortBy=${this.state.sortByInvoice}&sortOrder=${this.state.sortOrderInvoice}` +
      filter,
      data,
      pageOptions,
    )
      .then((res) => {
        this.setState(
          {
            billingData: res.data ? res.data : {},
            invoiceHistoryData: res.data.invoiceHistory
              ? res.data.invoiceHistory
              : [],
            totalInvoiceCount: +res.headers["x-total-count"],
          },
          () => {
            this.setState({
              renderBillingView: true,
              searchingBillingData: false,
              loading: false,
            });
            this.getMyProfile(jsonData);
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, searchingBillingData: false });
      });
  };

  getSubscriptionAdjustments = (partyId) => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/subscriptionAdjustments?partyId=${partyId}`,
      {},
      pageOptions,
    )
      .then((res) => {
        let data = res.data;
        if (data.length > 0) {
          var tempData = data;
          for (var i = 0; i < tempData.length; i++) {
            tempData.open = false;
          }
          this.setState({
            subscriptionAdjustments: tempData,
            totalOrderCount: +res.headers["x-total-count"],
            loading: false,
          });
        } else {
          this.setState({
            subscriptionAdjustments: [],
            totalOrderCount: 0,
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getCustomerInvoiceAndAdjustmentsOnChange = async (partyId) => {
    // billing invoice data
    this.setState({
      loading: true,
      searchingBillingData: true,
      invoiceHistoryData: [],
    });
    let invoicePageOptions = {
      batchSize: this.state.invoiceHistoryPerPage,
      startRecord: this.state.invoiceHistoryStartRecord,
    };
    let filter = "&orderId=";
    if (this.state.orderId !== null && this.state.orderId !== "") {
      filter = filter + this.state.orderId;
    }
    let data = {};
    if (
      this.props.providerType === "SOLUTION_PROVIDER" &&
      (this.props.screen === "billing" ||
        this.props.screen === "assetOwner" ||
        this.props.screen === "subscriptions")
    ) {
      data.tenantId = this.state.tenant;
    }

    // adjustments data
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    Promise.all([
      BusApiCall(
        "GET",
        `${constants.busV4Url}/billing/views/${partyId}/invoice?sortBy=${this.state.sortByInvoice}&sortOrder=${this.state.sortOrderInvoice}` +
        filter,
        data,
        invoicePageOptions,
      ),
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/subscriptionAdjustments?partyId=${partyId}`,
        {},
        pageOptions,
      ),
    ])
      .then((res) => {
        var response1 = res[0].data;
        var response2 = res[1].data;

        // adjustments res management
        var adjustmentData = {
          subscriptionAdjustments: [],
          totalOrderCount: 0,
        };
        if (response2.length > 0) {
          var tempData = response2;
          for (var i = 0; i < tempData.length; i++) {
            tempData.open = false;
          }
          adjustmentData = {
            subscriptionAdjustments: tempData,
            totalOrderCount: +res[1].headers["x-total-count"],
          };
        }

        this.setState(
          {
            // billing invoice res management
            billingData: response1 ? response1 : {},
            invoiceHistoryData: response1.invoiceHistory
              ? response1.invoiceHistory
              : [],
            totalInvoiceCount: +res[0].headers["x-total-count"],

            // adjustments data update
            ...adjustmentData,
          },
          () => {
            this.setState({
              renderBillingView: true,
              searchingBillingData: false,
              loading: false,
            });
            var jsonData = {
              partyId: partyId,
            };
            this.getMyProfile(jsonData);
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  checkOrderForInvoice = () => {
    if (this.state.orderId != null) {
      BusApiCall(
        "GET",
        `${constants.busV4Url}/orders/${this.state.orderId}/itemsAvailableForInvoice`,
      )
        .then((res) => {
          let data = res.data;

          this.setState({
            orderBillToCustomerId: data.billToCustomerId,
            showOrderInvoice: data.itemsAvailableForInvoice,
            isNormalFlow: data.isNormalFlow,
            disableInvoiceBtn: !data.itemsAvailableForInvoice,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getCustomersHierarchy();
        // this.getFilteredHierarchy();
      },
    );
  };

  enpandAllCustomers = () => {
    this.setState(
      {
        initialOpen: Array.isArray(this.state.initialOpen)
          ? true
          : !this.state.initialOpen,
        showHierarchy: false,
      },
      () => {
        this.setState({
          showHierarchy: true,
        });
      },
    );
  };

  // Update state data on input change
  onChange = (e) => {
    var input = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        // console.log('check event', input)
        localStorage.setItem("selectedSalesChannel", this.state.tenant);
        if (input === "tenant") {
          // this.filterHierarchy();
          this.setState(
            {
              ordersData: [],
              totalOrdersCount: 0,
              customerDetails: {},
              subscriptionData: [],
              totalSubscriptionCount: 0,
              addonsData: [],
              totalAddonsCount: 0,
              quotesData: [],
              totalQuotesCount: 0,
              subscriptionAdjustments: [],
              totalOrderCount: 0,
              totalInvoiceCount: 0,
              invoiceHistoryData: [],
              billingData: {},
            },
            () => {
              this.getCustomersHierarchy();
            },
          );
        }
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getCustomersHierarchy();
        // this.getFilteredHierarchy();
      },
    );
  };
  onSearchChange = (e) => {
    this.setState({
      name: e.target.value,
    });
  };
  filterHierarchy = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        totalRowsCount: 0,
      },
      () => {
        this.getCustomersHierarchy();
        if (!this.state.initialOpen) {
          this.enpandAllCustomers();
        }
      },
    );
  };

  // Clear all search filters
  clearHierarchyFilters = () => {
    this.removeQueryParam('leadId');
    if (this.state.isTaskMode) {
      this.setState(
        {
          isTaskMode: false,
          taskCustomerId: "",
          taskCustomerTenant: "",
          newLeadOrCustomer: false,
        },
        () => {
          this.props.router.navigate({ pathname: window.location.pathname });
        },
      );
    }
    this.setState(
      {
        name: "",
        page: 1,
        startRecord: 1,
        totalRowsCount: 0,
      },
      () => {
        this.getCustomersHierarchy();
        if (this.state.initialOpen) {
          this.enpandAllCustomers();
        }
      },
    );
  };

  removeQueryParam = (paramName) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(paramName);

    window.history.replaceState(
      {},
      document.title,
      url.toString()
    );
  }

  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterHierarchy();
    }
  };

  assetDataPageChange = (e, page) => {
    this.setState(
      {
        assetDataPage: page,
        assetDataStartRecord: this.state.assetDataPerpage * (page - 1) + 1,
      },
      () => {
        this.getAssetDetails(this.state.customerDetails.partyId);
      },
    );
  };

  assetDataRowsPerPageChange = (event) => {
    this.setState(
      {
        assetDataPerpage: event.target.value,
        assetDataStartRecord: 1,
        assetDataPage: 1,
      },
      () => {
        this.getAssetDetails(this.state.customerDetails.partyId);
      },
    );
  };

  paginateAssetData = () => {
    return this.state.assetDataProxy.slice(
      (this.state.assetDataPage - 1) * this.state.assetDataPerpage,
      this.state.assetDataPage * this.state.assetDataPerpage,
    );
  };

  openSubscription = (index) => {
    let subscriptions = [...this.state.subscriptionData];
    if (
      !subscriptions[index].expand &&
      !subscriptions[index].addiotinalDetails
    ) {
      subscriptions[index].expand = !subscriptions[index].expand;
      this.setState({
        loading: true,
      });
      let jsonData = {};
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        jsonData.tenantId = this.state.tenant;
      }
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/subscriptions/${subscriptions[index].subscriptionId}`,
        jsonData,
      )
        .then((res) => {
          subscriptions[index].addiotinalDetails = res.data;
          this.setState({
            subscriptionData: subscriptions,
            loading: false,
          });
        })
        .catch((err) => {
          this.setState({
            subscriptionData: subscriptions,
            loading: false,
          });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      subscriptions[index].expand = !subscriptions[index].expand;
      this.setState({
        subscriptionData: subscriptions,
      });
    }
    // subscriptions[index].expand = !subscriptions[index].expand;
    // this.setState({
    //     subscriptionData: subscriptions
    // })
  };

  expandItemHistory = (index) => {
    let subscriptions = [...this.state.subscriptionData];
    if (subscriptions[index].expandHistory) {
      subscriptions[index].expandHistory = false;
    } else {
      subscriptions[index].expandHistory = true;
    }
    this.setState({
      subscriptionData: subscriptions,
    });
  };

  openAddons = (index) => {
    console.log('index===== openAddons', index, this.state.addonsData)
    let addonsData = [...this.state.addonsData];
    addonsData[index].expand = !addonsData[index].expand;
    this.setState({
      addonsData: addonsData,
    });
  };

  initiateInvoicePayment = (orderId, invoiceId) => {
    this.setState({
      invoiceOrderId: orderId,
      invoiceId: invoiceId,
      initiatePaymentDialog: true,
    });
  };

  closePaymentDialog = () => {
    this.setState({
      invoiceOrderId: null,
      invoiceId: null,
      initiatePaymentDialog: false,
    });
  };

  chooseExistingPaymentMethod = (method) => {
    this.setState({
      loading: true,
    });
    // hit API when user select existing payment method
    var payload = {
      orderId: this.state.invoiceOrderId,
      invoiceId: this.state.invoiceId,
      paymentMethodId: method.paymentMethodId,
    };

    BusApiCall(
      "POST",
      `${constants.busV4Url}/invoice/${payload.invoiceId}/paymentMethod/${payload.paymentMethodId}`,
      {},
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t("PAYMENT_INITIATED_SUCCESSFULLY"),
          true,
        );
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });

    this.setState({
      initiatePaymentDialog: false,
    });
  };

  addChildItem = (e, id) => {
    e.preventDefault();
    this.setState({
      selectedParty: id,
      childItemDialog: true,
      selectedItemToEdit: {},
    });
  };

  promoteLead = (e, data) => {
    this.setState(
      {
        selectedToPromote: data,
      },
      () => {
        this.setState({
          showBanDialog: true,
        });
      },
    );
  };

  closeBanDialog = () => {
    this.setState({
      showCustomerBanError: false,
      showBanDialog: false,
      custCodeAvailable: false,
      custCodeValue: "",
      showCustomerBanError: false,
    });
  };

  createCustomerBan = () => {
    if (
      this.state.selectedToPromote.tempCustCodePrefix &&
      this.state.custCodeValue
        .toLowerCase()
        .startsWith(
          this.state.selectedToPromote.tempCustCodePrefix.toLowerCase(),
        )
    ) {
      this.setState({
        showCustomerBanError: true,
      });
      return;
    }
    if (this.state.custCodeValue.trim()) {
      this.setState({ loading: true });
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/customers/${this.state.custCodeValue}/validate`,
        {},
      )
        .then((res) => {
          if (res && res.data) {
            if (res.data.apiEnabled === "Y") {
              if (
                // res.data.code === 200 &&
                (res.data.status === "Active" || res.data.status === "active" ||
                  res.data.status === "Qualified" || res.data.status === "qualified")
              ) {
                // Allow to create
                this.submitCustomerBan();
                this.setState({
                  showBanDialog: false,
                });
              } else {
                // not allowed
                this.props.setErrorMessage(
                  this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
                  false,
                );
                this.setState({
                  showBanDialog: false,
                  loading: false,
                  custCodeAvailable: false,
                  custCodeValue: "",
                  showCustomerBanError: false,
                });
              }
            } else {
              // Allow to create
              this.submitCustomerBan();
              this.setState({
                showBanDialog: false,
              });
            }
          } else {
            // not allowed
            this.props.setErrorMessage(
              this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
              false,
            );
            this.setState({
              showBanDialog: false,
              loading: false,
              custCodeValue: "",
              custCodeAvailable: false,
              showCustomerBanError: false,
            });
          }
        })
        .catch((err) => {
          // not allowed
          // this.props.setErrorMessage(this.props.t('BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER'), false);
          var msg = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
          this.props.setErrorMessage(msg, false);
          this.setState({
            showBanDialog: false,
            loading: false,
            custCodeAvailable: false,
            custCodeValue: "",
            showCustomerBanError: false,
          });
        });
    }
  };

  createCustomerWithoutBan = () => {
    this.setState({ loading: true });
    var customerData = {};
    let customer = {
      accountName: this.state.selectedToPromote.accountName,
    };
    BusApiCall(
      "GET",
      `${constants.busV4Url}/myProfile?customerId=${this.state.customerDetails.partyId}`,
    )
      .then((res) => {
        customerData = {
          contact: {
            firstName: res.data.firstName || "",
            lastName: res.data.lastName || "",
            partyId: res.data.partyId || "",
            officePhone: res.data.officePhone || "",
            email: res.data.email || "",
            emailMechId: res.data.emailMechId || "",
            billingCloseDay: res.data.billingCloseDay,
          },
          billing: {
            attention: res.data.billing?.[0]?.attention || "",
            phone: res.data.billing?.[0]?.phone || "",
            street1: res.data.billing?.[0]?.street1 || "",
            street2: res.data.billing?.[0]?.street2 || "",
            city: res.data.billing?.[0]?.city || "",
            state: res.data.billing?.[0]?.state || "",
            zip: res.data.billing?.[0]?.zip || "",
            country: res.data.billing?.[0]?.country || "",
          },
          shipping: {
            attention: res.data.shipping?.[0]?.attention || "",
            phone: res.data.shipping?.[0]?.phone || "",
            phoneMechId: res.data.shipping?.[0]?.phoneMechId || "",
            street1: res.data.shipping?.[0]?.street1 || "",
            street2: res.data.shipping?.[0]?.street2 || "",
            city: res.data.shipping?.[0]?.city || "",
            state: res.data.shipping?.[0]?.state || "",
            zip: res.data.shipping?.[0]?.zip || "",
            country: res.data.shipping?.[0]?.country || "",
            postalMechId: res.data.shipping?.[0]?.postalMechId || "",
          },
          banDetails: {
            accountName: res.data.accountName || "",
            ban: res.data.ban || "",
            isManaged: false,
          },
        };

        // Add lead object if on manageLeads screen
        if (window.location.pathname === "/manageLeads") {
          customerData.lead = {
            isLead: "Y",
          };
        }
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/customers`,
          customerData,
        )
          .then((res) => {
            this.setState({
              loading: false,
              showBanDialog: false,
              custCodeAvailable: false,
              custCodeValue: "",
              showCustomerBanError: false,
            });
            this.props.setErrorMessage(
              this.props.t("LEAD_PROMOTED_SUCCESSFULLY", { customer }),
              true,
            );
            this.getCustomersHierarchy();
          })
          .catch((err) => {
            console.log("err=====", err);
            this.setState({
              loading: false,
              showBanDialog: false,
              custCodeAvailable: false,
              custCodeValue: "",
              showCustomerBanError: false,
            });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          showBanDialog: false,
          custCodeAvailable: false,
          custCodeValue: "",
          showCustomerBanError: false,
        });
      });
  };

  submitCustomerBan = () => {
    let customer = {
      accountName: this.state.selectedToPromote.accountName,
    };
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/customers/${this.state.custCodeValue}/client/${this.state.selectedToPromote.partyId}/updateCustomerBAN`,
    )
      .then((res) => {
        this.props.setErrorMessage(
          this.props.t("LEAD_PROMOTED_SUCCESSFULLY", { customer }),
          true,
        );
        this.setState(
          {
            custCodeValue: "",
            selectedToPromote: {},
            loading: false,
          },
          () => {
            this.getCustomersHierarchy();
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  changeCustomerBan = (e) => {
    this.setState({
      showCustomerBanError: false,
      [e.target.name]: e.target.value,
    });
  };

  editChildItem = (e, data) => {
    e.preventDefault();
    if (data.partyType === "LOCATION") {
      let tempData = {
        partyId: data.partyId ? data.partyId : "",
        isGroup: data.isGroup ? data.isGroup : "",
        partyName: data.accountName ? data.accountName : "",
        userName: data.username ? data.username : "",
        partyType: data.partyType,
        locationDetails: {
          description: data.locationDetails.description
            ? data.locationDetails.description
            : "",
          identifier: data.locationDetails.identifier
            ? data.locationDetails.identifier
            : "",
          positioning: data.locationDetails.positioning
            ? data.locationDetails.positioning
            : "",
        },
      };
      this.setState({
        childItemDialog: true,
        selectedItemToEdit: tempData,
      });
    } else {
      let tempData = {
        partyId: data.partyId ? data.partyId : "",
        isGroup: data.isGroup ? data.isGroup : "",
        partyName: data.accountName ? data.accountName : "",
        userName: data.username ? data.username : "",
        partyType: data.partyType,
        isManaged: data.isManaged,
        createdByUser: data.createdByUser,
        contact: {
          firstName: data.firstName ? data.firstName : "",
          lastName: data.lastName ? data.lastName : "",
          email: data.email ? data.email : "",
          phone: data.officePhone ? data.officePhone : "",
          emailMechId: data.emailMechId ? data.emailMechId : "",
          phoneMechId: data.officePhoneMechId ? data.officePhoneMechId : "",
        },
        parentPartyId: data.parentId ? data.parentId : "",
      };
      if (data.shipping && data.shipping.length > 0) {
        tempData.shipping = {
          mechId: data.shipping[0].postalMechId,
          addressLine1: data.shipping[0].street1,
          addressLine2: data.shipping[0].street2,
          city: data.shipping[0].city,
          state: data.shipping[0].state,
          zipCode: data.shipping[0].zip,
          country: data.shipping[0].country,
        };
      } else {
        tempData.shipping = {
          mechId: "",
          addressLine1: "",
          addressLine2: "",
          city: "",
          state: "",
          zipCode: "",
          country: this.props.defaultCountry,
        };
      }
      this.setState({
        childItemDialog: true,
        selectedItemToEdit: tempData,
      });
    }
  };

  downloadInvoicePdf = (orderId, invoiceId, type) => {
    this.setState({
      loading: true,
    });

    // Get PDF link
    BusApiCall(
      "GET",
      `${constants.busV4Url}/orders/${orderId}/invoice/${invoiceId}`,
    )
      .then((res) => {
        this.setState({
          loading: false,
        });
        console.log("check original response", res.data);

        if (type && type === "view") {
          this.setState({
            selectedFileToView: {
              base64: res.data.invoicePdf,
              mimeType: "application/pdf",
              name: invoiceId,
            },
            showFileData: true,
          });
        } else {
          // Convert pdf to array buffer
          var arrrayBuffer = this.base64ToArrayBuffer(res.data.invoicePdf);
          // Create pdf blob
          var blob = new Blob(
            [arrrayBuffer],
            { type: "application/pdf" },
            invoiceId + "-bill.pdf",
          );
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = url;
          link.download = invoiceId + "-bill.pdf";
          link.dispatchEvent(new MouseEvent("click"));
          // Create URL object and download
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  onInvoiceHistoryPageChange = (e, page) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        loading: true,
        invoiceHistoryPage: page,
        invoiceHistoryStartRecord:
          this.state.invoiceHistoryPerPage * (page - 1) + 1,
      },
      () => {
        this.getCustomerInvoice(jsonData);
      },
    );
  };

  // Change table sorting
  updateInvoiceSorting = (by) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    if (by === this.state.sortByInvoice) {
      this.setState(
        {
          sortOrderInvoice:
            this.state.sortOrderInvoice === "DESC" ? "ASC" : "DESC",
          invoiceHistoryPage: 1,
          invoiceHistoryStartRecord: 1,
        },
        () => {
          this.getCustomerInvoice(jsonData);
        },
      );
    } else {
      this.setState(
        {
          sortByInvoice: by,
          sortOrderInvoice: "ASC",
          invoiceHistoryPage: 1,
          invoiceHistoryStartRecord: 1,
        },
        () => {
          this.getCustomerInvoice(jsonData);
        },
      );
    }
  };

  updateInvoiceHistoryPerPageRows = (event) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        loading: true,
        invoiceHistoryPage: 1,
        invoiceHistoryPerPage: event.target.value,
        invoiceHistoryStartRecord: 1,
      },
      () => {
        this.getCustomerInvoice(jsonData);
      },
    );
  };

  updateSubsSorting = (by) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    if (by === this.state.sortBySubs) {
      this.setState(
        {
          loading: true,
          sortOrderSubs: this.state.sortOrderSubs === "DESC" ? "ASC" : "DESC",
          subsHistoryPage: 1,
          subsHistoryStartRecord: 1,
        },
        () => {
          this.getCustomerSubscriptions(jsonData);
        },
      );
    } else {
      this.setState(
        {
          loading: true,
          sortBySubs: by,
          sortOrderSubs: "ASC",
          subsHistoryPage: 1,
          subsHistoryStartRecord: 1,
        },
        () => {
          this.getCustomerSubscriptions(jsonData);
        },
      );
    }
  };

  updateSubsHistoryPerPageRows = (event) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        loading: true,
        subsHistoryPage: 1,
        subsHistoryPerPage: event.target.value,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getCustomerSubscriptions(jsonData);
      },
    );
  };

  onSubsHistoryPageChange = (e, page) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        loading: true,
        subsHistoryPage: page,
        subsHistoryStartRecord: this.state.subsHistoryPerPage * (page - 1) + 1,
      },
      () => {
        this.getCustomerSubscriptions(jsonData);
      },
    );
  };

  onChangeSubsInput = (e) => {
    var data = { ...this.state.subsFilters };
    data[e.target.name] = e.target.value;
    this.setState({
      subsFilters: data,
    });
  };
  onSearchKeyDownSubsInput = (e) => {
    if (e.key === "Enter") {
      var jsonData = {
        partyId: this.state.showChildItem
          ? this.state.childItemDetails.partyId
          : this.state.customerDetails.partyId,
      };
      this.setState(
        {
          loading: true,
          subsHistoryPage: 1,
          subsHistoryStartRecord: 1,
        },
        () => {
          this.getCustomerSubscriptions(jsonData);
        },
      );
    }
  };

  handleSearchIdentifierChange = (e) => {
    const { name, value } = e.target;
    this.setState(prev => {
      const arr = Array.isArray(prev.searchIdentifierValues) ? [...prev.searchIdentifierValues] : [];
      const idx = arr.findIndex(item => item.key === name);
      if (value === '' || value == null) {
        if (idx > -1) arr.splice(idx, 1);
      } else if (idx > -1) {
        arr[idx] = { ...arr[idx], value };
      } else {
        arr.push({ key: name, value });
      }
      return { searchIdentifierValues: arr };
    });
  };

  filterSubsTable = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        loading: true,
        subsHistoryPage: 1,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getCustomerSubscriptions(jsonData);
      },
    );
  };

  clearSubsTableSearch = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        subsFilters: {
          productName: "",
          subscriptionId: "",
          orderId: "",
        },
        searchIdentifierValues: [],
        loading: true,
        subsHistoryPage: 1,
        subsHistoryStartRecord: 1,
      },
      () => {
        this.getCustomerSubscriptions(jsonData);
      },
    );
  };

  closeEditChildItemDialog = (data, loginData) => {
    this.setState({ loading: true });
    if (loginData && loginData.id) {
      const username = { username: loginData.id };
      BusApiCall(
        "POST",
        `${constants.busInternalUrl}/passthru/VALIDATE_PARTY_USERNAME/endpoint`,
        username,
      ).then((res) => {
        if (res.data.status === "failure") {
          this.setState({ loading: false });
          this.setState({ err: res.data.message });
        } else {
          BusApiCall("PUT", `${constants.busV4Url}/parties`, data)
            .then((res) => {
              var tempCustomers = [...this.state.customerListProxy];
              var index = tempCustomers.findIndex(
                (x) => x.partyId === data.partyId,
              );
              if (index > -1) {
                tempCustomers[index].name = data.partyName;
                if (tempCustomers[index].accountName) {
                  tempCustomers[index].accountName = data.partyName;
                }
                this.setState(
                  {
                    customerList: tempCustomers,
                    renderView: false,
                    childItemDialog: false,
                    selectedItemToEdit: {},
                    selectedParty: "",
                  },
                  () => {
                    this.createCustomerTreeData();
                  },
                );
              }
              this.createUser(loginData, data.partyId);
              // if (data.partyType === 'PARTY_GROUP') {
              //     this.props.setErrorMessage(this.props.t('Customer Group ' + data.partyName + ' updated successfully'), true);
              // }
              // else if (data.partyType === 'PERSON') {
              //     this.props.setErrorMessage(this.props.t('Customer ' + data.partyName + ' updated successfully'), true);
              // }
              // else if (data.partyType === 'LOCATION') {
              //     this.props.setErrorMessage(this.props.t('Customer Location ' + data.partyName + ' updated successfully'), true);
              // } else {
              //     this.props.setErrorMessage("User updated successfully ", true)
              // }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({ loading: false });
            });
        }
      });
    } else {
      BusApiCall("PUT", `${constants.busV4Url}/parties`, data)
        .then((res) => {
          var tempCustomers = [...this.state.customerListProxy];
          var index = tempCustomers.findIndex(
            (x) => x.partyId === data.partyId,
          );
          if (index > -1) {
            tempCustomers[index].name = data.partyName;
            if (tempCustomers[index].accountName) {
              tempCustomers[index].accountName = data.partyName;
            }
            this.setState(
              {
                customerList: tempCustomers,
                renderView: false,
                childItemDialog: false,
                selectedItemToEdit: {},
                selectedParty: "",
              },
              () => {
                this.createCustomerTreeData();
              },
            );
          }
          if (data.partyType === "PARTY_GROUP") {
            this.props.setErrorMessage(
              this.props.t(
                "Customer Group " + data.partyName + " updated successfully",
              ),
              true,
            );
          } else if (data.partyType === "PERSON") {
            this.props.setErrorMessage(
              this.props.t(
                "Customer " + data.partyName + " updated successfully",
              ),
              true,
            );
          } else if (data.partyType === "LOCATION") {
            this.props.setErrorMessage(
              this.props.t(
                "Customer Location " + data.partyName + " updated successfully",
              ),
              true,
            );
          } else {
            this.props.setErrorMessage("User updated successfully ", true);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({ loading: false });
        });
    }
  };

  closeChildItemDialog = (data, loginData) => {
    if (data) {
      data.parentPartyId = this.state.selectedParty;
      this.setState({ loading: true });
      if (loginData && loginData.id) {
        const username = { username: loginData.id };
        //check for duplicate usernames
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/passthru/VALIDATE_PARTY_USERNAME/endpoint`,
          username,
        ).then((res) => {
          if (res.data.status === "failure") {
            this.setState({ loading: false });
            this.setState({ err: res.data.message });
          } else {
            // this.createUser(loginData, res.data.partyId);
            BusApiCall("POST", `${constants.busV4Url}/parties`, data)
              .then((partyRes) => {
                this.setState({
                  childItemDialog: false,
                  // customersList: mainArray,
                  selectedItemToEdit: {},
                  selectedParty: "",
                  // loading: false
                });
                this.createUser(loginData, partyRes.data.partyId);
                // this.getCustomersHierarchy();
                // this.props.setErrorMessage(this.props.t('Customer ' + data.partyName + ' added successfully'), true);
                this.setState({
                  loading: false,
                });
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  // this.props.setErrorMessage(err.response.data.message, false)
                  this.setState({ err: err.response.data.message });
                } else {
                  // this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
                  this.setState({ err: this.props.t("DEFAULT_ERROR_MESSAGE") });
                }
                this.setState({ loading: false });
              });
          }
        });
      } else {
        BusApiCall("POST", `${constants.busV4Url}/parties`, data)
          .then((res) => {
            this.setState({
              childItemDialog: false,
              // customersList: mainArray,
              selectedItemToEdit: {},
              selectedParty: "",
              // loading: false
            });
            this.getCustomersHierarchy();
            if (data.partyType === "PARTY_GROUP") {
              this.props.setErrorMessage(
                this.props.t(
                  "Customer Group " + data.partyName + " added successfully",
                ),
                true,
              );
            } else if (data.partyType === "PERSON") {
              this.props.setErrorMessage(
                this.props.t(
                  "Customer " + data.partyName + " added successfully",
                ),
                true,
              );
            } else if (data.partyType === "LOCATION") {
              this.props.setErrorMessage(
                this.props.t(
                  "Customer Location " + data.partyName + " added successfully",
                ),
                true,
              );
            } else {
              this.props.setErrorMessage(
                this.props.t("ITEM_ADDED_SUCCESSFULLY"),
                true,
              );
            }
            this.setState({
              loading: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              // this.props.setErrorMessage(err.response.data.message, false)
              this.setState({ err: err.response.data.message });
            } else {
              // this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
              this.setState({ err: this.props.t("DEFAULT_ERROR_MESSAGE") });
            }
            this.setState({ loading: false });
          });
      }
    } else {
      this.setState({
        err: "",
        childItemDialog: false,
        selectedParty: "",
        selectedItemToEdit: {},
      });
    }
  };

  createUser = (data, partyId) => {
    var loginData = { ...data };
    loginData.customerBan = this.state.customerDetails.ban;
    loginData.partyId = partyId;
    BusApiCall("POST", `${constants.busV4Url}/user`, loginData)
      .then((res) => {
        this.getCustomersHierarchy();
        this.props.setErrorMessage(
          "User created successfully with id: " + loginData.id + ".",
          true,
        );
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.getCustomersHierarchy();
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          console.log(err);
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
    this.setState({ loading: false });
  };

  goNext = (paymentData, selectedProfileData) => {
    let data = {};
    let paymentMethod = {};
    if (paymentData) {
      paymentMethod = paymentData;
    }
    let billing = {};
    if (this.state.name) {
      if (this.state.childItemDetails.name) {
        let parentId = this.state.childItemDetails.path.split("/")[1];
        if (this.state.customerDetails.ban) {
          if (this.state.customerDetails.partyId !== parentId) {
            let parentIndex = this.state.customersListProxy.findIndex(
              (a) => a.partyId === parentId,
            );
            this.state.customerDetails =
              this.state.customersListProxy[parentIndex];
            let availablePaymetnMethods =
              this.state.customersListProxy[parentIndex].paymentMethods;
            for (let i = 0; i < availablePaymetnMethods.length; i++) {
              if (availablePaymetnMethods[i].primary) {
                if (availablePaymetnMethods[i].cardNumber) {
                  let payment = [];
                  payment.push(availablePaymetnMethods[i]);
                  paymentMethod = {
                    creditCards: payment,
                  };
                } else {
                  let payment = [];
                  payment.push(availablePaymetnMethods[i]);
                  paymentMethod = {
                    eftAccount: payment,
                  };
                }
              }
            }
          }
        } else {
          let parentIndex = this.state.customersListProxy.findIndex(
            (a) => a.partyId === parentId,
          );
          this.state.customerDetails =
            this.state.customersListProxy[parentIndex];
          let availablePaymetnMethods =
            this.state.customersListProxy[parentIndex].paymentMethods;
          for (let i = 0; i < availablePaymetnMethods.length; i++) {
            if (availablePaymetnMethods[i].primary) {
              if (availablePaymetnMethods[i].cardNumber) {
                let payment = [];
                payment.push(availablePaymetnMethods[i]);
                paymentMethod = {
                  creditCards: payment,
                };
              } else {
                let payment = [];
                payment.push(availablePaymetnMethods[i]);
                paymentMethod = {
                  eftAccount: payment,
                };
              }
            }
          }
        }
      }
    }

    if (paymentData.creditCards && paymentData.creditCards.length > 0) {
      billing = {
        attention: paymentData.creditCards[0].attention,
        phone: paymentData.creditCards[0].phone,
        street1: paymentData.creditCards[0].street1,
        street2: paymentData.creditCards[0].street2,
        city: paymentData.creditCards[0].city,
        state: paymentData.creditCards[0].state,
        zip: paymentData.creditCards[0].zip,
        country: paymentData.creditCards[0].country,

        phoneMechId: paymentData.creditCards[0].phoneMechId,
        postalMechId: paymentData.creditCards[0].postalMechId,
      };
    } else if (paymentData.eftAccount && paymentData.eftAccount.length > 0) {
      billing = {
        attention: paymentData.eftAccount[0].attention,
        phone: paymentData.eftAccount[0].phone,
        street1: paymentData.eftAccount[0].street1,
        street2: paymentData.eftAccount[0].street2,
        city: paymentData.eftAccount[0].city,
        state: paymentData.eftAccount[0].state,
        zip: paymentData.eftAccount[0].zip,
        country: paymentData.eftAccount[0].country,

        phoneMechId: paymentData.eftAccount[0].phoneMechId,
        postalMechId: paymentData.eftAccount[0].postalMechId,
      };
    } else {
      if (Array.isArray(this.state.customerDetails.billing)) {
        if (this.state.customerDetails.billing.length > 0) {
          billing = {
            attention: this.state.customerDetails.billing[0].attention,
            phone: this.state.customerDetails.billing[0].phone,
            street1: this.state.customerDetails.billing[0].street1,
            street2: this.state.customerDetails.billing[0].street2,
            city: this.state.customerDetails.billing[0].city,
            state: this.state.customerDetails.billing[0].state,
            zip: this.state.customerDetails.billing[0].zip,
            country: this.state.customerDetails.billing[0].country,

            phoneMechId: this.state.customerDetails.billing[0].phoneMechId,
            postalMechId: this.state.customerDetails.billing[0].postalMechId,
          };
        } else {
          billing = {};
        }
      } else {
        if (this.state.customerDetails.billing.attention) {
          billing = {
            attention: this.state.customerDetails.billing.attention,
            phone: this.state.customerDetails.billing.phone,
            street1: this.state.customerDetails.billing.street1,
            street2: this.state.customerDetails.billing.street2,
            city: this.state.customerDetails.billing.city,
            state: this.state.customerDetails.billing.state,
            zip: this.state.customerDetails.billing.zip,
            country: this.state.customerDetails.billing.country,

            phoneMechId: this.state.customerDetails.billing.phoneMechId,
            postalMechId: this.state.customerDetails.billing.postalMechId,
          };
        } else {
          billing = {};
        }
      }
    }
    if (this.state.showChildItem) {
      data = {
        partyId: selectedProfileData.partyId,

        ban: this.state.customerDetails.ban,
        parentId: this.state.childItemDetails.path.split("/")[1],
        canonicalName: this.state.childItemDetails.canonicalName.substring(1),

        // accountName: this.state.childItemDetails.partyName,
        // firstName: this.state.childItemDetails.firstName,
        // lastName: this.state.childItemDetails.lastName,

        // officePhone: this.state.childItemDetails.officePhone,
        // officePhoneMechId: this.state.childItemDetails.officePhoneMechId,

        // email: this.state.childItemDetails.email,
        // emailMechId: this.state.childItemDetails.emailMechId,

        // billingCloseDay: this.state.customerDetails.billingCloseDay,
        accountName: this.state.customerDetails.accountName,
        childAccountName: selectedProfileData.accountName,
        childFirstName: selectedProfileData.firstName,
        childLastName: selectedProfileData.lastName,
        firstName: this.state.customerDetails.firstName,
        lastName: this.state.customerDetails.lastName,

        officePhone: this.state.customerDetails.officePhone,
        officePhoneMechId: this.state.customerDetails.officePhoneMechId,

        mobilePhone: this.state.customerDetails.mobilePhone,
        mobilePhoneMechId: this.state.customerDetails.mobilePhoneMechId,

        email: this.state.customerDetails.email,
        emailMechId: this.state.customerDetails.emailMechId,

        billingCloseDay: this.state.customerDetails.billingCloseDay,

        billing: billing,
        paymentMethod: paymentMethod,
        role: this.state.customerDetails.role,
        childRole: this.state.childItemDetails.role,
      };
      if (Array.isArray(this.state.childItemDetails.shipping)) {
        data.shipping = {
          attention: this.state.childItemDetails.shipping[0].attention,
          street1: this.state.childItemDetails.shipping[0].street1,
          street2: this.state.childItemDetails.shipping[0].street2,
          city: this.state.childItemDetails.shipping[0].city,
          state: this.state.childItemDetails.shipping[0].state,
          zip: this.state.childItemDetails.shipping[0].zip,
          country: this.state.childItemDetails.shipping[0].country,

          postalMechId: this.state.childItemDetails.shipping[0].postalMechId,
          accountName: this.state.childItemDetails.shipping[0].accountName,
          phone: this.state.childItemDetails.officePhone,
        };
      } else {
        data.shipping = {
          attention: this.state.childItemDetails.shipping.attention,
          street1: this.state.childItemDetails.shipping.street1,
          street2: this.state.childItemDetails.shipping.street2,
          city: this.state.childItemDetails.shipping.city,
          state: this.state.childItemDetails.shipping.state,
          zip: this.state.childItemDetails.shipping.zip,
          country: this.state.childItemDetails.shipping.country,

          postalMechId: this.state.childItemDetails.shipping.postalMechId,
          accountName: this.state.childItemDetails.shipping.accountName,
          phone: this.state.childItemDetails.officePhone,
        };
      }
    } else {
      data = {
        ban: this.state.customerDetails.ban,
        partyId: this.state.customerDetails.partyId,
        canonicalName: this.state.customerDetails.canonicalName.substring(1),

        accountName: this.state.customerDetails.accountName,
        firstName: this.state.customerDetails.firstName,
        lastName: this.state.customerDetails.lastName,

        officePhone: this.state.customerDetails.officePhone,
        officePhoneMechId: this.state.customerDetails.officePhoneMechId,

        mobilePhone: this.state.customerDetails.mobilePhone,
        mobilePhoneMechId: this.state.customerDetails.mobilePhoneMechId,

        email: this.state.customerDetails.email,
        emailMechId: this.state.customerDetails.emailMechId,

        billingCloseDay: this.state.customerDetails.billingCloseDay,

        billing: billing,
        paymentMethod: paymentMethod,
        role: this.state.customerDetails.role,
      };
      if (Array.isArray(this.state.customerDetails.shipping)) {
        if (this.state.customerDetails.shipping.length > 0) {
          data.shipping = {
            // confirm for these 2 fields
            attention: this.state.customerDetails.shipping[0].attention,
            phone: this.state.customerDetails.shipping[0].phone,

            street1: this.state.customerDetails.shipping[0].street1,
            street2: this.state.customerDetails.shipping[0].street2,
            city: this.state.customerDetails.shipping[0].city,
            state: this.state.customerDetails.shipping[0].state,
            zip: this.state.customerDetails.shipping[0].zip,
            country: this.state.customerDetails.shipping[0].country,

            phoneMechId: this.state.customerDetails.shipping[0].phoneMechId,
            postalMechId: this.state.customerDetails.shipping[0].postalMechId,
            accountName: this.state.customerDetails.shipping[0].accountName,
          };
        } else {
          data.shipping = {};
        }
      } else {
        if (this.state.customerDetails.shipping.attention) {
          data.shipping = {
            // confirm for these 2 fields
            attention: this.state.customerDetails.shipping.attention,
            phone: this.state.customerDetails.shipping.phone,

            street1: this.state.customerDetails.shipping.street1,
            street2: this.state.customerDetails.shipping.street2,
            city: this.state.customerDetails.shipping.city,
            state: this.state.customerDetails.shipping.state,
            zip: this.state.customerDetails.shipping.zip,
            country: this.state.customerDetails.shipping.country,

            phoneMechId: this.state.customerDetails.shipping.phoneMechId,
            postalMechId: this.state.customerDetails.shipping.postalMechId,
            accountName: this.state.customerDetails.shipping.accountName,
          };
        } else {
          data.shipping = {};
        }
      }
    }
    this.props.next(
      this.props.stage,
      data,
      this.state.selectedTreeItems,
      paymentData,
    );
  };

  // Covert base64 to array buffer
  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  // Change rows per page
  handleSubscriptionChangeRowsPerPage = (event) => {
    let partyId = this.state.customerDetails.partyId;
    this.setState(
      {
        subscriptionPage: 1,
        subscriptionRowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getSubscriptionAdjustments(partyId);
      },
    );
  };

  // Change page
  handleSubscriptionChangePage = (event, newPage) => {
    let partyId = this.state.customerDetails.partyId;
    this.setState(
      {
        subscriptionPage: newPage,
        startRecord: this.state.subscriptionRowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getSubscriptionAdjustments(partyId);
      },
    );
  };

  toggleAdjustmentInfo = (item) => {
    var tempData = [...this.state.subscriptionAdjustments];
    var index = tempData.findIndex((x) => x.adjustmentId === item.adjustmentId);
    if (index > -1) {
      tempData[index].open = !tempData[index].open;
    }
    this.setState({
      subscriptionAdjustments: tempData,
    });
  };

  showAddAdjustment = () => {
    this.billingRef(true);
  };

  onChangeSerialNumber = (e) => {
    this.setState({
      serialNumber: e.target.value,
    });
  };

  searchAssetData = () => {
    this.setState(
      {
        assetDataStartRecord: 1,
        assetDataPage: 1,
      },
      () => {
        this.getAssetDetails(this.state.customerDetails.partyId);
      },
    );
  };

  clearAssetDataSearch = () => {
    this.setState(
      {
        serialNumber: "",
        assetDataStartRecord: 1,
        assetDataPage: 1,
      },
      () => {
        this.getAssetDetails(this.state.customerDetails.partyId);
      },
    );
  };

  onAssetSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.setState(
        {
          assetDataStartRecord: 1,
          assetDataPage: 1,
        },
        () => {
          this.getAssetDetails(this.state.customerDetails.partyId);
        },
      );
    }
  };

  // addons methods
  clearAddonsFilters = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        addonsFilters: {
          productName: "",
          addonId: "",
          orderId: "",
        },
        addonsPage: 1,
        addonsStartRecord: 1,
      },
      () => {
        this.getCustomerAddons(jsonData);
      },
    );
  };
  filterAddonsTable = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        addonsPage: 1,
        addonsStartRecord: 1,
      },
      () => {
        this.getCustomerAddons(jsonData);
      },
    );
  };
  onAddonsSearchKeyDownInput = (e) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    if (e.key === "Enter") {
      this.setState(
        {
          addonsPage: 1,
          addonsStartRecord: 1,
        },
        () => {
          this.getCustomerAddons(jsonData);
        },
      );
    }
  };
  onChangeAddonsFilters = (e) => {
    var filters = { ...this.state.addonsFilters };
    filters[e.target.name] = e.target.value;
    this.setState({
      addonsFilters: filters,
    });
  };
  updateAddonsSorting = (by) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    if (by === this.state.sortByAddons) {
      this.setState(
        {
          loading: true,
          sortOrderAddons:
            this.state.sortOrderAddons === "DESC" ? "ASC" : "DESC",

          addonsPage: 1,
          addonsStartRecord: 1,
        },
        () => {
          this.getCustomerAddons(jsonData);
        },
      );
    } else {
      this.setState(
        {
          loading: true,
          sortByAddons: by,
          sortOrderAddons: "ASC",

          addonsPage: 1,
          addonsStartRecord: 1,
        },
        () => {
          this.getCustomerAddons(jsonData);
        },
      );
    }
  };
  updateAddonsRowsPerPage = (event) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        addonsPage: 1,
        addonsStartRecord: 1,
        addonsRowsPerPage: event.target.value,
      },
      () => {
        this.getCustomerAddons(jsonData);
      },
    );
  };
  changeAddonsPage = (event, newPage) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
    };
    this.setState(
      {
        addonsPage: newPage,
        addonsStartRecord: this.state.addonsRowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getCustomerAddons(jsonData);
      },
    );
  };

  //orders functions
  clearOrdersFilters = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        ordersPage: 1,
        ordersStartRecord: 1,
        ordersFilters: {
          orderId: "",
          orderStatus: "",
        },
      },
      () => {
        this.getCustomerOrders(jsonData);
      },
    );
  };
  filterOrdersTable = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        ordersPage: 1,
        ordersStartRecord: 1,
        ordersFilters: {
          orderId: this.state.ordersFilters.orderId,
          orderStatus: this.state.ordersFilters.orderStatus,
        },
      },
      () => {
        this.getCustomerOrders(jsonData);
      },
    );
  };
  refreshCustomerOrdersTable = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        ordersFilters: {
          orderId: "",
          orderStatus: "",
        },
        ordersPage: 1,
        OrdersStartRecord: 1,
        sortByOrders: "orderDate",
        sortOrderOrders: "DESC",
      },
      () => {
        this.getCustomerOrders(jsonData);
      },
    );
  };
  onOrdersSearchKeyDownInput = (e) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    if (e.key === "Enter") {
      this.setState(
        {
          ordersPage: 1,
          ordersStartRecord: 1,
          ordersFilters: {
            orderId: this.state.ordersFilters.orderId,
            orderStatus: this.state.ordersFilters.orderStatus,
          },
        },
        () => {
          this.getCustomerOrders(jsonData);
        },
      );
    }
  };
  onChangeOrdersFilters = (e) => {
    var filters = { ...this.state.ordersFilters };
    filters[e.target.name] = e.target.value;
    this.setState({
      ordersFilters: filters,
    });
  };
  updateOrdersSorting = (by) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    if (by === this.state.sortByOrders) {
      this.setState(
        {
          loading: true,
          sortOrderOrders:
            this.state.sortOrderOrders === "DESC" ? "ASC" : "DESC",

          ordersPage: 1,
          ordersStartRecord: 1,
        },
        () => {
          this.getCustomerOrders(jsonData);
        },
      );
    } else {
      this.setState(
        {
          loading: true,
          sortByOrders: by,
          sortOrderOrders: "ASC",

          ordersPage: 1,
          ordersStartRecord: 1,
        },
        () => {
          this.getCustomerOrders(jsonData);
        },
      );
    }
  };
  updateOrdersRowsPerPage = (event) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        ordersPage: 1,
        ordersStartRecord: 1,
        ordersRowsPerPage: event.target.value,
      },
      () => {
        this.getCustomerOrders(jsonData);
      },
    );
  };
  changeOrdersPage = (event, newPage) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        ordersPage: newPage,
        ordersStartRecord: this.state.ordersRowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getCustomerOrders(jsonData);
      },
    );
  };

  //quote functions
  clearQuotesFilters = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        quotesPage: 1,
        quotesStartRecord: 1,
        quotesFilters: {
          quoteId: "",
          quoteStatus: "",
          quoteType: "",
        },
      },
      () => {
        this.getCustomerQuotes(jsonData);
      },
    );
  };
  filterQuotesTable = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        quotesPage: 1,
        quotesStartRecord: 1,
        quotesFilters: {
          quoteId: this.state.quotesFilters.quoteId,
          quoteStatus: this.state.quotesFilters.quoteStatus,
          quoteType: this.state.quotesFilters.quoteType,
        },
      },
      () => {
        this.getCustomerQuotes(jsonData);
      },
    );
  };
  refreshCustomerQuotesTable = () => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        quotesFilters: {
          quoteId: "",
          quoteStatus: "",
          quoteType: "",
        },
        quotesPage: 1,
        quotesStartRecord: 1,
        sortByQuotes: "createdTxStamp",
        sortOrderQutoes: "DESC",
      },
      () => {
        this.getCustomerQuotes(jsonData);
      },
    );
  };
  onQuotesSearchKeyDownInput = (e) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    if (e.key === "Enter") {
      this.setState(
        {
          quotesPage: 1,
          quotesStartRecord: 1,
          quotesFilters: {
            quoteId: this.state.quotesFilters.quoteId,
            qutoeStatus: this.state.quotesFilters.quoteStatus,
            quoteType: this.state.quotesFilters.quoteType,
          },
        },
        () => {
          this.getCustomerQuotes(jsonData);
        },
      );
    }
  };
  onChangeQuotesFilters = (e) => {
    var filters = { ...this.state.quotesFilters };
    filters[e.target.name] = e.target.value;
    this.setState({
      quotesFilters: filters,
    });
  };
  updateQuotesSorting = (by) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    if (by === this.state.sortByQuotes) {
      this.setState(
        {
          loading: true,
          sortOrderQuotes:
            this.state.sortOrderQuotes === "DESC" ? "ASC" : "DESC",

          quotesPage: 1,
          quotesStartRecord: 1,
        },
        () => {
          this.getCustomerQuotes(jsonData);
        },
      );
    } else {
      this.setState(
        {
          loading: true,
          sortByQuotes: by,
          sortOrderQuotes: "ASC",

          quotesPage: 1,
          quotesStartRecord: 1,
        },
        () => {
          this.getCustomerQuotes(jsonData);
        },
      );
    }
  };
  updateQuotesRowsPerPage = (event) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        quotesPage: 1,
        quoteStartRecord: 1,
        quotesRowsPerPage: event.target.value,
      },
      () => {
        this.getCustomerQuotes(jsonData);
      },
    );
  };
  changeQuotesPage = (event, newPage) => {
    var jsonData = {
      partyId: this.state.showChildItem
        ? this.state.childItemDetails.partyId
        : this.state.customerDetails.partyId,
      // ban: this.state.showChildItem ? '' : this.state.customerDetails.ban,
    };
    this.setState(
      {
        quotesPage: newPage,
        quotesStartRecord: this.state.quotesRowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getCustomerQuotes(jsonData);
      },
    );
  };

  toggleShowMyCustomers = (e) => {
    const isMyCustomers = e.target.value === "true"; // convert string to boolean
    this.setState(
      {
        showMyCustomers: isMyCustomers,
        ordersData: [],
        totalOrdersCount: 0,
        customerDetails: {},
        subscriptionData: [],
        totalSubscriptionCount: 0,
        addonsData: [],
        totalAddonsCount: 0,
        quotesData: [],
        totalQuotesCount: 0,
        subscriptionAdjustments: [],
        totalOrderCount: 0,
        totalInvoiceCount: 0,
        invoiceHistoryData: [],
        billingData: {},
      },
      () => {
        localStorage.setItem("showMyCustomers", isMyCustomers);
        this.getCustomersHierarchy();
      },
    );
  };
  handleSwitchChange = (e) => {
    this.setState({
      custCodeAvailable: e.target.checked,
    });
  };

  getUpcomingInvoices = () => {
    const payload = {
      partyId: this.state.customerDetails.partyId,
      ban: this.state.customerDetails.ban,
    }
    this.setState({
      loading: true
    })
    console.log("payload", payload);
    BusApiCall('POST', `${constants.busInternalUrl}/passthru/UPCOMING_BILL/endpoint`, payload).then(res => {
      console.log("res- view upcoming", res.data);
      if (res?.data?.invoicePdf && res?.data?.invoicePdf?.length > 0) {
        this.setState({
          selectedFileToView: {
            base64: res.data.invoicePdf,
            mimeType: 'application/pdf',
            name: 'upcoming-bill.pdf'
          },
          showFileData: true
        })
      }
      this.setState({
        loading: false
      })
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.message) {
        this.props.setErrorMessage(err.response.data.message, false)
      } else {
        this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
      }
      this.setState({
        loading: false
      })
    })
  }

  getUpcomingInvoices = () => {
    const payload = {
      partyId: this.state.customerDetails.partyId,
      ban: this.state.customerDetails.ban,
    }
    this.setState({
      loading: true
    })
    console.log("payload", payload);
    BusApiCall('POST', `${constants.busInternalUrl}/passthru/UPCOMING_BILL/endpoint`, payload).then(res => {
      console.log("res- view upcoming", res.data);
      if (res?.data?.invoicePdf && res?.data?.invoicePdf?.length > 0) {
        this.setState({
          selectedFileToView: {
            base64: res.data.invoicePdf,
            mimeType: 'application/pdf',
            name: 'upcoming-bill.pdf'
          },
          showFileData: true
        })
      }
      this.setState({
        loading: false
      })
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.message) {
        this.props.setErrorMessage(err.response.data.message, false)
      } else {
        this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
      }
      this.setState({
        loading: false
      })
    })
  }

  onSettlementSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterSettlementTable();
    }
  }
  onSettlementChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  filterSettlementTable = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        settlementPage: 1,
        settlementStartRecord: 1,
      },
      () => {
        this.getCustomerSettlements();
      },
    );
  };

  clearSettlementsFilters = () => {
    this.setState(
      {
        solutionProviderName: '',
        itemDescription: '',
        settlementOrderId: '',
        fromDate: "",
        toDate: "",
        settlementPage: 1,
        settlementStartRecord: 1,
      },
      () => {
        this.getCustomerSettlements();
      },
    );
  }
  updateSettlementSorting = (by) => {
    if (by === this.state.settlemtnSortBy) {
      this.setState(
        {
          settlementSortOrder: this.state.settlementSortOrder === "DESC" ? "ASC" : "DESC",
          settlementPage: 1,
          settlementStartRecord: 1,
        },
        () => {
          this.getCustomerSettlements();
        },
      );
    } else {
      this.setState(
        {
          settlemtnSortBy: by,
          settlementSortOrder: "ASC",
          settlementPage: 1,
          settlementStartRecord: 1,
        },
        () => {
          this.getCustomerSettlements();
        },
      );
    }
  };
  handleSettlementChangePage = (event, newPage) => {
    this.setState(
      {
        settlementPage: newPage,
        settlementStartRecord: this.state.settlementRowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getCustomerSettlements();
      },
    );
  }
  handleSettlementChangeRowsPerPage = (event) => {
    this.setState(
      {
        settlementPage: 1,
        settlementRowsPerPage: event.target.value,
        settlementStartRecord: 1,
      },
      () => {
        this.getCustomerSettlements();
      },
    );
  }

  render() {
    const { t } = this.props;
    const mainStyle = {
      margin: "0",
      padding: "0",
    };
    const { classes: jssClasses } = this.props;
    // const sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
    const sideMenu = this.props.sideMenu;
    const moveItemMessageText = this.state.moveItemMessageText;
    // console.log('thi.props.screen=====', this.props.screen, this.props.subScreen, this.props.isMobile )
    const customerList = (
      <div>
        <Grid
          item
          size={{
            xs: 12,
            md:
              this.props.screen === "products" ||
                this.props.screen === "createOffering"
                ? 12
                : 3,
          }}
          style={{ borderRight: "1px solid lightgrey", padding: "1rem" }}
        >
          <div>
            <>
              <ThemeProvider theme={theme}>
                <Grid container spacing={1}>
                  {this.props.providerType === "SOLUTION_PROVIDER" && (
                    <Grid item size={{ xs: 12 }}>
                      <div className={classes.searchInputDiv}>
                        <Select
                          style={{ width: "100%", marginBottom: "10px" }}
                          native
                          size={"small"}
                          variant={"outlined"}
                          name={"tenant"}
                          inputProps={{
                            name: "tenant",
                            id: "outlined-native-tenant",
                          }}
                          //value={(a) => a.value}
                          value={this.state.tenant}
                          onChange={(e) => {
                            this.onChange(e);
                          }}
                          onKeyDown={(e) => {
                            this.onSearchKeyDown(e);
                          }}
                          // disabled={
                          //   this.props.parentTenantId 
                          //   &&
                          //   this.props.screen !== "orders"
                          // }
                          selectClass={
                            classes.inputClass +
                            " " +
                            classes.statusSelectBg +
                            " " +
                            classes.searchOrderSelect
                          }
                        >
                          {this.state.tenantList.map((a) => (
                            <option key={a.tenantId} value={a.tenantId}>
                              {a.tenantName}
                            </option>
                          ))}
                        </Select>
                      </div>
                    </Grid>
                  )}
                  {/* <div style={{display: 'flex'}}> */}
                  <Grid
                    item
                    size={{ xs: 10, md: 8 }}
                    justifyContent="space-between"
                  >
                    <div
                      className={classes.hierarchyFilterInput}
                      style={{ width: "100%" }}
                    >
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("SEARCH_BY_NAME")}
                        value={this.state.name}
                        name={"name"}
                        onChange={(e) => {
                          this.onSearchChange(e);
                        }}
                        divClass={classes.inputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 2,
                      md: 4,
                    }}
                  >
                    <div
                      className={classes.hierarchyFilterButtons}
                      style={{
                        width:
                          this.props.screen === "billing" ||
                            this.props.screen === "products" ||
                            this.props.screen === "createOffering"
                            ? "80px"
                            : "auto",
                        display: "flex",
                        flexWrap: "nowrap",
                      }}
                    >
                      <Tooltip title={t("SEARCH")}>
                        <IconButton
                          className="buttonSecondary"
                          onClick={this.filterHierarchy}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("CLEAR")}>
                        <IconButton
                          className="buttonSecondary"
                          onClick={this.clearHierarchyFilters}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>
                      {this.props.screen !== "billing" &&
                        this.props.screen !== "products" &&
                        this.props.screen !== "createOffering" && (
                          <>
                            &nbsp;
                            <Tooltip title={t("EXPAND_ALL")}>
                              <IconButton
                                className="buttonSecondary"
                                onClick={this.enpandAllCustomers}
                              >
                                <ExpandAll />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                    </div>
                  </Grid>
                  {/* </div> */}
                </Grid>
                <Divider style={{ marginTop: "1rem" }} />
                {/* <div className={'cl'}></div> */}
                <div
                  className={
                    styles.scrollable_panel + " " + styles.custom_tree_ui
                  }
                >
                  {/* <div className={styles.current}>
                                                        <p>
                                                            Current node:{" "}
                                                            <span className={styles.currentLabel}>
                                                                {this.state.selectedCustomerNodes.length === 0
                                                                    ? "none"
                                                                    : this.state.selectedCustomerNodes.map((n) => n.accountName).join(", ")}
                                                            </span>
                                                        </p>
                                                    </div> */}
                  {this.state.showHierarchy && (
                    <RemoveSelection deSelect={this.deSelect}>
                      <Tree
                        tree={this.state.customerTreeData}
                        rootId={0}
                        initialOpen={this.state.initialOpen}
                        render={(node, { depth, isOpen, onToggle }) => (
                          <CustomNode
                            node={node}
                            depth={depth}
                            isOpen={isOpen}
                            isSelected={
                              !!this.state.selectedCustomerNodes.find(
                                (n) => n.id === node.id,
                              )
                            }
                            onToggle={onToggle}
                            onSelect={this.handleSelectCustomer}
                            onSelectMouseDown={
                              this.handleSelectMouseDownCustomer
                            }
                            addChildItem={this.addChildItem}
                            screen={this.props.screen}
                            subScreen={this.props.subScreen}
                            selectCustomers={this.props.selectCustomers}
                            customerData={this.props.customerData}
                            userPerms={this.props.permissions}
                            hierarchyLevel={this.state.hierarchyLevel}
                            preSelectedCustomer={
                              this.props.preSelectedCustomer
                                ? this.props.preSelectedCustomer
                                : ""
                            }
                            providerType={this.props.providerType}
                            isMobile={this.props.isMobile}
                            toggleShowCustomerList={
                              this.props.toggleShowCustomerList
                            }
                            offeringState={this.props.offeringState}
                          />
                        )}
                        dragPreviewRender={(monitorProps) => (
                          <CustomDragPreview monitorProps={monitorProps} />
                        )}
                        onDrop={this.handleDropCustomer}
                        classes={{
                          draggingSource: styles.draggingSource,
                          dropTarget: styles.dropTarget,
                        }}
                        canDrag={() => this.state.enableDnd}
                      />
                    </RemoveSelection>
                  )}
                </div>

                {this.state.customerList.length === 0 && (
                  <div style={{ marginTop: "15px" }} align="center">
                    {t("NO_RESULT_FOUND")}
                  </div>
                )}
              </ThemeProvider>
            </>
            {/* Pagination */}
            <div style={{ marginTop: "1rem" }}>
              <Divider />
            </div>
            <div className="global-custom-pagination">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <label style={{ float: "left", padding: "5px" }}>
                  {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalRowsCount)}
                </label>
                {this.state.customerList.length > 0 && (
                  <label style={{ padding: " 0px 5px 5px 5px" }}>
                    {/* Rows per page select */}
                    {t("ROWS_PER_PAGE")}
                    <Select
                      value={this.state.rowsPerPage}
                      onChange={this.handleChangeRowsPerPage}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </label>
                )}
              </div>
              {/* Pagination component */}
              {this.state.totalRowsCount > this.state.rowsPerPage && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  {/* <Pagination count={Math.ceil(this.state.totalRowsCount / this.state.rowsPerPage)} onChange={this.handleChangePage} page={this.state.page} showFirstButton showLastButton /> */}
                  <Pagination
                    count={Math.ceil(
                      this.state.totalRowsCount / this.state.rowsPerPage,
                    )}
                    onChange={this.handleChangePage}
                    page={this.state.page}
                    shape="rounded"
                    tenantData={this.props.tenantData}
                    siblingCount={0}
                    // showFirstButton
                    // showLastButton
                    size="small"
                  />
                </div>
              )}
            </div>
          </div>
        </Grid>
      </div>
    );

    return (
      <>
        <div
          style={{
            ...mainStyle,
            minHeight: window.location.pathname === "/createPackage" && "200px",
          }}
        >
          {this.props.screen === "checkout" &&
            this.props.subScreen !== "product" && (
              <div className={"newContentWrapper checkPageContentWrapper"}>
                <div className={"breadcrumbWrapper"}>
                  <div className={"breadcrumbContent"}>
                    <Grid container>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <Breadcrumb list={this.state.bread} />
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </div>
            )}

          {this.state.renderView && (
            <>
              {this.props.viewMode && this.props.viewMode === "Table" ? (
                <>
                  <ManageCustomerTableView
                    customerList={this.state.customerList}
                    rowsPerPage={this.state.rowsPerPage}
                    handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                    totalRowsCount={this.state.totalRowsCount}
                    handleChangePage={this.handleChangePage}
                    createLeadQuote={this.props.createLeadQuote}
                    onSearchChange={this.onSearchChange}
                    onSearchKeyDown={this.onSearchKeyDown}
                    name={this.state.name}
                    showMyCustomers={this.state.showMyCustomers}
                    toggleShowMyCustomers={this.toggleShowMyCustomers}
                    showMyCustomersEnabled={this.props.showMyCustomersEnabled}
                    clearHierarchyFilters={this.clearHierarchyFilters}
                    filterHierarchy={this.filterHierarchy}
                    tenant={this.state.tenant}
                    parentTenantId={this.props.parentTenantId}
                    screen={this.props.screen}
                    tenantList={this.state.tenantList}
                    onChange={this.onChange}
                  />
                </>
              ) : (
                <div
                  style={{
                    borderRadius: "8px",
                    border: "1px solid lightgrey",
                    background: "white",
                    marginBottom: "40px",
                  }}
                >
                  <div style={{ display: 'block' }}>
                    <Grid container spacing={0}>
                      <>
                        {!this.props.isMobile ? (
                          this.props.screen === "products" ||
                            this.props.screen === "createOffering" ? (
                            <Grid
                              item
                              style={{ padding: "1rem" }}
                              size={{
                                xs: 12,
                                md: 12,
                              }}
                            >
                              <div>
                                <>
                                  <ThemeProvider theme={theme}>
                                    <Grid container spacing={1}>
                                      {this.props.providerType ===
                                        "SOLUTION_PROVIDER" && (
                                          <Grid
                                            item
                                            size={{
                                              xs: 12,
                                              md: 12,
                                            }}
                                          >
                                            <div
                                              className={classes.searchInputDiv}
                                            >
                                              <Select
                                                style={{
                                                  width: "100%",
                                                  marginBottom: "10px",
                                                }}
                                                native
                                                size={"small"}
                                                variant={"outlined"}
                                                name={"tenant"}
                                                inputProps={{
                                                  name: "tenant",
                                                  id: "outlined-native-tenant",
                                                }}
                                                //value={(a) => a.value}
                                                value={this.state.tenant}
                                                onChange={(e) => {
                                                  this.onChange(e);
                                                }}
                                                onKeyDown={(e) => {
                                                  this.onSearchKeyDown(e);
                                                }}
                                                // disabled={
                                                //   this.props.parentTenantId
                                                //   &&
                                                //   this.props.screen !== "orders"
                                                // }
                                                selectClass={
                                                  classes.inputClass +
                                                  " " +
                                                  classes.statusSelectBg +
                                                  " " +
                                                  classes.searchOrderSelect
                                                }
                                              >
                                                {this.state.tenantList.map(
                                                  (a) => (
                                                    <option
                                                      key={a.tenantId}
                                                      value={a.tenantId}
                                                    >
                                                      {a.tenantName}
                                                    </option>
                                                  ),
                                                )}
                                              </Select>
                                            </div>
                                          </Grid>
                                        )}

                                      {this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER") && this.props.screen === 'settlementView' && (
                                        <Grid
                                          item
                                          size={{
                                            xs: 12,
                                            md: 12,
                                          }}
                                        >
                                          <div
                                            className={classes.searchInputDiv}
                                          >
                                            <Select
                                              style={{
                                                width: "100%",
                                                marginBottom: "10px",
                                              }}
                                              native
                                              size={"small"}
                                              variant={"outlined"}
                                              name={"tenant"}
                                              inputProps={{
                                                name: "tenant",
                                                id: "outlined-native-tenant",
                                              }}
                                              //value={(a) => a.value}
                                              value={this.state.tenant}
                                              onChange={(e) => {
                                                this.onChange(e);
                                              }}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                              disabled={
                                                this.props.parentTenantId
                                                // &&
                                                // this.props.screen !== "orders"
                                              }
                                              selectClass={
                                                classes.inputClass +
                                                " " +
                                                classes.statusSelectBg +
                                                " " +
                                                classes.searchOrderSelect
                                              }
                                            >
                                              {this.state.tenantList.map(
                                                (a) => (
                                                  <option
                                                    key={a.tenantId}
                                                    value={a.tenantId}
                                                  >
                                                    {a.tenantName}
                                                  </option>
                                                ),
                                              )}
                                            </Select>
                                          </div>
                                        </Grid>
                                      )}

                                      {/* show my customers toggle */}
                                      {this.props.showMyCustomersEnabled &&
                                        !(
                                          this.props.screen === "products" &&
                                          (this.props.subScreen === "product" ||
                                            this.props.subScreen ===
                                            "productsFilter")
                                        ) && (
                                          <>
                                            {this.props.screen === 'settlementView' ? '' :
                                              <Grid
                                                item
                                                size={{
                                                  xs: 12,
                                                  md: 12,
                                                }}
                                              >
                                                <div
                                                  className={classes.searchInputDiv}
                                                >
                                                  <Select
                                                    style={{
                                                      width: "100%",
                                                      marginBottom: "10px",
                                                    }}
                                                    native
                                                    size={"small"}
                                                    variant={"outlined"}
                                                    name={"showMyCustomers"}
                                                    inputProps={{
                                                      name: "showMyCustomers",
                                                      id: "outlined-native-showMyCustomers",
                                                    }}
                                                    //value={(a) => a.value}
                                                    value={
                                                      this.state.showMyCustomers
                                                    }
                                                    onChange={
                                                      this.toggleShowMyCustomers
                                                    }
                                                    // disabled={this.props.parentTenantId}
                                                    selectClass={
                                                      classes.inputClass +
                                                      " " +
                                                      classes.statusSelectBg +
                                                      " " +
                                                      classes.searchOrderSelect
                                                    }
                                                  >
                                                    {window.location.pathname.includes(
                                                      "/manageLeads",
                                                    ) ? (
                                                      <>
                                                        <option value="true">
                                                          {t("MY_LEADS")}
                                                        </option>
                                                        <option value="false">
                                                          {t("ALL_LEADS")}
                                                        </option>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <option value="true">
                                                          {t("MY_CUSTOMERS")}
                                                        </option>
                                                        <option value="false">
                                                          {t("ALL_CUSTOMERS")}
                                                        </option>
                                                      </>
                                                    )}
                                                  </Select>
                                                </div>
                                              </Grid>
                                            }
                                          </>
                                        )}
                                      {/* <div style={{display: 'flex'}}> */}
                                      <Grid
                                        item
                                        style={{
                                          display: "flex",
                                          flexWrap: "nowrap",
                                        }}
                                        size={{
                                          xs: 12,
                                          md: 12,
                                        }}
                                      >
                                        {/* <div className={classes.hierarchyFilterInput} style={{ width: '100%' }}> */}
                                        <Input
                                          size={"small"}
                                          variant={"outlined"}
                                          placeholder={
                                            window.location.pathname.includes(
                                              "/manageLeads",
                                            )
                                              ? t("SEARCH_BY_LEAD_NAME")
                                              : t("SEARCH_BY_NAME")
                                          }
                                          value={this.state.name}
                                          name={"name"}
                                          onChange={(e) => {
                                            this.onSearchChange(e);
                                          }}
                                          divClass={classes.inputClass}
                                          onKeyDown={(e) => {
                                            this.onSearchKeyDown(e);
                                          }}
                                        />
                                        &nbsp;
                                        {/* </div> */}
                                        {/* </Grid>
                                                                <Grid item xs={3} md={3}> */}
                                        {/* <div className={classes.hierarchyFilterButtons} style={{ width: (this.props.screen === 'billing' || this.props.screen === 'products' || this.props.screen === 'createOffering') ? '80px' : 'auto', display: 'flex', flexWrap: 'nowrap' }}> */}
                                        <Tooltip title={t("SEARCH")}>
                                          <IconButton
                                            className="buttonSecondary"
                                            onClick={this.filterHierarchy}
                                          >
                                            <SearchIcon />
                                          </IconButton>
                                        </Tooltip>{" "}
                                        &nbsp;
                                        <Tooltip title={t("CLEAR")}>
                                          <IconButton
                                            className="buttonSecondary"
                                            onClick={this.clearHierarchyFilters}
                                          >
                                            <ClearIcon />
                                          </IconButton>
                                        </Tooltip>
                                        {this.props.screen !== "billing" &&
                                          this.props.screen !== "products" &&
                                          this.props.screen !==
                                          "createOffering" && (
                                            <>
                                              &nbsp;
                                              <Tooltip title={t("EXPAND_ALL")}>
                                                <IconButton
                                                  className="buttonSecondary"
                                                  onClick={
                                                    this.enpandAllCustomers
                                                  }
                                                >
                                                  <ExpandAll />
                                                </IconButton>
                                              </Tooltip>
                                            </>
                                          )}
                                        {/* </div> */}
                                      </Grid>
                                      {/* </div> */}
                                    </Grid>
                                    <Divider style={{ marginTop: "1rem" }} />
                                    {/* <div className={'cl'}></div> */}
                                    <div
                                      className={
                                        styles.scrollable_panel +
                                        " " +
                                        styles.custom_tree_ui
                                      }
                                    >
                                      {/* <div className={styles.current}>
                                                            <p>
                                                                Current node:{" "}
                                                                <span className={styles.currentLabel}>
                                                                    {this.state.selectedCustomerNodes.length === 0
                                                                        ? "none"
                                                                        : this.state.selectedCustomerNodes.map((n) => n.accountName).join(", ")}
                                                                </span>
                                                            </p>
                                                        </div> */}
                                      {this.state.showHierarchy && (
                                        <RemoveSelection
                                          deSelect={this.deSelect}
                                        >
                                          <Tree
                                            tree={this.state.customerTreeData}
                                            rootId={0}
                                            initialOpen={this.state.initialOpen}
                                            render={(
                                              node,
                                              { depth, isOpen, onToggle },
                                            ) => (
                                              <CustomNode
                                                node={node}
                                                depth={depth}
                                                isOpen={isOpen}
                                                isSelected={
                                                  !!this.state.selectedCustomerNodes.find(
                                                    (n) => n.id === node.id,
                                                  )
                                                }
                                                onToggle={onToggle}
                                                onSelect={
                                                  this.handleSelectCustomer
                                                }
                                                onSelectMouseDown={
                                                  this
                                                    .handleSelectMouseDownCustomer
                                                }
                                                addChildItem={this.addChildItem}
                                                screen={this.props.screen}
                                                subScreen={this.props.subScreen}
                                                selectCustomers={
                                                  this.props.selectCustomers
                                                }
                                                customerData={
                                                  this.props.customerData
                                                }
                                                userPerms={
                                                  this.props.permissions
                                                }
                                                hierarchyLevel={
                                                  this.state.hierarchyLevel
                                                }
                                                preSelectedCustomer={
                                                  this.props.preSelectedCustomer
                                                    ? this.props
                                                      .preSelectedCustomer
                                                    : ""
                                                }
                                                providerType={
                                                  this.props.providerType
                                                }
                                                isMobile={this.props.isMobile}
                                                offeringState={
                                                  this.props.offeringState
                                                }
                                              />
                                            )}
                                            dragPreviewRender={(
                                              monitorProps,
                                            ) => (
                                              <CustomDragPreview
                                                monitorProps={monitorProps}
                                              />
                                            )}
                                            onDrop={this.handleDropCustomer}
                                            classes={{
                                              draggingSource:
                                                styles.draggingSource,
                                              dropTarget: styles.dropTarget,
                                            }}
                                            canDrag={() => this.state.enableDnd}
                                          />
                                        </RemoveSelection>
                                      )}
                                    </div>

                                    {this.state.customerList.length === 0 && (
                                      <div
                                        style={{ marginTop: "15px" }}
                                        align="center"
                                      >
                                        {t("NO_RESULT_FOUND")}
                                      </div>
                                    )}
                                  </ThemeProvider>
                                </>
                                {/* Pagination */}
                                <div style={{ marginTop: "1rem" }}>
                                  <Divider />
                                </div>
                                <div className="global-custom-pagination">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexWrap: "wrap",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{ float: "left", padding: "5px" }}
                                    >
                                      {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalRowsCount)}
                                    </label>
                                    {this.state.customerList.length > 0 && (
                                      <label
                                        style={{ padding: " 0px 5px 5px 5px" }}
                                      >
                                        {/* Rows per page select */}
                                        {t("ROWS_PER_PAGE")}
                                        <Select
                                          value={this.state.rowsPerPage}
                                          onChange={
                                            this.handleChangeRowsPerPage
                                          }
                                        >
                                          <MenuItem value={10}>10</MenuItem>
                                          <MenuItem value={20}>20</MenuItem>
                                          <MenuItem value={50}>50</MenuItem>
                                          <MenuItem value={100}>100</MenuItem>
                                        </Select>
                                      </label>
                                    )}
                                  </div>
                                  {/* Pagination component */}
                                  {this.state.totalRowsCount >
                                    this.state.rowsPerPage && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          marginTop: "1rem",
                                        }}
                                      >
                                        {/* <Pagination count={Math.ceil(this.state.totalRowsCount / this.state.rowsPerPage)} onChange={this.handleChangePage} page={this.state.page} showFirstButton showLastButton /> */}
                                        <Pagination
                                          count={Math.ceil(
                                            this.state.totalRowsCount /
                                            this.state.rowsPerPage,
                                          )}
                                          onChange={this.handleChangePage}
                                          page={this.state.page}
                                          shape="rounded"
                                          tenantData={this.props.tenantData}
                                          siblingCount={0}
                                          // showFirstButton
                                          // showLastButton
                                          size="small"
                                        />
                                      </div>
                                    )}
                                </div>
                              </div>
                            </Grid>
                          ) : (
                            <Split
                              sizes={[25, 75]} // Initial sizes in percentages
                              minSize={[200, 400]} // Minimum sizes in pixels
                              expandToMin={false}
                              gutterSize={10}
                              gutterAlign="center"
                              snapOffset={30}
                              dragInterval={1}
                              direction="horizontal"
                              cursor="col-resize"
                              className="split"
                            >
                              {/* left */}
                              <div
                                style={{
                                  overflow: "auto",
                                  borderRight: "1px solid lightgrey",
                                }}
                              >
                                <Grid
                                  item
                                  style={{ padding: "1rem" }}
                                  size={{
                                    xs: 12,
                                    md: 12,
                                  }}
                                >
                                  <div>
                                    <>
                                      <ThemeProvider theme={theme}>
                                        <Grid container spacing={1}>
                                          {this.props.providerType === "SOLUTION_PROVIDER" && (
                                            <Grid
                                              item
                                              size={{
                                                xs: 12,
                                                md: 12,
                                              }}
                                            >
                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                              >
                                                <Select
                                                  style={{
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                  }}
                                                  native
                                                  size={"small"}
                                                  variant={"outlined"}
                                                  name={"tenant"}
                                                  inputProps={{
                                                    name: "tenant",
                                                    id: "outlined-native-tenant",
                                                  }}
                                                  //value={(a) => a.value}
                                                  value={this.state.tenant}
                                                  onChange={(e) => {
                                                    this.onChange(e);
                                                  }}
                                                  onKeyDown={(e) => {
                                                    this.onSearchKeyDown(e);
                                                  }}
                                                  // disabled={
                                                  //   this.props.parentTenantId
                                                    // &&
                                                    // this.props.screen !==
                                                    // "orders"
                                                  // }
                                                  selectClass={
                                                    classes.inputClass +
                                                    " " +
                                                    classes.statusSelectBg +
                                                    " " +
                                                    classes.searchOrderSelect
                                                  }
                                                >
                                                  {this.state.tenantList.map(
                                                    (a) => (
                                                      <option
                                                        key={a.tenantId}
                                                        value={a.tenantId}
                                                      >
                                                        {a.tenantName}
                                                      </option>
                                                    ),
                                                  )}
                                                </Select>
                                              </div>
                                            </Grid>
                                          )}

                                          {this.props.providerType === "SALES_CHNL_PROVIDER" && this.props.tenantRoles.includes("MASTER_PROVIDER") && this.props.screen === 'settlementView' && (
                                            <Grid
                                              item
                                              size={{
                                                xs: 12,
                                                md: 12,
                                              }}
                                            >
                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                              >
                                                <Select
                                                  style={{
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                  }}
                                                  native
                                                  size={"small"}
                                                  variant={"outlined"}
                                                  name={"tenant"}
                                                  inputProps={{
                                                    name: "tenant",
                                                    id: "outlined-native-tenant",
                                                  }}
                                                  //value={(a) => a.value}
                                                  value={this.state.tenant}
                                                  onChange={(e) => {
                                                    this.onChange(e);
                                                  }}
                                                  onKeyDown={(e) => {
                                                    this.onSearchKeyDown(e);
                                                  }}
                                                  disabled={
                                                    this.props.parentTenantId
                                                    // &&
                                                    // this.props.screen !==
                                                    // "orders"
                                                  }
                                                  selectClass={
                                                    classes.inputClass +
                                                    " " +
                                                    classes.statusSelectBg +
                                                    " " +
                                                    classes.searchOrderSelect
                                                  }
                                                >
                                                  {this.state.tenantList.map(
                                                    (a) => (
                                                      <option
                                                        key={a.tenantId}
                                                        value={a.tenantId}
                                                      >
                                                        {a.tenantName}
                                                      </option>
                                                    ),
                                                  )}
                                                </Select>
                                              </div>
                                            </Grid>
                                          )}

                                          {/* show my customers toggle */}
                                          {this.props.showMyCustomersEnabled &&
                                            !(
                                              this.props.screen ===
                                              "products" &&
                                              (this.props.subScreen ===
                                                "product" ||
                                                this.props.subScreen ===
                                                "productsFilter") && this.props.screen !== 'settlementView'
                                            ) && (
                                              <>
                                                {this.props.screen === 'settlementView' ? '' :
                                                  <Grid
                                                    item
                                                    size={{
                                                      xs: 12,
                                                      md: 12,
                                                    }}
                                                  >
                                                    <div
                                                      className={
                                                        classes.searchInputDiv
                                                      }
                                                    >
                                                      <Select
                                                        style={{
                                                          width: "100%",
                                                          marginBottom: "10px",
                                                        }}
                                                        native
                                                        size={"small"}
                                                        variant={"outlined"}
                                                        name={"showMyCustomers"}
                                                        inputProps={{
                                                          name: "showMyCustomers",
                                                          id: "outlined-native-showMyCustomers",
                                                        }}
                                                        //value={(a) => a.value}
                                                        value={
                                                          this.state.showMyCustomers
                                                        }
                                                        onChange={
                                                          this.toggleShowMyCustomers
                                                        }
                                                        // disabled={this.props.parentTenantId}
                                                        selectClass={
                                                          classes.inputClass +
                                                          " " +
                                                          classes.statusSelectBg +
                                                          " " +
                                                          classes.searchOrderSelect
                                                        }
                                                      >
                                                        {window.location.pathname.includes(
                                                          "/manageLeads",
                                                        ) ? (
                                                          <>
                                                            <option value="true">
                                                              {t("MY_LEADS")}
                                                            </option>
                                                            <option value="false">
                                                              {t("ALL_LEADS")}
                                                            </option>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <option value="true">
                                                              {t("MY_CUSTOMERS")}
                                                            </option>
                                                            <option value="false">
                                                              {t("ALL_CUSTOMERS")}
                                                            </option>
                                                          </>
                                                        )}
                                                      </Select>
                                                    </div>
                                                  </Grid>
                                                }
                                              </>
                                            )}
                                          {/* <div style={{display: 'flex'}}> */}
                                          <Grid
                                            item
                                            style={{
                                              display: "flex",
                                              flexWrap: "nowrap",
                                            }}
                                            size={{
                                              xs: 12,
                                              md: 12,
                                            }}
                                          >
                                            {/* <div className={classes.hierarchyFilterInput} style={{ width: '100%' }}> */}
                                            <Input
                                              size={"small"}
                                              variant={"outlined"}
                                              placeholder={
                                                window.location.pathname.includes(
                                                  "/manageLeads",
                                                )
                                                  ? t("SEARCH_BY_LEAD_NAME")
                                                  : t("SEARCH_BY_NAME")
                                              }
                                              value={this.state.name}
                                              name={"name"}
                                              onChange={(e) => {
                                                this.onSearchChange(e);
                                              }}
                                              divClass={classes.inputClass}
                                              onKeyDown={(e) => {
                                                this.onSearchKeyDown(e);
                                              }}
                                            />
                                            &nbsp;
                                            {/* </div> */}
                                            {/* </Grid>
                                                                <Grid item xs={3} md={3}> */}
                                            {/* <div className={classes.hierarchyFilterButtons} style={{ width: (this.props.screen === 'billing' || this.props.screen === 'products' || this.props.screen === 'createOffering') ? '80px' : 'auto', display: 'flex', flexWrap: 'nowrap' }}> */}
                                            <Tooltip title={t("SEARCH")}>
                                              <IconButton
                                                className="buttonSecondary"
                                                onClick={this.filterHierarchy}
                                              >
                                                <SearchIcon />
                                              </IconButton>
                                            </Tooltip>{" "}
                                            &nbsp;
                                            <Tooltip title={t("CLEAR")}>
                                              <IconButton
                                                className="buttonSecondary"
                                                onClick={
                                                  this.clearHierarchyFilters
                                                }
                                              >
                                                <ClearIcon />
                                              </IconButton>
                                            </Tooltip>
                                            {this.props.screen !== "billing" &&
                                              this.props.screen !==
                                              "products" &&
                                              this.props.screen !==
                                              "createOffering" && (
                                                <>
                                                  &nbsp;
                                                  <Tooltip
                                                    title={t("EXPAND_ALL")}
                                                  >
                                                    <IconButton
                                                      className="buttonSecondary"
                                                      onClick={
                                                        this.enpandAllCustomers
                                                      }
                                                    >
                                                      <ExpandAll />
                                                    </IconButton>
                                                  </Tooltip>
                                                </>
                                              )}
                                            {/* </div> */}
                                          </Grid>
                                          {/* </div> */}
                                        </Grid>
                                        <Divider
                                          style={{ marginTop: "1rem" }}
                                        />
                                        {/* <div className={'cl'}></div> */}
                                        <div
                                          className={
                                            styles.scrollable_panel +
                                            " " +
                                            styles.custom_tree_ui
                                          }
                                        >
                                          {/* <div className={styles.current}>
                                                            <p>
                                                                Current node:{" "}
                                                                <span className={styles.currentLabel}>
                                                                    {this.state.selectedCustomerNodes.length === 0
                                                                        ? "none"
                                                                        : this.state.selectedCustomerNodes.map((n) => n.accountName).join(", ")}
                                                                </span>
                                                            </p>
                                                        </div> */}
                                          {this.state.showHierarchy && (
                                            <RemoveSelection
                                              deSelect={this.deSelect}
                                            >
                                              <Tree
                                                tree={
                                                  this.state.customerTreeData
                                                }
                                                rootId={0}
                                                initialOpen={
                                                  this.state.initialOpen
                                                }
                                                render={(
                                                  node,
                                                  { depth, isOpen, onToggle },
                                                ) => (
                                                  <CustomNode
                                                    node={node}
                                                    depth={depth}
                                                    isOpen={isOpen}
                                                    isSelected={
                                                      !!this.state.selectedCustomerNodes.find(
                                                        (n) => n.id === node.id,
                                                      )
                                                    }
                                                    onToggle={onToggle}
                                                    onSelect={
                                                      this.handleSelectCustomer
                                                    }
                                                    onSelectMouseDown={
                                                      this
                                                        .handleSelectMouseDownCustomer
                                                    }
                                                    addChildItem={
                                                      this.addChildItem
                                                    }
                                                    screen={this.props.screen}
                                                    subScreen={
                                                      this.props.subScreen
                                                    }
                                                    selectCustomers={
                                                      this.props.selectCustomers
                                                    }
                                                    customerData={
                                                      this.props.customerData
                                                    }
                                                    userPerms={
                                                      this.props.permissions
                                                    }
                                                    hierarchyLevel={
                                                      this.state.hierarchyLevel
                                                    }
                                                    preSelectedCustomer={
                                                      this.props
                                                        .preSelectedCustomer
                                                        ? this.props
                                                          .preSelectedCustomer
                                                        : ""
                                                    }
                                                    providerType={
                                                      this.props.providerType
                                                    }
                                                    isMobile={
                                                      this.props.isMobile
                                                    }
                                                    offeringState={
                                                      this.props.offeringState
                                                    }
                                                  />
                                                )}
                                                dragPreviewRender={(
                                                  monitorProps,
                                                ) => (
                                                  <CustomDragPreview
                                                    monitorProps={monitorProps}
                                                  />
                                                )}
                                                onDrop={this.handleDropCustomer}
                                                classes={{
                                                  draggingSource:
                                                    styles.draggingSource,
                                                  dropTarget: styles.dropTarget,
                                                }}
                                                canDrag={() =>
                                                  this.state.enableDnd
                                                }
                                              />
                                            </RemoveSelection>
                                          )}
                                        </div>

                                        {this.state.customerList.length ===
                                          0 && (
                                            <div
                                              style={{ marginTop: "15px" }}
                                              align="center"
                                            >
                                              {t("NO_RESULT_FOUND")}
                                            </div>
                                          )}
                                      </ThemeProvider>
                                    </>
                                    {/* Pagination */}
                                    <div style={{ marginTop: "1rem" }}>
                                      <Divider />
                                    </div>
                                    <div className="global-custom-pagination">
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          flexWrap: "wrap",
                                          alignItems: "center",
                                        }}
                                      >
                                        <label
                                          style={{
                                            float: "left",
                                            padding: "5px",
                                          }}
                                        >
                                          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalRowsCount)}
                                        </label>
                                        {this.state.customerList.length > 0 && (
                                          <label
                                            style={{
                                              padding: " 0px 5px 5px 5px",
                                            }}
                                          >
                                            {/* Rows per page select */}
                                            {t("ROWS_PER_PAGE")}
                                            <Select
                                              value={this.state.rowsPerPage}
                                              onChange={
                                                this.handleChangeRowsPerPage
                                              }
                                            >
                                              <MenuItem value={10}>10</MenuItem>
                                              <MenuItem value={20}>20</MenuItem>
                                              <MenuItem value={50}>50</MenuItem>
                                              <MenuItem value={100}>
                                                100
                                              </MenuItem>
                                            </Select>
                                          </label>
                                        )}
                                      </div>
                                      {/* Pagination component */}
                                      {this.state.totalRowsCount >
                                        this.state.rowsPerPage && (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              marginTop: "1rem",
                                            }}
                                          >
                                            {/* <Pagination count={Math.ceil(this.state.totalRowsCount / this.state.rowsPerPage)} onChange={this.handleChangePage} page={this.state.page} showFirstButton showLastButton /> */}
                                            <Pagination
                                              count={Math.ceil(
                                                this.state.totalRowsCount /
                                                this.state.rowsPerPage,
                                              )}
                                              onChange={this.handleChangePage}
                                              page={this.state.page}
                                              shape="rounded"
                                              tenantData={this.props.tenantData}
                                              siblingCount={0}
                                              // showFirstButton
                                              // showLastButton
                                              size="small"
                                            />
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                              {/* right */}
                              <div style={{ overflow: "auto" }}>
                                {this.props.screen !== "products" &&
                                  this.props.screen !== "createOffering" &&
                                  !this.props.showCustomerList && (
                                    <Grid
                                      item
                                      style={{
                                        overflow: "hidden",
                                        padding: "1rem",
                                      }}
                                      size={{
                                        xs: 12,
                                        md: 12,
                                      }}
                                    >
                                      {this.state.renderView && (
                                        <>
                                          {this.props.screen === "billing" ||
                                            this.props.screen === "assetOwner" ||
                                            this.props.screen ===
                                            "subscriptions" ||
                                            this.props.screen === "orders" ||
                                            this.props.screen === "quotes" ||
                                            this.props.screen === "addonsManagement" ||
                                            this.props.screen === "settlementView" ? (
                                            <>
                                              {this.props.screen ===
                                                "billing" && (
                                                  <>
                                                    <BillingAccount
                                                      downloadInvoicePdf={
                                                        this.downloadInvoicePdf
                                                      }
                                                      data={
                                                        this.state.billingData
                                                      }
                                                      isChild={
                                                        this.state.showChildItem
                                                          ? true
                                                          : false
                                                      }
                                                      selectedCustomerPartyId={
                                                        this.state.showChildItem
                                                          ? this.state
                                                            .childItemDetails
                                                            .partyId
                                                          : this.state
                                                            .customerDetails
                                                            .partyId
                                                      }
                                                      customerDetails={
                                                        this.state.customerDetails
                                                      }
                                                      childItemDetails={
                                                        this.state
                                                          .childItemDetails
                                                      }
                                                      renderBillingView={
                                                        this.state
                                                          .renderBillingView
                                                      }
                                                      invoiceHistoryData={
                                                        this.state
                                                          .invoiceHistoryData
                                                      }
                                                      invoiceHistoryPage={
                                                        this.state
                                                          .invoiceHistoryPage
                                                      }
                                                      invoiceHistoryPerPage={
                                                        this.state
                                                          .invoiceHistoryPerPage
                                                      }
                                                      onInvoiceHistoryPageChange={
                                                        this
                                                          .onInvoiceHistoryPageChange
                                                      }
                                                      updateInvoiceSorting={
                                                        this.updateInvoiceSorting
                                                      }
                                                      updateInvoiceHistoryPerPageRows={
                                                        this
                                                          .updateInvoiceHistoryPerPageRows
                                                      }
                                                      totalInvoiceCount={
                                                        this.state
                                                          .totalInvoiceCount
                                                      }
                                                      searchingBillingData={
                                                        this.state
                                                          .searchingBillingData
                                                      }
                                                      initiateInvoicePayment={
                                                        this
                                                          .initiateInvoicePayment
                                                      }
                                                      subscriptionAdjustments={
                                                        this.state
                                                          .subscriptionAdjustments
                                                      }
                                                      totalOrderCount={
                                                        this.state.totalOrderCount
                                                      }
                                                      subscriptionPerPage={
                                                        this.state
                                                          .subsHistoryPerPage
                                                      }
                                                      subscriptionRowsPerPage={
                                                        this.state
                                                          .subscriptionRowsPerPage
                                                      }
                                                      handleSubscriptionChangeRowsPerPage={
                                                        this
                                                          .handleSubscriptionChangeRowsPerPage
                                                      }
                                                      handleSubscriptionChangePage={
                                                        this
                                                          .handleSubscriptionChangePage
                                                      }
                                                      getSubscriptionAdjustments={
                                                        this
                                                          .getSubscriptionAdjustments
                                                      }
                                                      setErrorMessage={
                                                        this.props.setErrorMessage
                                                      }
                                                      toggleAdjustmentInfo={
                                                        this.toggleAdjustmentInfo
                                                      }
                                                      userRoles={
                                                        this.props.userRoles
                                                      }
                                                      onRef={(ref) =>
                                                        (this.billingRef = ref)
                                                      }
                                                      themeColor={
                                                        this.props.tenantData
                                                          .color
                                                      }
                                                      menuPaths={
                                                        this.props.menuPaths
                                                      }
                                                      getUpcomingInvoices={this.getUpcomingInvoices}
                                                    />
                                                  </>
                                                )}

                                              {this.props.screen ===
                                                "assetOwner" && (
                                                  <>
                                                    <AssetOwnershipTable
                                                      list={this.state.assetData}
                                                      listProxy={
                                                        this.state.assetDataProxy
                                                      }
                                                      isChild={
                                                        this.state.showChildItem
                                                          ? true
                                                          : false
                                                      }
                                                      customerDetails={
                                                        this.state.customerDetails
                                                      }
                                                      childItemDetails={
                                                        this.state
                                                          .childItemDetails
                                                      }
                                                      assetDataPage={
                                                        this.state.assetDataPage
                                                      }
                                                      assetDataPerpage={
                                                        this.state
                                                          .assetDataPerpage
                                                      }
                                                      tenantId={this.state.tenant}
                                                      assetDataPageChange={
                                                        this.assetDataPageChange
                                                      }
                                                      assetDataRowsPerPageChange={
                                                        this
                                                          .assetDataRowsPerPageChange
                                                      }
                                                      totalAssetCount={
                                                        this.state.totalAssetCount
                                                      }
                                                      serialNumber={
                                                        this.state.serialNumber
                                                      }
                                                      changeSearialNumber={
                                                        this.onChangeSerialNumber
                                                      }
                                                      clearAssetDataSearch={
                                                        this.clearAssetDataSearch
                                                      }
                                                      searchAssetData={
                                                        this.searchAssetData
                                                      }
                                                      onAssetSearchKeyDown={
                                                        this.onAssetSearchKeyDown
                                                      }
                                                      openAssetData={
                                                        this.openAssetData
                                                      }
                                                    />
                                                  </>
                                                )}

                                              {this.props.screen ===
                                                "subscriptions" && (
                                                  <>
                                                    <SubscriptionsTable
                                                      totalSubscriptionCount={
                                                        this.state
                                                          .totalSubscriptionCount
                                                      }
                                                      subsHistoryPage={
                                                        this.state.subsHistoryPage
                                                      }
                                                      subsHistoryPerPage={
                                                        this.state
                                                          .subsHistoryPerPage
                                                      }
                                                      onSubsHistoryPageChange={
                                                        this
                                                          .onSubsHistoryPageChange
                                                      }
                                                      updateSubsHistoryPerPageRows={
                                                        this
                                                          .updateSubsHistoryPerPageRows
                                                      }
                                                      updateSubsSorting={
                                                        this.updateSubsSorting
                                                      }
                                                      subscriptions={
                                                        this.state
                                                          .subscriptionData
                                                      }
                                                      isChild={
                                                        this.state.showChildItem
                                                          ? true
                                                          : false
                                                      }
                                                      customerDetails={
                                                        this.state.customerDetails
                                                      }
                                                      childItemDetails={
                                                        this.state
                                                          .childItemDetails
                                                      }
                                                      openSubscription={
                                                        this.openSubscription
                                                      }
                                                      tenantId={this.state.tenant}
                                                      getCustomerSubscriptions={
                                                        this
                                                          .getCustomerSubscriptions
                                                      }
                                                      searchingSubscriptions={
                                                        this.state
                                                          .searchingSubscriptions
                                                      }
                                                      changeRoute={
                                                        this.props.changeRoute
                                                      }
                                                      sortBySubs={
                                                        this.state.sortBySubs
                                                      }
                                                      sortOrderSubs={
                                                        this.state.sortOrderSubs
                                                      }
                                                      subsFilters={
                                                        this.state.subsFilters
                                                      }
                                                      clearSubsTableSearch={
                                                        this.clearSubsTableSearch
                                                      }
                                                      filterSubsTable={
                                                        this.filterSubsTable
                                                      }
                                                      onChangeSubsInput={
                                                        this.onChangeSubsInput
                                                      }
                                                      onSearchKeyDownSubsInput={
                                                        this
                                                          .onSearchKeyDownSubsInput
                                                      }
                                                      goToQuote={
                                                        this.props.goToQuote
                                                      }
                                                      expandItemHistory={
                                                        this.expandItemHistory
                                                      }
                                                      handleSearchIdentifierChange={this.handleSearchIdentifierChange}
                                                      searchIdentifierValues={this.state.searchIdentifierValues}
                                                      screen={'customerView'}
                                                    />
                                                  </>
                                                )}
                                              {this.props.screen ===
                                                "addonsManagement" && (
                                                  <>
                                                    <AddonsTable
                                                      data={this.state.addonsData}
                                                      isChild={
                                                        this.state.showChildItem
                                                          ? true
                                                          : false
                                                      }
                                                      customerDetails={
                                                        this.state.customerDetails
                                                      }
                                                      childItemDetails={
                                                        this.state
                                                          .childItemDetails
                                                      }
                                                      tenantId={this.state.tenant}
                                                      getCustomerAddons={
                                                        this.getCustomerAddons
                                                      }
                                                      changeRoute={
                                                        this.props.changeRoute
                                                      }
                                                      sortBy={
                                                        this.state.sortByAddons
                                                      }
                                                      sortOrder={
                                                        this.state.sortOrderAddons
                                                      }
                                                      updateSorting={
                                                        this.updateAddonsSorting
                                                      }
                                                      filters={
                                                        this.state.addonsFilters
                                                      }
                                                      clearAddonsFilters={
                                                        this.clearAddonsFilters
                                                      }
                                                      filterAddonsTable={
                                                        this.filterAddonsTable
                                                      }
                                                      onChangeAddonsFilters={
                                                        this.onChangeAddonsFilters
                                                      }
                                                      onAddonsSearchKeyDownInput={
                                                        this
                                                          .onAddonsSearchKeyDownInput
                                                      }
                                                      searchingAddons={
                                                        this.state.searchingAddons
                                                      }
                                                      totalAddonsCount={
                                                        this.state
                                                          .totalAddonsCount
                                                      }
                                                      addonsRowsPerPage={
                                                        this.state
                                                          .addonsRowsPerPage
                                                      }
                                                      addonsPage={
                                                        this.state.addonsPage
                                                      }
                                                      addonsStartRecord={
                                                        this.state
                                                          .addonsStartRecord
                                                      }
                                                      updateAddonsRowsPerPage={
                                                        this
                                                          .updateAddonsRowsPerPage
                                                      }
                                                      changeAddonsPage={
                                                        this.changeAddonsPage
                                                      }
                                                      goToQuote={
                                                        this.props.goToQuote
                                                      }
                                                      openAddons={this.openAddons}
                                                    />
                                                  </>
                                                )}
                                              {this.props.screen ===
                                                "orders" && (
                                                  <>
                                                    {!this.state
                                                      .searchingOrders && (
                                                        <>
                                                          <Grid
                                                            container
                                                            spacing={2}
                                                            style={{
                                                              padding:
                                                                "1rem 1rem 0rem 1rem",
                                                            }}
                                                          >
                                                            <Grid
                                                              item
                                                              size={{
                                                                xs: 9,
                                                              }}
                                                            >
                                                              {this.state
                                                                .customerDetails &&
                                                                this.state
                                                                  .customerDetails
                                                                  .accountName && (
                                                                  <h3
                                                                    style={{
                                                                      marginTop: 0,
                                                                    }}
                                                                  >
                                                                    {/* {t("INVOICE_HISTORY")}:  */}
                                                                    {
                                                                      this.state
                                                                        .customerDetails
                                                                        .accountName
                                                                    }{" "}
                                                                    {this.props
                                                                      .providerType ===
                                                                      "SALES_CHNL_PROVIDER" &&
                                                                      `(${this.state.customerDetails.ban})`}
                                                                  </h3>
                                                                )}
                                                            </Grid>
                                                          </Grid>

                                                          <div
                                                            className={
                                                              classes.searchOuterDiv
                                                            }
                                                            style={{
                                                              marginBottom: ".5rem",
                                                              width: "100%",
                                                              alignItems: "center",
                                                            }}
                                                          >
                                                            <div
                                                              className={
                                                                classes.searchInputDiv
                                                              }
                                                            >
                                                              <Input
                                                                size={"small"}
                                                                variant={"outlined"}
                                                                placeholder={t(
                                                                  "ORDER_ID",
                                                                )}
                                                                value={
                                                                  this.state
                                                                    .ordersFilters
                                                                    .orderId
                                                                }
                                                                name={"orderId"}
                                                                onChange={(e) => {
                                                                  this.onChangeOrdersFilters(
                                                                    e,
                                                                  );
                                                                }}
                                                                divClass={
                                                                  classes.inputClass
                                                                }
                                                                onKeyDown={(e) => {
                                                                  this.onOrdersSearchKeyDownInput(
                                                                    e,
                                                                  );
                                                                }}
                                                              />
                                                            </div>
                                                            <div
                                                              className={
                                                                classes.searchInputDiv
                                                              }
                                                              style={{
                                                                maxWidth: "250px",
                                                              }}
                                                            >
                                                              <FormControl>
                                                                <Select
                                                                  native
                                                                  style={{
                                                                    width: "245px",
                                                                  }}
                                                                  variant={
                                                                    "outlined"
                                                                  }
                                                                  // name='orderStatus'
                                                                  inputProps={{
                                                                    name: "orderStatus",
                                                                    id: "outlined-native-orderStatus",
                                                                  }}
                                                                  value={
                                                                    this.state
                                                                      .ordersFilters
                                                                      .orderStatus
                                                                  }
                                                                  onChange={(e) => {
                                                                    this.onChangeOrdersFilters(
                                                                      e,
                                                                    );
                                                                  }}
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    this.onOrdersSearchKeyDownInput(
                                                                      e,
                                                                    );
                                                                  }}
                                                                  selectClass={
                                                                    classes.inputClass +
                                                                    " " +
                                                                    classes.statusSelectBg +
                                                                    " " +
                                                                    classes.searchOrderSelect
                                                                  }
                                                                >
                                                                  <option
                                                                    value={
                                                                      "All Orders"
                                                                    }
                                                                  >
                                                                    All Orders
                                                                  </option>
                                                                  {this.props
                                                                    .statusList &&
                                                                    this.props.statusList
                                                                      .sort(
                                                                        (a, b) =>
                                                                          a.value.localeCompare(
                                                                            b.value,
                                                                          ),
                                                                      )
                                                                      .map((a) => (
                                                                        <option
                                                                          key={
                                                                            a.value
                                                                          }
                                                                          value={
                                                                            a.value
                                                                          }
                                                                        >
                                                                          {a.value}
                                                                        </option>
                                                                      ))}
                                                                </Select>
                                                              </FormControl>
                                                            </div>
                                                            <div
                                                              className={
                                                                classes.searchOrderLabelOuter
                                                              }
                                                              style={{
                                                                marginTop: ".25rem",
                                                              }}
                                                            >
                                                              <div
                                                                className={
                                                                  classes.searchOrderLabelInner
                                                                }
                                                              >
                                                                <Tooltip
                                                                  title={t(
                                                                    "SEARCH",
                                                                  )}
                                                                >
                                                                  <IconButton
                                                                    className="iconButtonSecondary"
                                                                    onClick={
                                                                      this
                                                                        .filterOrdersTable
                                                                    }
                                                                  >
                                                                    <SearchIcon />
                                                                  </IconButton>
                                                                </Tooltip>{" "}
                                                                &nbsp;
                                                                <Tooltip
                                                                  title={t("CLEAR")}
                                                                >
                                                                  <IconButton
                                                                    className="iconButtonSecondary"
                                                                    onClick={
                                                                      this
                                                                        .clearOrdersFilters
                                                                    }
                                                                  >
                                                                    <ClearIcon />
                                                                  </IconButton>
                                                                </Tooltip>{" "}
                                                                &nbsp;
                                                                <Tooltip
                                                                  title={t(
                                                                    "REFRESH",
                                                                  )}
                                                                >
                                                                  <IconButton
                                                                    className="iconButtonSecondary"
                                                                    onClick={
                                                                      this
                                                                        .refreshCustomerOrdersTable
                                                                    }
                                                                  >
                                                                    <RefreshIcon />
                                                                  </IconButton>
                                                                </Tooltip>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <Card
                                                            variant="outlined"
                                                            style={{
                                                              borderRadius: "8px",
                                                              marginBottom: "40px",
                                                            }}
                                                          >
                                                            <OrderTable
                                                              view="ordersByCustomer"
                                                              orderId={
                                                                this.props.orderId
                                                              }
                                                              orders={
                                                                this.state
                                                                  .ordersData
                                                              }
                                                              openResendDialog={
                                                                this.props
                                                                  .openResendDialog
                                                              }
                                                              rowsPerPage={
                                                                this.state
                                                                  .ordersRowsPerPage
                                                              }
                                                              totalOrderCount={
                                                                this.state
                                                                  .totalOrdersCount
                                                              }
                                                              page={
                                                                this.state
                                                                  .ordersPage
                                                              }
                                                              sortBy={
                                                                this.state
                                                                  .sortByOrders
                                                              }
                                                              sortOrder={
                                                                this.state
                                                                  .sortOrderOrders
                                                              }
                                                              startRecord={
                                                                this.state
                                                                  .ordersStartRecord
                                                              }
                                                              updateSorting={
                                                                this
                                                                  .updateOrdersSorting
                                                              }
                                                              handleChangePage={
                                                                this
                                                                  .changeOrdersPage
                                                              }
                                                              handleChangeRowsPerPage={
                                                                this
                                                                  .updateOrdersRowsPerPage
                                                              }
                                                              controls={
                                                                this.props.controls
                                                              }
                                                              loggedInUserType={
                                                                this.props
                                                                  .loggedInUserType
                                                              }
                                                              tenantId={
                                                                this.state.tenant
                                                              }
                                                              providerType={
                                                                this.props
                                                                  .providerType
                                                              }
                                                            // showLoading={this.props.showLoading}
                                                            />
                                                          </Card>
                                                        </>
                                                      )}
                                                  </>
                                                )}
                                              {this.props.screen ===
                                                "quotes" && (
                                                  <>
                                                    {!this.state
                                                      .searchingQuotes && (
                                                        <>
                                                          <Grid
                                                            container
                                                            spacing={2}
                                                            style={{
                                                              padding:
                                                                "1rem 1rem 0rem 1rem",
                                                            }}
                                                          >
                                                            <Grid
                                                              item
                                                              size={{
                                                                xs: 9,
                                                              }}
                                                            >
                                                              {this.state
                                                                .customerDetails &&
                                                                this.state
                                                                  .customerDetails
                                                                  .accountName && (
                                                                  <h3
                                                                    style={{
                                                                      marginTop: 0,
                                                                    }}
                                                                  >
                                                                    {/* {t("INVOICE_HISTORY")}:  */}
                                                                    {
                                                                      this.state
                                                                        .customerDetails
                                                                        .accountName
                                                                    }{" "}
                                                                    (
                                                                    {
                                                                      this.state
                                                                        .customerDetails
                                                                        .ban
                                                                    }
                                                                    )
                                                                  </h3>
                                                                )}
                                                            </Grid>
                                                          </Grid>

                                                          <div
                                                            className={
                                                              classes.searchOuterDiv
                                                            }
                                                            style={{
                                                              marginBottom: ".5rem",
                                                              width: "100%",
                                                              alignItems: "center",
                                                            }}
                                                          >
                                                            <div
                                                              className={
                                                                classes.searchInputDiv
                                                              }
                                                            >
                                                              <Input
                                                                size={"small"}
                                                                variant={"outlined"}
                                                                placeholder={t(
                                                                  "QUOTE_ID",
                                                                )}
                                                                value={
                                                                  this.state
                                                                    .quotesFilters
                                                                    .quoteId
                                                                }
                                                                name={"quoteId"}
                                                                onChange={(e) => {
                                                                  this.onChangeQuotesFilters(
                                                                    e,
                                                                  );
                                                                }}
                                                                divClass={
                                                                  classes.inputClass
                                                                }
                                                                onKeyDown={(e) => {
                                                                  this.onQuotesSearchKeyDownInput(
                                                                    e,
                                                                  );
                                                                }}
                                                              />
                                                            </div>

                                                            <div
                                                              className={
                                                                classes.searchInputDiv
                                                              }
                                                            >
                                                              <FormControl
                                                                variant="outlined"
                                                                className="custom-select-input"
                                                                size={"small"}
                                                              >
                                                                <InputLabel htmlFor="outlined-native-quoteStatus">
                                                                  {t("STATUS")}
                                                                </InputLabel>
                                                                <Select
                                                                  native
                                                                  label="STATUS "
                                                                  value={
                                                                    this.state
                                                                      .quotesFilters
                                                                      .quoteStatus
                                                                  }
                                                                  onChange={(e) => {
                                                                    this.onChangeQuotesFilters(
                                                                      e,
                                                                    );
                                                                  }}
                                                                  inputProps={{
                                                                    name: "quoteStatus",
                                                                    id: "outlined-native-quoteStatus",
                                                                  }}
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    this.onQuotesSearchKeyDownInput(
                                                                      e,
                                                                    );
                                                                  }}
                                                                  style={{
                                                                    width: "186px",
                                                                  }}
                                                                >
                                                                  <option
                                                                    value={
                                                                      "All Quotes"
                                                                    }
                                                                  >
                                                                    {t(
                                                                      "ALL_QUOTES",
                                                                    )}
                                                                  </option>
                                                                  {this.props
                                                                    .statusList &&
                                                                    this.props.statusList.map(
                                                                      (a) => (
                                                                        <option
                                                                          key={
                                                                            a.name
                                                                          }
                                                                          value={
                                                                            a.name
                                                                          }
                                                                        >
                                                                          {a.value}
                                                                        </option>
                                                                      ),
                                                                    )}
                                                                </Select>
                                                              </FormControl>
                                                            </div>
                                                            <div
                                                              className={
                                                                classes.searchInputDiv
                                                              }
                                                            >
                                                              <FormControl
                                                                variant="outlined"
                                                                className="custom-select-input"
                                                                size={"small"}
                                                              >
                                                                <InputLabel htmlFor="outlined-native-type">
                                                                  {t("TYPE")}
                                                                </InputLabel>
                                                                <Select
                                                                  native
                                                                  label="TYPE "
                                                                  value={
                                                                    this.state
                                                                      .quotesFilters
                                                                      .quoteType
                                                                  }
                                                                  onChange={(e) => {
                                                                    this.onChangeQuotesFilters(
                                                                      e,
                                                                    );
                                                                  }}
                                                                  inputProps={{
                                                                    name: "quoteType",
                                                                    id: "outlined-native-type",
                                                                  }}
                                                                  onKeyDown={(
                                                                    e,
                                                                  ) => {
                                                                    this.onQuotesSearchKeyDownInput(
                                                                      e,
                                                                    );
                                                                  }}
                                                                  style={{
                                                                    width: "186px",
                                                                  }}
                                                                >
                                                                  {this.props
                                                                    .typeList &&
                                                                    this.props.typeList.map(
                                                                      (a) => (
                                                                        <option
                                                                          key={
                                                                            a.value
                                                                          }
                                                                          value={
                                                                            a.value
                                                                          }
                                                                        >
                                                                          {t(
                                                                            a.name,
                                                                          )}
                                                                        </option>
                                                                      ),
                                                                    )}
                                                                </Select>
                                                              </FormControl>
                                                            </div>

                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "flex-start",
                                                              }}
                                                            >
                                                              <Tooltip
                                                                title={t("SEARCH")}
                                                              >
                                                                <IconButton
                                                                  className="iconButtonSecondary"
                                                                  onClick={
                                                                    this
                                                                      .filterQuotesTable
                                                                  }
                                                                >
                                                                  <SearchIcon />
                                                                </IconButton>
                                                              </Tooltip>{" "}
                                                              &nbsp;
                                                              <Tooltip
                                                                title={t("CLEAR")}
                                                              >
                                                                <IconButton
                                                                  className="iconButtonSecondary"
                                                                  onClick={
                                                                    this
                                                                      .clearQuotesFilters
                                                                  }
                                                                >
                                                                  <ClearIcon />
                                                                </IconButton>
                                                              </Tooltip>{" "}
                                                              &nbsp;
                                                              <Tooltip
                                                                title={t("REFRESH")}
                                                              >
                                                                <IconButton
                                                                  className="iconButtonSecondary"
                                                                  onClick={
                                                                    this
                                                                      .refreshCustomerQuotesTable
                                                                  }
                                                                >
                                                                  <RefreshIcon />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                          </div>
                                                          <Card
                                                            variant="outlined"
                                                            style={{
                                                              borderRadius: "8px",
                                                              marginBottom: "40px",
                                                            }}
                                                          >
                                                            <QuoteTable
                                                              view="quotesByCustomer"
                                                              // customerName={this.state.customerName}
                                                              // customerBAN={this.state.customerBAN}
                                                              quotes={
                                                                this.state
                                                                  .quotesData
                                                              }
                                                              openResendDialog={
                                                                this.props
                                                                  .openResendDialog
                                                              }
                                                              rowsPerPage={
                                                                this.state
                                                                  .quotesRowsPerPage
                                                              }
                                                              totalQuoteCount={
                                                                this.state
                                                                  .totalQuotesCount
                                                              }
                                                              page={
                                                                this.state
                                                                  .quotesPage
                                                              }
                                                              sortBy={
                                                                this.state
                                                                  .sortByQuotes
                                                              }
                                                              sortOrder={
                                                                this.state
                                                                  .sortOrderQuotes
                                                              }
                                                              updateSorting={
                                                                this
                                                                  .updateQuotesSorting
                                                              }
                                                              handleChangePage={
                                                                this
                                                                  .changeQuotesPage
                                                              }
                                                              handleChangeRowsPerPage={
                                                                this
                                                                  .updateQuotesRowsPerPage
                                                              }
                                                              controls={
                                                                this.props.controls
                                                              }
                                                              loggedInUserType={
                                                                this.props
                                                                  .loggedInUserType
                                                              }
                                                              tenantId={
                                                                this.state.tenant
                                                              }
                                                              providerType={
                                                                this.props
                                                                  .providerType
                                                              }
                                                            // showLoading={this.state.showLoading}
                                                            />

                                                            {/* <OrderTable
                                                                                view='ordersByCustomer'
                                                                                orderId={this.props.orderId}
                                                                                orders={this.state.ordersData}
                                                                                openResendDialog={this.props.openResendDialog}

                                                                                rowsPerPage={this.state.ordersRowsPerPage}
                                                                                totalOrderCount={this.state.totalOrdersCount}
                                                                                page={this.state.ordersPage}
                                                                                sortBy={this.state.sortByOrders}
                                                                                sortOrder={this.state.sortOrderOrders}
                                                                                startRecord={this.state.ordersStartRecord}

                                                                                updateSorting={this.updateOrdersSorting}
                                                                                handleChangePage={this.changeOrdersPage}
                                                                                handleChangeRowsPerPage={this.updateOrdersRowsPerPage}
                                                                                localizeDateTime={this.props.localizeDateTime}
                                                                                controls={this.props.controls}
                                                                                loggedInUserType={this.props.loggedInUserType}
                                                                                tenantId={this.props.tenant}
                                                                                providerType={this.props.providerType}
                                                                                
                                                                            /> */}
                                                          </Card>
                                                        </>
                                                      )}
                                                  </>
                                                )}
                                              {this.props.screen === "settlementView" && (
                                                <>
                                                  {!this.state
                                                    .searchingSettlements && (
                                                      <>
                                                        <Grid
                                                          container
                                                          spacing={2}
                                                          style={{
                                                            padding:
                                                              "1rem 1rem 0rem 1rem",
                                                          }}
                                                        >
                                                          <Grid
                                                            item
                                                            size={{
                                                              xs: 9,
                                                            }}
                                                          >
                                                            {this.state
                                                              .customerDetails &&
                                                              this.state
                                                                .customerDetails
                                                                .accountName && (
                                                                <h3
                                                                  style={{
                                                                    marginTop: 0,
                                                                  }}
                                                                >
                                                                  {/* {t("INVOICE_HISTORY")}:  */}
                                                                  {
                                                                    this.state
                                                                      .customerDetails
                                                                      .accountName
                                                                  }{" "}
                                                                  {this.props
                                                                    .providerType ===
                                                                    "SALES_CHNL_PROVIDER" &&
                                                                    `(${this.state.customerDetails.ban})`}
                                                                </h3>
                                                              )}
                                                          </Grid>
                                                        </Grid>

                                                        <Paper
                                                          className={"tablePaper"}
                                                          elevation={0}
                                                          style={{ background: "transparent" }}
                                                        >
                                                          <div className={classes.searchOuterDiv}>
                                                            {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                                                              <div>
                                                                {/* <Input
                                                                  size={"small"}
                                                                  variant={"outlined"}
                                                                  placeholder={t("PROVIDER_NAME")}
                                                                  value={this.state.solutionProviderName}
                                                                  name={"solutionProviderName"}
                                                                  onChange={(e) => {
                                                                    this.onSettlementChange(e);
                                                                  }}
                                                                  divClass={classes.inputClass}
                                                                  onKeyDown={(e) => {
                                                                    this.onSettlementSearchKeyDown(e);
                                                                  }}
                                                                /> */}
                                                                <Select
                                                                  native
                                                                  size="small"
                                                                  variant="outlined"
                                                                  name="partnerId"
                                                                  value={this.state.partnerId}
                                                                  onChange={this.onSettlementChange}
                                                                  onKeyDown={this.onSettlementSearchKeyDown}
                                                                  inputProps={{
                                                                    name: "partnerId",
                                                                    id: "outlined-native-partnerId"
                                                                  }}
                                                                  style={{ width: '173px' }}
                                                                  selectClass={`${classes.inputClass} ${classes.statusSelectBg} ${classes.searchOrderSelect}`}
                                                                >
                                                                  {this.props.partnerList.map((a) => (
                                                                    <option key={a.id} value={a.id}>
                                                                      {a.groupName}
                                                                    </option>
                                                                  ))}
                                                                </Select>
                                                              </div>
                                                            )}
                                                            <div>
                                                              <Input
                                                                size={"small"}
                                                                variant={"outlined"}
                                                                placeholder={t("PRODUCT_NAME")}
                                                                value={this.state.itemDescription}
                                                                name={"itemDescription"}
                                                                onChange={(e) => {
                                                                  this.onSettlementChange(e);
                                                                }}
                                                                divClass={classes.inputClass}
                                                                onKeyDown={(e) => {
                                                                  this.onSettlementSearchKeyDown(e);
                                                                }}
                                                              />
                                                            </div>
                                                            <div>
                                                              <Input
                                                                size={"small"}
                                                                variant={"outlined"}
                                                                placeholder={t("ORDER_ID")}
                                                                value={this.state.settlementOrderId}
                                                                name={"settlementOrderId"}
                                                                onChange={(e) => {
                                                                  this.onSettlementChange(e);
                                                                }}
                                                                divClass={classes.ordInputClass}
                                                                onKeyDown={(e) => {
                                                                  this.onSettlementSearchKeyDown(e);
                                                                }}
                                                              />
                                                            </div>
                                                            <div>
                                                              <TextField
                                                                name="fromDate"
                                                                id="fromDate"
                                                                type="date"
                                                                value={this.state.fromDate}
                                                                label={t("FROM_DATE")}
                                                                InputLabelProps={{
                                                                  shrink: true,
                                                                }}
                                                                variant={"outlined"}
                                                                size={"small"}
                                                                onChange={(e) => {
                                                                  this.onSettlementChange(e);
                                                                }}
                                                                inputProps={{ max: this.state.today, format: "MM/dd/yyyy" }}
                                                                onKeyDown={(e) => {
                                                                  this.onSettlementSearchKeyDown(e);
                                                                }}
                                                                style={{ width: '120px' }}
                                                              />
                                                            </div>

                                                            <div>
                                                              <TextField
                                                                name="toDate"
                                                                id="toDate"
                                                                type="date"
                                                                value={this.state.toDate}
                                                                label={t("TO_DATE")}
                                                                InputLabelProps={{
                                                                  shrink: true,
                                                                }}
                                                                variant={"outlined"}
                                                                size={"small"}
                                                                onChange={(e) => {
                                                                  this.onSettlementChange(e);
                                                                }}
                                                                inputProps={{
                                                                  max: this.state.today,
                                                                  min: this.state.fromDate,
                                                                  format: "MM/dd/yyyy",
                                                                }}
                                                                onKeyDown={(e) => {
                                                                  this.onSettlementSearchKeyDown(e);
                                                                }}
                                                                style={{ width: '120px' }}
                                                              />
                                                            </div>
                                                            <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                              <Tooltip title={t("SEARCH")}>
                                                                <IconButton
                                                                  className="iconButtonSecondary"
                                                                  onClick={this.filterSettlementTable}
                                                                >
                                                                  <SearchIcon />
                                                                </IconButton>
                                                              </Tooltip>{" "}
                                                              &nbsp;
                                                              <Tooltip title={t("CLEAR")}>
                                                                <IconButton
                                                                  className="iconButtonSecondary"
                                                                  onClick={this.clearSettlementsFilters}
                                                                >
                                                                  <ClearIcon />
                                                                </IconButton>
                                                              </Tooltip>{" "}
                                                              &nbsp;
                                                              <Tooltip title={t("REFRESH")}>
                                                                <IconButton
                                                                  className="iconButtonSecondary"
                                                                  onClick={this.clearSettlementsFilters}
                                                                >
                                                                  <RefreshIcon />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                          </div>

                                                          <SettlementTable
                                                            list={this.state.settlementList}
                                                            rowsPerPage={this.state.settlementRowsPerPage}
                                                            totalSettlementCount={this.state.totalSettlementCount}
                                                            page={this.state.settlementPage}
                                                            handleChangePage={this.handleSettlementChangePage}
                                                            handleChangeRowsPerPage={this.handleSettlementChangeRowsPerPage}
                                                            sortBy={this.state.settlemtnSortBy}
                                                            sortOrder={this.state.settlementSortOrder}
                                                            updateSorting={this.updateSettlementSorting}
                                                            // convertDate={this.convertDate}
                                                            isValidDate={this.isValidDate}
                                                            providerType={this.props.providerType}
                                                            tenantRoles={this.props.tenantRoles}
                                                            screen={'customerView'}
                                                          />
                                                        </Paper>
                                                      </>
                                                    )}
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {this.state.customerList
                                                .length === 0 ? (
                                                <div></div>
                                              ) : (
                                                this.state.display && (
                                                  <Profile
                                                    screen={
                                                      this.props.screen ===
                                                        "checkout"
                                                        ? this.props.screen
                                                        : "manageCustomer"
                                                    }
                                                    customerDetails={
                                                      this.state.customerDetails
                                                    }
                                                    childItemDetails={
                                                      this.state
                                                        .childItemDetails
                                                    }
                                                    selectedCustomerPartyId={
                                                      this.state.showChildItem
                                                        ? this.state
                                                          .childItemDetails
                                                          .partyId
                                                        : this.state
                                                          .customerDetails
                                                          .partyId
                                                    }
                                                    addChildItem={
                                                      this.addChildItem
                                                    }
                                                    editChildItem={
                                                      this.editChildItem
                                                    }
                                                    isChild={
                                                      this.state.showChildItem
                                                        ? true
                                                        : false
                                                    }
                                                    selectedPaymentMethod={
                                                      this.props
                                                        .selectedPaymentMethod
                                                    }
                                                    getCustomersHierarchy={
                                                      this.getCustomersHierarchy
                                                    }
                                                    back={this.props.back}
                                                    stage={this.props.stage}
                                                    goNext={this.goNext}
                                                    subScreen={
                                                      this.props.subScreen
                                                    }
                                                    closeDialog={
                                                      this.props.closeDialog
                                                    }
                                                    parentTenantId={
                                                      this.state.tenant
                                                    }
                                                    manageCustomerRequired={
                                                      this.state
                                                        .manageCustomerRequired
                                                    }
                                                    isTaskMode={
                                                      this.state.isTaskMode
                                                    }
                                                    newLeadOrCustomer={
                                                      this.state
                                                        .newLeadOrCustomer
                                                    }
                                                    promoteLead={
                                                      this.promoteLead
                                                    }
                                                    sectorsList={
                                                      this.props.sectorsList
                                                    }
                                                    setSelectCallback={this.setProfileSelectCallback}
                                                  />
                                                )
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </Grid>
                                  )}
                              </div>
                            </Split>
                          )
                        ) : (
                          this.props.isMobile &&
                          (this.props.showCustomerList ? (
                            <Drawer
                              anchor="left"
                              // variant='permanant'
                              open={this.props.showCustomerList}
                              onClose={() => {
                                this.props.toggleShowCustomerList();
                              }}
                              // classes={{ paper: classes.drawerPaper }}
                              PaperProps={{
                                style: {
                                  width: "100%",
                                  maxWidth: "100vw",
                                },
                              }}
                            >
                              <div>
                                <div>
                                  <IconButton
                                    onClick={() => {
                                      this.props.toggleShowCustomerList();
                                    }}
                                  >
                                    <ChevronLeft />
                                  </IconButton>
                                </div>
                                <Card
                                  variant="outlined"
                                  className={"roundedCorners"}
                                >
                                  {customerList}
                                </Card>
                              </div>
                            </Drawer>
                          ) : (
                            this.props.screen !== "products" &&
                            this.props.screen !== "createOffering" &&
                            !this.props.showCustomerList &&
                            // <Grid item xs={12} md={12} style={{ overflow: 'hidden', padding: '1rem' }}>
                            this.state.renderView && (
                              <>
                                {this.props.screen === "billing" ||
                                  this.props.screen === "assetOwner" ||
                                  this.props.screen === "subscriptions" ||
                                  this.props.screen === "orders" ||
                                  this.props.screen === "quotes" ||
                                  this.props.screen === "addonsManagement" ||
                                  this.props.screen === "settlementView" ? (
                                  <>
                                    {this.props.screen === "billing" && (
                                      <>
                                        <BillingAccount
                                          downloadInvoicePdf={
                                            this.downloadInvoicePdf
                                          }
                                          data={this.state.billingData}
                                          isChild={
                                            this.state.showChildItem
                                              ? true
                                              : false
                                          }
                                          selectedCustomerPartyId={
                                            this.state.showChildItem
                                              ? this.state.childItemDetails
                                                .partyId
                                              : this.state.customerDetails
                                                .partyId
                                          }
                                          customerDetails={
                                            this.state.customerDetails
                                          }
                                          childItemDetails={
                                            this.state.childItemDetails
                                          }
                                          renderBillingView={
                                            this.state.renderBillingView
                                          }
                                          invoiceHistoryData={
                                            this.state.invoiceHistoryData
                                          }
                                          invoiceHistoryPage={
                                            this.state.invoiceHistoryPage
                                          }
                                          invoiceHistoryPerPage={
                                            this.state.invoiceHistoryPerPage
                                          }
                                          onInvoiceHistoryPageChange={
                                            this.onInvoiceHistoryPageChange
                                          }
                                          updateInvoiceSorting={
                                            this.updateInvoiceSorting
                                          }
                                          updateInvoiceHistoryPerPageRows={
                                            this.updateInvoiceHistoryPerPageRows
                                          }
                                          totalInvoiceCount={
                                            this.state.totalInvoiceCount
                                          }
                                          searchingBillingData={
                                            this.state.searchingBillingData
                                          }
                                          initiateInvoicePayment={
                                            this.initiateInvoicePayment
                                          }
                                          subscriptionAdjustments={
                                            this.state.subscriptionAdjustments
                                          }
                                          totalOrderCount={
                                            this.state.totalOrderCount
                                          }
                                          subscriptionPerPage={
                                            this.state.subsHistoryPerPage
                                          }
                                          subscriptionRowsPerPage={
                                            this.state.subscriptionRowsPerPage
                                          }
                                          handleSubscriptionChangeRowsPerPage={
                                            this
                                              .handleSubscriptionChangeRowsPerPage
                                          }
                                          handleSubscriptionChangePage={
                                            this.handleSubscriptionChangePage
                                          }
                                          getSubscriptionAdjustments={
                                            this.getSubscriptionAdjustments
                                          }
                                          setErrorMessage={
                                            this.props.setErrorMessage
                                          }
                                          toggleAdjustmentInfo={
                                            this.toggleAdjustmentInfo
                                          }
                                          userRoles={this.props.userRoles}
                                          onRef={(ref) =>
                                            (this.billingRef = ref)
                                          }
                                          themeColor={
                                            this.props.tenantData.color
                                          }
                                          menuPaths={this.props.menuPaths}
                                          isMobile={this.props.isMobile}
                                          getUpcomingInvoices={this.getUpcomingInvoices}
                                        />
                                      </>
                                    )}

                                    {this.props.screen === "assetOwner" && (
                                      <>
                                        <AssetOwnershipTable
                                          list={this.state.assetData}
                                          listProxy={this.state.assetDataProxy}
                                          isChild={
                                            this.state.showChildItem
                                              ? true
                                              : false
                                          }
                                          customerDetails={
                                            this.state.customerDetails
                                          }
                                          childItemDetails={
                                            this.state.childItemDetails
                                          }
                                          assetDataPage={
                                            this.state.assetDataPage
                                          }
                                          assetDataPerpage={
                                            this.state.assetDataPerpage
                                          }
                                          tenantId={this.state.tenant}
                                          assetDataPageChange={
                                            this.assetDataPageChange
                                          }
                                          assetDataRowsPerPageChange={
                                            this.assetDataRowsPerPageChange
                                          }
                                          totalAssetCount={
                                            this.state.totalAssetCount
                                          }
                                          serialNumber={this.state.serialNumber}
                                          changeSearialNumber={
                                            this.onChangeSerialNumber
                                          }
                                          clearAssetDataSearch={
                                            this.clearAssetDataSearch
                                          }
                                          searchAssetData={this.searchAssetData}
                                          onAssetSearchKeyDown={
                                            this.onAssetSearchKeyDown
                                          }
                                          openAssetData={this.openAssetData}
                                          isMobile={this.props.isMobile}
                                        />
                                      </>
                                    )}

                                    {this.props.screen === "subscriptions" && (
                                      <>
                                        <SubscriptionsTable
                                          totalSubscriptionCount={
                                            this.state.totalSubscriptionCount
                                          }
                                          subsHistoryPage={
                                            this.state.subsHistoryPage
                                          }
                                          subsHistoryPerPage={
                                            this.state.subsHistoryPerPage
                                          }
                                          onSubsHistoryPageChange={
                                            this.onSubsHistoryPageChange
                                          }
                                          updateSubsHistoryPerPageRows={
                                            this.updateSubsHistoryPerPageRows
                                          }
                                          updateSubsSorting={
                                            this.updateSubsSorting
                                          }
                                          subscriptions={
                                            this.state.subscriptionData
                                          }
                                          isChild={
                                            this.state.showChildItem
                                              ? true
                                              : false
                                          }
                                          customerDetails={
                                            this.state.customerDetails
                                          }
                                          childItemDetails={
                                            this.state.childItemDetails
                                          }
                                          openSubscription={
                                            this.openSubscription
                                          }
                                          tenantId={this.state.tenant}
                                          getCustomerSubscriptions={
                                            this.getCustomerSubscriptions
                                          }
                                          searchingSubscriptions={
                                            this.state.searchingSubscriptions
                                          }
                                          changeRoute={this.props.changeRoute}
                                          sortBySubs={this.state.sortBySubs}
                                          sortOrderSubs={
                                            this.state.sortOrderSubs
                                          }
                                          subsFilters={this.state.subsFilters}
                                          clearSubsTableSearch={
                                            this.clearSubsTableSearch
                                          }
                                          filterSubsTable={this.filterSubsTable}
                                          onChangeSubsInput={
                                            this.onChangeSubsInput
                                          }
                                          onSearchKeyDownSubsInput={
                                            this.onSearchKeyDownSubsInput
                                          }
                                          goToQuote={this.props.goToQuote}
                                          expandItemHistory={
                                            this.expandItemHistory
                                          }
                                          isMobile={this.props.isMobile}
                                          handleSearchIdentifierChange={this.handleSearchIdentifierChange}
                                          searchIdentifierValues={this.state.searchIdentifierValues}
                                        />
                                      </>
                                    )}
                                    {this.props.screen ===
                                      "addonsManagement" && (
                                        <>
                                          <AddonsTable
                                            data={this.state.addonsData}
                                            isChild={
                                              this.state.showChildItem
                                                ? true
                                                : false
                                            }
                                            customerDetails={
                                              this.state.customerDetails
                                            }
                                            childItemDetails={
                                              this.state.childItemDetails
                                            }
                                            tenantId={this.state.tenant}
                                            getCustomerAddons={
                                              this.getCustomerAddons
                                            }
                                            changeRoute={this.props.changeRoute}
                                            sortBy={this.state.sortByAddons}
                                            sortOrder={this.state.sortOrderAddons}
                                            updateSorting={
                                              this.updateAddonsSorting
                                            }
                                            filters={this.state.addonsFilters}
                                            clearAddonsFilters={
                                              this.clearAddonsFilters
                                            }
                                            filterAddonsTable={
                                              this.filterAddonsTable
                                            }
                                            onChangeAddonsFilters={
                                              this.onChangeAddonsFilters
                                            }
                                            onAddonsSearchKeyDownInput={
                                              this.onAddonsSearchKeyDownInput
                                            }
                                            searchingAddons={
                                              this.state.searchingAddons
                                            }
                                            totalAddonsCount={
                                              this.state.totalAddonsCount
                                            }
                                            addonsRowsPerPage={
                                              this.state.addonsRowsPerPage
                                            }
                                            addonsPage={this.state.addonsPage}
                                            addonsStartRecord={
                                              this.state.addonsStartRecord
                                            }
                                            updateAddonsRowsPerPage={
                                              this.updateAddonsRowsPerPage
                                            }
                                            changeAddonsPage={
                                              this.changeAddonsPage
                                            }
                                            goToQuote={this.props.goToQuote}
                                            openAddons={this.openAddons}
                                            isMobile={this.props.isMobile}
                                          />
                                        </>
                                      )}
                                    {this.props.screen === "orders" && (
                                      <>
                                        {!this.state.searchingOrders && (
                                          <>
                                            <Grid
                                              container
                                              spacing={2}
                                              style={{
                                                padding: "1rem 1rem 0rem 1rem",
                                              }}
                                            >
                                              <Grid
                                                item
                                                size={{
                                                  xs: 9,
                                                }}
                                              >
                                                {this.state.customerDetails &&
                                                  this.state.customerDetails
                                                    .accountName && (
                                                    <h3
                                                      style={{ marginTop: 0 }}
                                                    >
                                                      {/* {t("INVOICE_HISTORY")}:  */}
                                                      {
                                                        this.state
                                                          .customerDetails
                                                          .accountName
                                                      }{" "}
                                                      {this.props
                                                        .providerType ===
                                                        "SALES_CHNL_PROVIDER" &&
                                                        `(${this.state.customerDetails.ban})`}
                                                    </h3>
                                                  )}
                                              </Grid>
                                            </Grid>

                                            <div
                                              className={classes.searchOuterDiv}
                                              style={{
                                                marginBottom: ".5rem",
                                                width: "100%",
                                                alignItems: "center",
                                                paddingLeft: "1rem",
                                                paddingRight: "1rem",
                                              }}
                                            >
                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                              >
                                                <Input
                                                  size={"small"}
                                                  variant={"outlined"}
                                                  placeholder={t("ORDER_ID")}
                                                  value={
                                                    this.state.ordersFilters
                                                      .orderId
                                                  }
                                                  name={"orderId"}
                                                  onChange={(e) => {
                                                    this.onChangeOrdersFilters(
                                                      e,
                                                    );
                                                  }}
                                                  divClass={classes.inputClass}
                                                  onKeyDown={(e) => {
                                                    this.onOrdersSearchKeyDownInput(
                                                      e,
                                                    );
                                                  }}
                                                />
                                              </div>
                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                                style={{ maxWidth: "250px" }}
                                              >
                                                <FormControl>
                                                  <Select
                                                    native
                                                    style={{ width: "245px" }}
                                                    variant={"outlined"}
                                                    // name='orderStatus'
                                                    inputProps={{
                                                      name: "orderStatus",
                                                      id: "outlined-native-orderStatus",
                                                    }}
                                                    value={
                                                      this.state.ordersFilters
                                                        .orderStatus
                                                    }
                                                    onChange={(e) => {
                                                      this.onChangeOrdersFilters(
                                                        e,
                                                      );
                                                    }}
                                                    onKeyDown={(e) => {
                                                      this.onOrdersSearchKeyDownInput(
                                                        e,
                                                      );
                                                    }}
                                                    selectClass={
                                                      classes.inputClass +
                                                      " " +
                                                      classes.statusSelectBg +
                                                      " " +
                                                      classes.searchOrderSelect
                                                    }
                                                  >
                                                    <option
                                                      value={"All Orders"}
                                                    >
                                                      All Orders
                                                    </option>
                                                    {this.props.statusList &&
                                                      this.props.statusList
                                                        .sort((a, b) =>
                                                          a.value.localeCompare(
                                                            b.value,
                                                          ),
                                                        )
                                                        .map((a) => (
                                                          <option
                                                            key={a.value}
                                                            value={a.value}
                                                          >
                                                            {a.value}
                                                          </option>
                                                        ))}
                                                  </Select>
                                                </FormControl>
                                              </div>
                                              <div
                                                className={
                                                  classes.searchOrderLabelOuter
                                                }
                                                style={{ marginTop: ".25rem" }}
                                              >
                                                <div
                                                  className={
                                                    classes.searchOrderLabelInner
                                                  }
                                                >
                                                  <Tooltip title={t("SEARCH")}>
                                                    <IconButton
                                                      className="iconButtonSecondary"
                                                      onClick={
                                                        this.filterOrdersTable
                                                      }
                                                    >
                                                      <SearchIcon />
                                                    </IconButton>
                                                  </Tooltip>{" "}
                                                  &nbsp;
                                                  <Tooltip title={t("CLEAR")}>
                                                    <IconButton
                                                      className="iconButtonSecondary"
                                                      onClick={
                                                        this.clearOrdersFilters
                                                      }
                                                    >
                                                      <ClearIcon />
                                                    </IconButton>
                                                  </Tooltip>{" "}
                                                  &nbsp;
                                                  <Tooltip title={t("REFRESH")}>
                                                    <IconButton
                                                      className="iconButtonSecondary"
                                                      onClick={
                                                        this
                                                          .refreshCustomerOrdersTable
                                                      }
                                                    >
                                                      <RefreshIcon />
                                                    </IconButton>
                                                  </Tooltip>
                                                </div>
                                              </div>
                                            </div>
                                            <Card
                                              variant="outlined"
                                              style={{
                                                borderRadius: "8px",
                                                marginBottom: "40px",
                                                marginLeft: "1rem",
                                                marginRight: "1rem",
                                              }}
                                            >
                                              <OrderTable
                                                view="ordersByCustomer"
                                                orderId={this.props.orderId}
                                                orders={this.state.ordersData}
                                                openResendDialog={
                                                  this.props.openResendDialog
                                                }
                                                rowsPerPage={
                                                  this.state.ordersRowsPerPage
                                                }
                                                totalOrderCount={
                                                  this.state.totalOrdersCount
                                                }
                                                page={this.state.ordersPage}
                                                sortBy={this.state.sortByOrders}
                                                sortOrder={
                                                  this.state.sortOrderOrders
                                                }
                                                startRecord={
                                                  this.state.ordersStartRecord
                                                }
                                                updateSorting={
                                                  this.updateOrdersSorting
                                                }
                                                handleChangePage={
                                                  this.changeOrdersPage
                                                }
                                                handleChangeRowsPerPage={
                                                  this.updateOrdersRowsPerPage
                                                }
                                                controls={this.props.controls}
                                                loggedInUserType={
                                                  this.props.loggedInUserType
                                                }
                                                tenantId={this.state.tenant}
                                                providerType={
                                                  this.props.providerType
                                                }
                                                // showLoading={this.props.showLoading}
                                                isMobile={this.props.isMobile}
                                              />
                                            </Card>
                                          </>
                                        )}
                                      </>
                                    )}
                                    {this.props.screen === "quotes" && (
                                      <>
                                        {!this.state.searchingQuotes && (
                                          <>
                                            <Grid
                                              container
                                              spacing={2}
                                              style={{
                                                padding: "1rem 1rem 0rem 1rem",
                                              }}
                                            >
                                              <Grid
                                                item
                                                size={{
                                                  xs: 9,
                                                }}
                                              >
                                                {this.state.customerDetails &&
                                                  this.state.customerDetails
                                                    .accountName && (
                                                    <h3
                                                      style={{ marginTop: 0 }}
                                                    >
                                                      {/* {t("INVOICE_HISTORY")}:  */}
                                                      {
                                                        this.state
                                                          .customerDetails
                                                          .accountName
                                                      }{" "}
                                                      (
                                                      {
                                                        this.state
                                                          .customerDetails.ban
                                                      }
                                                      )
                                                    </h3>
                                                  )}
                                              </Grid>
                                            </Grid>

                                            <div
                                              className={classes.searchOuterDiv}
                                              style={{
                                                marginBottom: ".5rem",
                                                width: "100%",
                                                alignItems: "center",
                                                paddingLeft: "1rem",
                                                paddingRight: "1rem",
                                              }}
                                            >
                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                              >
                                                <Input
                                                  size={"small"}
                                                  variant={"outlined"}
                                                  placeholder={t("QUOTE_ID")}
                                                  value={
                                                    this.state.quotesFilters
                                                      .quoteId
                                                  }
                                                  name={"quoteId"}
                                                  onChange={(e) => {
                                                    this.onChangeQuotesFilters(
                                                      e,
                                                    );
                                                  }}
                                                  divClass={classes.inputClass}
                                                  onKeyDown={(e) => {
                                                    this.onQuotesSearchKeyDownInput(
                                                      e,
                                                    );
                                                  }}
                                                />
                                              </div>

                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                              >
                                                <FormControl
                                                  variant="outlined"
                                                  className="custom-select-input"
                                                  size={"small"}
                                                >
                                                  <InputLabel htmlFor="outlined-native-quoteStatus">
                                                    {t("STATUS")}
                                                  </InputLabel>
                                                  <Select
                                                    native
                                                    label="STATUS "
                                                    value={
                                                      this.state.quotesFilters
                                                        .quoteStatus
                                                    }
                                                    onChange={(e) => {
                                                      this.onChangeQuotesFilters(
                                                        e,
                                                      );
                                                    }}
                                                    inputProps={{
                                                      name: "quoteStatus",
                                                      id: "outlined-native-quoteStatus",
                                                    }}
                                                    onKeyDown={(e) => {
                                                      this.onQuotesSearchKeyDownInput(
                                                        e,
                                                      );
                                                    }}
                                                    style={{ width: "186px" }}
                                                  >
                                                    <option
                                                      value={"All Quotes"}
                                                    >
                                                      {t("ALL_QUOTES")}
                                                    </option>
                                                    {this.props.statusList &&
                                                      this.props.statusList.map(
                                                        (a) => (
                                                          <option
                                                            key={a.name}
                                                            value={a.name}
                                                          >
                                                            {a.value}
                                                          </option>
                                                        ),
                                                      )}
                                                  </Select>
                                                </FormControl>
                                              </div>
                                              <div
                                                className={
                                                  classes.searchInputDiv
                                                }
                                              >
                                                <FormControl
                                                  variant="outlined"
                                                  className="custom-select-input"
                                                  size={"small"}
                                                >
                                                  <InputLabel htmlFor="outlined-native-type">
                                                    {t("TYPE")}
                                                  </InputLabel>
                                                  <Select
                                                    native
                                                    label="TYPE "
                                                    value={
                                                      this.state.quotesFilters
                                                        .quoteType
                                                    }
                                                    onChange={(e) => {
                                                      this.onChangeQuotesFilters(
                                                        e,
                                                      );
                                                    }}
                                                    inputProps={{
                                                      name: "quoteType",
                                                      id: "outlined-native-type",
                                                    }}
                                                    onKeyDown={(e) => {
                                                      this.onQuotesSearchKeyDownInput(
                                                        e,
                                                      );
                                                    }}
                                                    style={{ width: "186px" }}
                                                  >
                                                    {this.props.typeList &&
                                                      this.props.typeList.map(
                                                        (a) => (
                                                          <option
                                                            key={a.value}
                                                            value={a.value}
                                                          >
                                                            {t(a.name)}
                                                          </option>
                                                        ),
                                                      )}
                                                  </Select>
                                                </FormControl>
                                              </div>

                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }}
                                              >
                                                <Tooltip title={t("SEARCH")}>
                                                  <IconButton
                                                    className="iconButtonSecondary"
                                                    onClick={
                                                      this.filterQuotesTable
                                                    }
                                                  >
                                                    <SearchIcon />
                                                  </IconButton>
                                                </Tooltip>{" "}
                                                &nbsp;
                                                <Tooltip title={t("CLEAR")}>
                                                  <IconButton
                                                    className="iconButtonSecondary"
                                                    onClick={
                                                      this.clearQuotesFilters
                                                    }
                                                  >
                                                    <ClearIcon />
                                                  </IconButton>
                                                </Tooltip>{" "}
                                                &nbsp;
                                                <Tooltip title={t("REFRESH")}>
                                                  <IconButton
                                                    className="iconButtonSecondary"
                                                    onClick={
                                                      this
                                                        .refreshCustomerQuotesTable
                                                    }
                                                  >
                                                    <RefreshIcon />
                                                  </IconButton>
                                                </Tooltip>
                                              </div>
                                            </div>
                                            <Card
                                              variant="outlined"
                                              style={{
                                                borderRadius: "8px",
                                                marginBottom: "40px",
                                                marginLeft: "1rem",
                                                marginRight: "1rem",
                                              }}
                                            >
                                              <QuoteTable
                                                view="quotesByCustomer"
                                                // customerName={this.state.customerName}
                                                // customerBAN={this.state.customerBAN}
                                                quotes={this.state.quotesData}
                                                openResendDialog={
                                                  this.props.openResendDialog
                                                }
                                                rowsPerPage={
                                                  this.state.quotesRowsPerPage
                                                }
                                                totalQuoteCount={
                                                  this.state.totalQuotesCount
                                                }
                                                page={this.state.quotesPage}
                                                sortBy={this.state.sortByQuotes}
                                                sortOrder={
                                                  this.state.sortOrderQuotes
                                                }
                                                updateSorting={
                                                  this.updateQuotesSorting
                                                }
                                                handleChangePage={
                                                  this.changeQuotesPage
                                                }
                                                handleChangeRowsPerPage={
                                                  this.updateQuotesRowsPerPage
                                                }
                                                controls={this.props.controls}
                                                loggedInUserType={
                                                  this.props.loggedInUserType
                                                }
                                                tenantId={this.state.tenant}
                                                providerType={
                                                  this.props.providerType
                                                }
                                                isMobile={this.props.isMobile}
                                              // showLoading={this.state.showLoading}
                                              />
                                            </Card>
                                          </>
                                        )}
                                      </>
                                    )}
                                    {this.props.screen === "settlementView" && (
                                      // <SettlementTable
                                      //   list={this.state.settlementList}
                                      //   rowsPerPage={this.state.settlementRowsPerPage}
                                      //   totalSettlementCount={this.state.totalSettlementCount}
                                      //   page={this.state.settlementPage}
                                      //   handleChangePage={this.handleChangePage}
                                      //   handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                                      //   sortBy={this.state.settlemtnSortBy}
                                      //   sortOrder={this.state.settlementSortOrder}
                                      //   updateSorting={this.updateSorting}
                                      //   // convertDate={this.convertDate}
                                      //   isValidDate={this.isValidDate}
                                      //   providerType={this.props.providerType}
                                      //   tenantRoles={this.props.tenantRoles}
                                      // />
                                      <>
                                        <Grid
                                          container
                                          spacing={2}
                                          style={{
                                            padding:
                                              "1rem 1rem 0rem 1rem",
                                          }}
                                        >
                                          <Grid
                                            item
                                            size={{
                                              xs: 9,
                                            }}
                                          >
                                            {this.state
                                              .customerDetails &&
                                              this.state
                                                .customerDetails
                                                .accountName && (
                                                <h3
                                                  style={{
                                                    marginTop: 0,
                                                  }}
                                                >
                                                  {/* {t("INVOICE_HISTORY")}:  */}
                                                  {
                                                    this.state
                                                      .customerDetails
                                                      .accountName
                                                  }{" "}
                                                  {this.props
                                                    .providerType ===
                                                    "SALES_CHNL_PROVIDER" &&
                                                    `(${this.state.customerDetails.ban})`}
                                                </h3>
                                              )}
                                          </Grid>
                                        </Grid>

                                        <Paper
                                          className={"tablePaper"}
                                          elevation={0}
                                          style={{ background: "transparent" }}
                                        >
                                          <div className={classes.searchOuterDiv}>
                                            {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                                              <div>
                                                <Input
                                                  size={"small"}
                                                  variant={"outlined"}
                                                  placeholder={t("PROVIDER_NAME")}
                                                  value={this.state.solutionProviderName}
                                                  name={"solutionProviderName"}
                                                  onChange={(e) => {
                                                    this.onSettlementChange(e);
                                                  }}
                                                  divClass={classes.inputClass}
                                                  onKeyDown={(e) => {
                                                    this.onSettlementSearchKeyDown(e);
                                                  }}
                                                />
                                              </div>
                                            )}
                                            <div>
                                              <Input
                                                size={"small"}
                                                variant={"outlined"}
                                                placeholder={t("PRODUCT_NAME")}
                                                value={this.state.itemDescription}
                                                name={"itemDescription"}
                                                onChange={(e) => {
                                                  this.onSettlementChange(e);
                                                }}
                                                divClass={classes.inputClass}
                                                onKeyDown={(e) => {
                                                  this.onSettlementSearchKeyDown(e);
                                                }}
                                              />
                                            </div>
                                            <div>
                                              <Input
                                                size={"small"}
                                                variant={"outlined"}
                                                placeholder={t("ORDER_ID")}
                                                value={this.state.settlementOrderId}
                                                name={"settlementOrderId"}
                                                onChange={(e) => {
                                                  this.onSettlementChange(e);
                                                }}
                                                divClass={classes.ordInputClass}
                                                onKeyDown={(e) => {
                                                  this.onSettlementSearchKeyDown(e);
                                                }}
                                              />
                                            </div>
                                            <div>
                                              <TextField
                                                name="fromDate"
                                                id="fromDate"
                                                type="date"
                                                value={this.state.fromDate}
                                                label={t("FROM_DATE")}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                variant={"outlined"}
                                                size={"small"}
                                                onChange={(e) => {
                                                  this.onSettlementChange(e);
                                                }}
                                                inputProps={{ max: this.state.today, format: "MM/dd/yyyy" }}
                                                onKeyDown={(e) => {
                                                  this.onSettlementSearchKeyDown(e);
                                                }}
                                              />
                                            </div>

                                            <div>
                                              <TextField
                                                name="toDate"
                                                id="toDate"
                                                type="date"
                                                value={this.state.toDate}
                                                label={t("TO_DATE")}
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                variant={"outlined"}
                                                size={"small"}
                                                onChange={(e) => {
                                                  this.onSettlementChange(e);
                                                }}
                                                inputProps={{
                                                  max: this.state.today,
                                                  min: this.state.fromDate,
                                                  format: "MM/dd/yyyy",
                                                }}
                                                onKeyDown={(e) => {
                                                  this.onSettlementSearchKeyDown(e);
                                                }}
                                              />
                                            </div>
                                            <div style={{ display: "flex", alignItems: "flex-start" }}>
                                              <Tooltip title={t("SEARCH")}>
                                                <IconButton
                                                  className="iconButtonSecondary"
                                                  onClick={this.filterSettlementTable}
                                                >
                                                  <SearchIcon />
                                                </IconButton>
                                              </Tooltip>{" "}
                                              &nbsp;
                                              <Tooltip title={t("CLEAR")}>
                                                <IconButton
                                                  className="iconButtonSecondary"
                                                  onClick={this.clearSettlementsFilters}
                                                >
                                                  <ClearIcon />
                                                </IconButton>
                                              </Tooltip>{" "}
                                              &nbsp;
                                              <Tooltip title={t("REFRESH")}>
                                                <IconButton
                                                  className="iconButtonSecondary"
                                                  onClick={this.clearSettlementsFilters}
                                                >
                                                  <RefreshIcon />
                                                </IconButton>
                                              </Tooltip>
                                            </div>
                                          </div>

                                          <SettlementTable
                                            list={this.state.settlementList}
                                            rowsPerPage={this.state.settlementRowsPerPage}
                                            totalSettlementCount={this.state.totalSettlementCount}
                                            page={this.state.settlementPage}
                                            handleChangePage={this.handleSettlementChangePage}
                                            handleChangeRowsPerPage={this.handleSettlementChangeRowsPerPage}
                                            sortBy={this.state.settlemtnSortBy}
                                            sortOrder={this.state.settlementSortOrder}
                                            updateSorting={this.updateSettlementSorting}
                                            // convertDate={this.convertDate}
                                            isValidDate={this.isValidDate}
                                            providerType={this.props.providerType}
                                            tenantRoles={this.props.tenantRoles}
                                            screen={'customerView'}
                                          />
                                        </Paper>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {this.state.customerList.length === 0 ? (
                                      <div></div>
                                    ) : (
                                      this.state.display && (
                                        <Profile
                                          screen={
                                            this.props.screen === "checkout"
                                              ? this.props.screen
                                              : "manageCustomer"
                                          }
                                          customerDetails={
                                            this.state.customerDetails
                                          }
                                          childItemDetails={
                                            this.state.childItemDetails
                                          }
                                          selectedCustomerPartyId={
                                            this.state.showChildItem
                                              ? this.state.childItemDetails
                                                .partyId
                                              : this.state.customerDetails
                                                .partyId
                                          }
                                          addChildItem={this.addChildItem}
                                          editChildItem={this.editChildItem}
                                          isChild={
                                            this.state.showChildItem
                                              ? true
                                              : false
                                          }
                                          selectedPaymentMethod={
                                            this.props.selectedPaymentMethod
                                          }
                                          getCustomersHierarchy={
                                            this.getCustomersHierarchy
                                          }
                                          back={this.props.back}
                                          stage={this.props.stage}
                                          goNext={this.goNext}
                                          subScreen={this.props.subScreen}
                                          closeDialog={this.props.closeDialog}
                                          parentTenantId={this.state.tenant}
                                          manageCustomerRequired={
                                            this.state.manageCustomerRequired
                                          }
                                          isTaskMode={this.state.isTaskMode}
                                          newLeadOrCustomer={
                                            this.state.newLeadOrCustomer
                                          }
                                          promoteLead={this.promoteLead}
                                          sectorsList={this.props.sectorsList}
                                          isMobile={this.props.isMobile}
                                        />
                                      )
                                    )}
                                  </>
                                )}
                              </>
                            )
                          ))

                          //  </Grid>
                        )}
                      </>
                    </Grid>
                  </div>
                </div>
              )}
            </>
          )}

          {this.state.childItemDialog && (
            <AddChildItemDialog
              open={this.state.childItemDialog}
              close={this.closeChildItemDialog}
              closeEdit={this.closeEditChildItemDialog}
              editData={this.state.selectedItemToEdit}
              err={this.state.err}
              isMobile={this.props.isMobile}
            />
          )}
          {this.state.showBanDialog && (
            <Dialog
              maxWidth={"xs"}
              PaperComponent={this.draggableDialogPaper}
              fullWidth={true}
              open={this.state.showBanDialog}
              aria-labelledby="delete-dialog-title"
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {t("PROMOTE_TO_CUSTOMER")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onClick={() => this.closeBanDialog()}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers style={{ height: "10rem" }}>
                <div style={{ marginBottom: "1rem" }}>
                  {/* {this.state.customerDetails.accountName} {t('BAN_REQUIRED')} */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.custCodeAvailable}
                        onChange={this.handleSwitchChange}
                        name="custCodeAvailable"
                      />
                    }
                    label={this.props.t("CUST_CODE_AVAILABLE")}
                  />
                </div>
                {this.state.custCodeAvailable && (
                  <Input
                    size={"small"}
                    name={"custCodeValue"}
                    variant={"outlined"}
                    placeholder={this.props.t("CUSTOMER_BAN") + " *"}
                    value={this.state.custCodeValue}
                    onChange={this.changeCustomerBan}
                    helperText={
                      this.props.t("CUSTOMER_CODE_PREFIX_ERROR") +
                      " " +
                      this.state.selectedToPromote.tempCustCodePrefix
                    }
                  />
                )}
              </DialogContent>
              <DialogActions>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      float: "left",
                      fontWeight: "bold",
                      color: "#f44336",
                    }}
                  >
                    {this.state.showCustomerBanError &&
                      this.props.t("CUSTOMER_CODE_PREFIX_ERROR") +
                      " " +
                      this.state.selectedToPromote.tempCustCodePrefix}
                  </div>
                  <div style={{ float: "right" }}>
                    <Button
                      onClick={() => {
                        if (this.state.custCodeAvailable) {
                          if (
                            this.state.custCodeValue &&
                            this.state.custCodeValue.trim()
                          ) {
                            this.createCustomerBan();
                          } else {
                            // Show error that BAN is required when switch is on
                            this.setState({ showCustomerBanError: true });
                          }
                        } else {
                          this.createCustomerWithoutBan();
                        }
                      }}
                      color="primary"
                    >
                      {t("SUBMIT")}
                    </Button>
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>
              </DialogActions>
            </Dialog>
          )}

          {this.state.initiatePaymentDialog && (
            <Dialog
              disableScrollLock={true}
              fullWidth={true}
              PaperComponent={this.draggableDialogPaper}
              maxWidth={"sm"}
              open={this.state.initiatePaymentDialog}
              aria-labelledby="customized-dialog-title"
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {t("CHOOSE_A_PAYMENT_METHOD")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => this.closePaymentDialog(false)}
                      onClick={() => this.closePaymentDialog(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <PaymentDetails
                  tabValue="3"
                  screen="invoicePayment"
                  eftAccountList={this.state.eftAccountList}
                  creditCardList={this.state.creditCardList}
                  chooseExistingCustomerDetail={
                    this.chooseExistingPaymentMethod
                  }
                  invoiceId={this.state.invoiceId}
                  invoiceOrderId={this.state.invoiceOrderId}
                  billingAddressList={this.state.billingAddressList}
                  customerDetails={this.state.customerDetails}
                  closePaymentDialog={this.closePaymentDialog}
                  invoicePayment={this.state.invoicePayment}
                />
              </DialogContent>
              {/* <DialogActions>
                            <Button onClick={event => this.closePaymentDialog(false)} color="primary">{t('CANCEL')}</Button>
                        </DialogActions> */}
            </Dialog>
          )}

          {/* move item confirmation */}
          {this.state.showMoveItemDialog && (
            <Dialog
              disableScrollLock={true}
              maxWidth={"sm"}
              PaperComponent={this.draggableDialogPaper}
              fullWidth={true}
              open={this.state.showMoveItemDialog}
              aria-labelledby="delete-dialog-title"
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {t("MOVE_ITEM")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => this.moveItem(false)}
                      onClick={() => this.moveItem(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText>
                  {t("MOVE_ITEM_CONFIRMATION", { moveItemMessageText })}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(event) => this.moveItem(false)}
                  color="primary"
                >
                  {t("NO")}
                </Button>
                <Button
                  onClick={(event) => this.moveItem(true)}
                  color="primary"
                >
                  {t("YES")}
                </Button>
              </DialogActions>
            </Dialog>
          )}

          {this.state.showFileData && (
            <Base64ViewerDialog
              base64={this.state.selectedFileToView.base64}
              mimeType={this.state.selectedFileToView.mimeType}
              title={this.state.selectedFileToView.name}
              open={this.state.showFileData}
              onClose={() => {
                this.setState({ selectedFileToView: {}, showFileData: false });
              }}
            />
          )}

          <Loader loading={this.state.loading} />
        </div>
      </>
    );
  }
}

export const theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*": {
          margin: 0,
          padding: 0,
        },
        "html, body, #root": {
          height: "100%",
        },
        ul: {
          listStyle: "none",
        },
      },
    },
    MuiSvgIcon: {
      root: { verticalAlign: "middle" },
    },
  },
});

// const jssStyles = {

//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     }
// }

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    loggedInUserType: state.auth.userLoginType,
    ecommerceCustData: state.auth.ecommerceCustData,
    solutionList: state.cart.solutions,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    menuPaths: state.auth.menuPaths,
    defaultCountry: state.auth.defaultCountry,
    showMyCustomersEnabled: state.auth.showMyCustomers,
    sideMenu: state.auth.sideMenu,
    tenantRoles: state.auth.tenantRoles,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ManageCustomersHierarchy)));
